<template>
<div class="app has-header">
    <div class="header main">
        <div class="align-left">
            <buttonc v-show="false" type="rectangle" icon="fa-filter" v-tooltip="$t('global.ui.viewOptions')" @click="OpenDisplayMenuDetails"/>
        </div>
        <div class="align-middle">
            <headerbuttonstack :state="headerButtons"/>
        </div>
        <div class="align-right">
               <headerbuttonstack :state="sideButtons"/>
            </div>

    </div>
    <div v-if="loading" class="loading-md bg">
        <i class="fas fa-spinner"></i>
        <br/>
        <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
            {{ loadingText }}
        </div>
    </div>
    <div class="scrollbar-container">
    <b-row v-if="!loading">
        <b-col md="auto" class="employee-list-col col-no-margin" v-if="!loading" v-bind:class="{disabled: creatingNewEmployee}">

            <b-row><!--  v-if="showEmployeeNameFilter"> -->
                <b-col>
                    <div class="employee-name-filter">
                        <div class="name-filter" style="transition: .2s">
                            <i class="fas fa-filter" role="button" @click="OpenDisplayMenuDetails"></i>
                            <i class="fas fa-search"></i>
                            <input v-model="nameFilter" />
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="data-grid employee-list" v-bind:class="{withfilter: showEmployeeNameFilter}" v-bind:style="{opacity: (loading ? '0' : '1'), border: employees.length < 10? '1px solid #cccccc' : ''}">
                        <div class="content" v-bind:style="{display: (loading ? 'none' : 'inline-block')}">
                            <grid ref="grid" :headerEnabled="false" :header="gridData.header" :data="dataFiltered" :OnSelect="ChangeEmployee" :OnSelectRow="ChangeEmployee">

                            </grid>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-col>

        <b-col md="auto" class="employee-col" v-if="!loading && !creatingNewEmployee" >
            <b-row style="margin:0px 10px 10px 10px;">
                <b-col class="col-no-margin employee-active">
                    <b-row style="height:255px;">
                        <b-col class="col-no-margin">
                            <div>
                                <img style="margin: 4px; width: 120px; height: 120px;" crossorigin="anonymous" id="employee-picture-img" :src="GetProfilePictureUrl(employee, 'large', true)"/>
                            </div>
                            <div v-bind:class="{disabled: creatingNewEmployee}" id="employee-picture" class="picture" style="cursor:pointer;" v-on:mouseover="showImageUploadCircle = true" v-on:mouseleave="showImageUploadCircle = false" v-bind:style="{background: GetProfilePictureUrl(employee, 'large'), opacity: (loading ? '0' : '1')}" v-on:click="UploadImage(false)">
                                <div class="inner-circle" v-if="(!employee.employeePicture || showImageUploadCircle) && !employee.dummy" style="cursor:pointer;">
                                    <i v-if="!employee.employeePicture" class="fas fa-plus"></i>
                                    <i v-else class="fas fa-edit"></i>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-no-margin">
                            <div class="firstName">
                                <div v-show="employeeWarnings.warnings.length > 0 && !creatingNewEmployee" class="alert-icon" v-bind:style="{'background': employeeWarnings.color}" @click="selectedPage = $helpers.isEmpty(employeeWarnings.link)? selectedPage : employeeWarnings.link">
                                    <i class="fas fa-exclamation" style="color:#fff;"/>
                                    <div class="tooltiptext">{{ employeeWarningsTooltipText() }}</div>
                                </div>
                                <tickertext myClass="firstNameLabel" :text="anonMode ? 'Anonymous' : employee.firstName"
                                            :constantScroll="true" :sizePx="240" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-no-margin">
                            <div class="lastName">
                                <tickertext myClass="lastNameLabel" :text="anonMode ? 'Anonymous' : employee.lastName"
                                            :constantScroll="true" :sizePx="240" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-no-margin">
                            <b-row class="split-flat">
                                <b-col>&nbsp;</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row style="margin-top: -24px;">
                        <b-col class="col-no-margin">
                            <div class="full">
                                <div class="third left">
                                    <div class="employee-info label">{{ $t('pages.employeeData.entranceDate') }}</div>
                                </div>
                                <div class="twothirds right">
                                    <div class="employee-info field">{{ employeeContractEntryDate(employee, false) }}</div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="employee.workEntryDate != null || !currentEntryDateEqualsFirstEntryDate(employee)" style="margin-top: -12px;">
                        <b-col class="col-no-margin">
                            <div class="full">
                                <div class="third left">
                                    <div class="employee-info label">{{ $t('pages.employeeData.initialEntranceDate') }}</div>
                                </div>
                                <div class="twothirds right">
                                    <div class="employee-info field">{{ employeeContractEntryDate(employee, true) }}</div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row style="margin-top: -12px;">
                        <b-col class="col-no-margin">
                            <div class="full">
                                <div class="third left">
                                    <div class="employee-info label">{{ $t('pages.employeeData.exitDate') }}</div>
                                </div>
                                <div class="twothirds right">
                                    <div class="employee-info field">{{ employeeContractExitDate(employee) }}</div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-no-margin">
                            <b-row class="split-flat">
                                <b-col>&nbsp;</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row style="margin-top: -16px;" v-if="!creatingNewEmployee">
                        <b-col class="col-no-margin">
                            <div class="full">
                                <b-button style="display: inline;" size="sm" pill :variant="!employee.active ? 'danger' : 'success'" @click="openEmployeeActivateDeactiveModal()" data-toggle="tooltip" data-placement="top" v-tooltip="employee.active ? $t('pages.employeeData.messages.deactivateEmployee') : $t('pages.employeeData.messages.activateEmployee')">
                                    <i v-if="!employee.active" class="fas fa-user-times"></i>
                                    <i v-else class="fas fa-user-check"></i>
                                    &nbsp;{{ employee.active ? $t('global.general.active') : $t('global.general.inactive') }}
                                </b-button>
                                <b-button style="display: inline; margin-left:8px; width: 31px;" size="sm" pill :variant="employee.accountId ? 'success' : 'warning'" @click="selectedPage = 'useraccount'" data-toggle="tooltip" data-placement="top" v-tooltip="employee.accountId ? $t('pages.employeeData.messages.accountExists') : $t('pages.employeeData.messages.createAccount')">
                                    <i class="fas fa-mobile-alt" style="margin: 2px 0px 0px 0.5px;"></i>
                                </b-button>
                                <b-button style="display: inline; margin-left:8px;" size="sm" pill variant="primary" @click="printEmployee(employee)" v-tooltip="this.$t('pages.employeeContext.personnelSheet') + ' PDF'">
                                    <i class="fas fa-file-pdf" style="margin-left: 0.5px;"></i>
                                </b-button>
                                <b-button style="display: inline; margin-left:8px;" size="sm" pill variant="warning" @click="printEmployeeCSV(employee)" v-tooltip="this.$t('pages.employeeContext.personnelSheet') + ' CSV'">
                                    <i class="fas fa-file-csv" style="margin-left: 0.5px;"></i>
                                </b-button>
                                <b-button style="display: inline; margin-left:8px;" size="sm" pill :variant="showDetails? 'outline-success':'success'" @click="showDetails = !showDetails">
                                    <i v-if="!showDetails" class="fas fa-chevron-down"></i>
                                    <i v-else class="fas fa-chevron-up"></i>
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="showDetails" :class="anonMode ? 'anonblur' : ''">
                        <b-col>
                            <b-row>
                                <b-col style="padding-top:12px;"></b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-no-margin">
                                    <div class="full">
                                        <div class="half left">
                                            <div class="employee-info label">{{ $t('pages.employeeData.dateOfBirth') }}</div>
                                        </div>
                                        <div class="half right">
                                            <div class="employee-info field">{{ dateOfBirth }}</div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="split-flat">
                                <b-col style="padding-top:4px;"></b-col>
                            </b-row>
                            <b-row v-if="!$helpers.isEmpty(employee.email)">
                                <b-col class="col-no-margin">
                                    <div class="full">
                                        <div class="third left">
                                            <div class="employee-info label">{{ $t('pages.employeeData.email') }}</div>
                                        </div>
                                        <div class="twothirds right">
                                            <div class="employee-info field">{{ employee.email }}</div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-if="!$helpers.isEmpty(employee.mobilephone)">
                                <b-col class="col-no-margin">
                                    <div class="full">
                                        <div class="third left">
                                            <div class="employee-info label">{{ $t('pages.employeeData.mobile') }}</div>
                                        </div>
                                        <div class="twothirds right">
                                            <div class="employee-info field">{{ employee.mobilephone }}</div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-if="!$helpers.isEmpty(employee.homephone)">
                                <b-col class="col-no-margin">
                                    <div class="full">
                                        <div class="third left">
                                            <div class="employee-info label">{{ $t('pages.employeeData.phone') }}</div>
                                        </div>
                                        <div class="twothirds right">
                                            <div class="employee-info field">{{ employee.homephone }}</div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="split-flat">
                                <b-col style="padding-top:4px;"></b-col>
                            </b-row>
                            <b-row v-if="!$helpers.isEmpty(employee.address)">
                                <b-col class="col-no-margin">
                                    <div class="full">
                                        <div class="third left">
                                            <div class="employee-info label">{{ $t('pages.employeeData.address') }}</div>
                                        </div>
                                        <div class="twothirds right">
                                            <div class="employee-info field">{{ employee.address }}</div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-if="!$helpers.isEmpty(employee.postalCode) || !$helpers.isEmpty(employee.city)">
                                <b-col class="col-no-margin">
                                    <div class="full">
                                        <div class="third left">
                                            <div class="employee-info label">{{ $t('pages.employeeData.zipCode') }}</div>
                                        </div>
                                        <div class="twothirds right">
                                            <div class="employee-info field">{{ employee.postalCode + ' ' + employee.city }}</div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                </b-col>
            </b-row>
            <b-row class="split-flat">
                <b-col style="padding-top:12px;"></b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-row style="margin: 0px 0px 4px 0px;">
                        <b-button style="width: 242px; margin: 0px 0px;" @click="selectEmployeePage('coredata')" squared :variant="selectedPage == 'coredata'? buttonVariants.coredata : 'outline-' + buttonVariants.coredata"><i class="fas fa-id-card" style="margin-top: 4px; float: left;"/>{{ $t('pages.employeeData.personalData') }}</b-button>
                    </b-row>
                    <b-row style="margin: 8px 0px 4px 0px;">
                        <b-button style="width: 242px; margin: 0px 0px;" @click="selectEmployeePage('contract')" squared :variant="selectedPage == 'contract'? buttonVariants.contract : 'outline-' + buttonVariants.contract"><i class="fas fa-file-contract" style="margin-top: 4px; float: left;"/>{{ $tc('pages.employeeData.contract') }}</b-button>
                    </b-row>
                    <b-row style="margin: 8px 0px 4px 0px;">
                        <b-button style="width: 242px; margin: 0px 0px;" @click="selectEmployeePage('documents')" squared :variant="selectedPage == 'documents'? buttonVariants.documents : 'outline-' + buttonVariants.documents"><i class="fas fa-folders" style="margin-top: 4px; float: left;"/>{{ $t('pages.employeeData.documents') }}</b-button>
                    </b-row>
                    <b-row style="margin: 8px 0px 4px 0px;" v-if="storeSettings && !storeSettings.simpleMode">
                        <b-button style="width: 242px; margin: 0px 0px;" @click="selectEmployeePage('plantype')" squared :variant="selectedPage == 'plantype'? buttonVariants.plantype : 'outline-' + buttonVariants.plantype"><i class="fas fa-sliders-h-square" style="margin-top: 4px; float: left;"/>{{ $tc('pages.employeeContext.planning', 1) }}</b-button>
                    </b-row>
                    <b-row v-if="!employee.metadata || employee.metadata.severity !== 'inactive'" style="margin: 8px 0px 4px 0px;">
                        <b-button style="width: 242px; margin: 0px 0px;" @click="selectEmployeePage('availabilityskills')" squared :variant="selectedPage == 'availabilityskills'? buttonVariants.availabilityskills : 'outline-' + buttonVariants.availabilityskills"><i class="fas fa-chalkboard-teacher" style="margin-top: 4px; float: left;"/>{{ $t('pages.employeeData.skills') }}</b-button>
                    </b-row>
                    <b-row v-if="!employee.metadata || employee.metadata.severity !== 'inactive'" style="margin: 8px 0px 4px 0px;">
                        <b-button style="width: 242px; margin: 0px 0px;" @click="selectEmployeePage('workingtimeaccount')" squared :variant="selectedPage == 'workingtimeaccount'? buttonVariants.workingtimeaccount : 'outline-' + buttonVariants.workingtimeaccount"><i class="fas fa-business-time" style="margin-top: 4px; float: left;"/>{{ $t('pages.employeeData.workTime') }}</b-button>
                    </b-row>

                    <b-row style="margin: 8px 0px 4px 0px;" v-if="employee && !employee.dummy">
                        <b-button style="width: 242px; margin: 0px 0px;" @click="selectEmployeePage('useraccount')" squared :variant="selectedPage == 'useraccount'? buttonVariants.useraccount : 'outline-' + buttonVariants.useraccount"><i class="fas fa-user" style="margin-top: 4px; float: left;"/>{{ $t('pages.employeeData.userAccount') }}</b-button>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>

        <b-col v-if="employees.length > 0 || creatingNewEmployee">
            <b-container fluid class="scrollbar-container-employeedata">
                <div class="page-settings w1400 data-input" v-bind:style="{opacity: (loading ? '0' : '1')}">
                    <b-row>
                        <b-col cols=12>
                            <div class="content">
                                <employeecoredata :class="anonMode ? 'anonblur' : ''" ref="compcoredata" v-show="selectedPage == 'coredata'" :uiData="uiData" :employee="employee" :spots="spots" :employeetypes="employeetypes" :employeerules="employeerules" :creatingNewEmployee="creatingNewEmployee" @employee-creation-cancelled="employeeCreationCancelled" @employee-edit-cancelled="editing = false;" @create-employee="startCandidateProcess" @updated="refresh" @coredata-updated="createCoredataChangePdf" @toggle-userosterchecks="toggleUseRosterChecks"></employeecoredata>
                                <employeecontract v-if="selectedPage == 'contract'" ref="employeecontract" :ccMandatory="storeSettings.collectiveContractRequired" :uiData="uiData" :employee="employee" :employeeContracts="employeeEmployeeContractMap[employee.id]" :contract="employeeContract" :pastContracts="pastEmployeeContracts" :futureContracts="futureEmployeeContracts" :contractFiles="contractFiles" :employeeTypes="employeetypes" :employeeRules="employeerules" :allowedContractMap="allowedContractMap" :collectiveContractMap="collectiveContractMap" @contract-added="employeeContractAdded" @file-added="contractFileAdded" @contract-approved="contractApproved" @contract-deleted="employeeContractDeleted" @contract-updated="employeeContractUpdated" @updated="refresh" @preview-pdf="previewPdfHook"></employeecontract>
                                <employeedocuments v-if="selectedPage == 'documents'" ref="documents" :documentListView="documentListView" :storeSettings="storeSettings" :employee="employee" :employeeId="employee.id" :contract="employeeContract" :displayedDocumentTypes="displayedDocumentTypes" @contract-deleted="contractFileDeleted" @document-upload-enabled="documentUploadEnabled" @filesUpdated="reloadEmployeeFiles"></employeedocuments>
                                <employeeplantype ref="compplantype" v-if="selectedPage == 'plantype'" :employee="employee" :contract="employeeContract" :employeetype="employeeTypeForEmployee(employee)" :employeerulesObj="employeeRulesForEmployee(employee,false)" :employeerules="employeeRulesForEmployee(employee)" :storeSettings="storeSettings" :employeetypes="employeetypes" :allEmployeeRules="employeerules" @employeetype-updated="employeeTypeUpdated" @employeerules-updated="employeeRulesUpdated" @employeeyouthworkconfig-updated="employeeYouthWorkConfigUpdated" @refresh="refresh"></employeeplantype>
                                <employeeavailabilityskills ref="compskills" v-if="selectedPage == 'availabilityskills'" :uiData="uiData" :spots="spots" :employee="employee" :employeeavailabilities="employeeAvailabilitiesForEmployee(employee)" :employeeskills="employeeSkillsForEmployee(employee)" :allskills="allSkills" @availability-added="employeeAvailablityAdded" @availability-deleted="employeeAvailablityDeleted" @skill-added="employeeSkillAdded" @skill-deleted="employeeSkillDeleted" @skill-updated="employeeSkillUpdated" @availability-updated="employeeAvailabilityUpdated"></employeeavailabilityskills>
                                <employeeworkingtimeaccount ref="comptimeaccount" v-if="selectedPage == 'workingtimeaccount'" :employee="employee" :employeeWorkbalances="employeeWorkbalancesForEmployee(employee)" @updated="refresh"></employeeworkingtimeaccount>

                                <employeeuseraccount :class="anonMode ? 'anonblur' : ''" ref="useraccount" v-if="selectedPage == 'useraccount'" :employee="employee" @updated="refresh" @account-info-refreshed="accountInfoRefreshed"></employeeuseraccount>
                            </div>
                        </b-col>
                    </b-row>

                    <div v-if="loading" class="loading">
                        <i class="fas fa-spinner"></i>
                    </div>
                    <dropdown v-for="(dropdown, i) in dropdowns" :dropdown="dropdown" :key="i" />
                </div>
            </b-container>
        </b-col>
    </b-row>
    </div>
    <br>
    <b-modal class="image-upload-modal" id="modal-image-upload" v-model="imageUploadModal" hide-footer hide-header>
        <!-- <div v-if="uploading" class="loading">
            <i class="fas fa-spinner"></i>
        </div> -->
        <div style="text-align:center;">
            <vue-avatar :image=uploadedImage :width=380 :height=380 :rotation="rotation" :scale="scale" ref="vueavatar" @vue-avatar-editor:image-ready="onImageReady">
            </vue-avatar>
            <br>
            <div v-if="hasImage && !loading" style="margin: 0px 48px 8px 48px;">
                <label>{{ $t('pages.employeeContext.zoom') }}:</label>
                <input type="range" min=1 max=3 step=0.02 v-model="scaleStr" />
                <div class="radio">
                    <hr />
                    <label for="rotateLeft"><i class="fas fa-portrait" style="margin: 4px 8px; transform: rotate(-90deg);"></i></label>
                    <input style="cursor:pointer;" type="radio" :checked="rotation == -90" v-model="rotation" name="rotationLeft" v-bind:value="rotationLeft" />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label for="rotateNone"><i class="fas fa-portrait" style="margin: 4px 8px;"></i></label>
                    <input style="cursor:pointer;" type="radio" :checked="rotation == 0" v-model="rotation" name="rotationNone" v-bind:value="rotationNone" />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label for="rotateRight"><i class="fas fa-portrait" style="margin: 4px 8px; transform: rotate(90deg);"></i></label>
                    <input style="cursor:pointer;" type="radio" :checked="rotation == 90" v-model="rotation" name="rotationRight" v-bind:value="rotationRight" />
                </div>
                <br>
                <button class="button" v-on:click="saveClicked">{{ $t('pages.employeeData.messages.saveEmployeeImage') }}</button>
            </div>
        </div>
    </b-modal>
    <b-modal class="image-upload-modal" id="default-modal-image-upload" v-model="defaultImageUploadModal" hide-footer hide-header>
        <!-- <div v-if="uploading" class="loading">
            <i class="fas fa-spinner"></i>
        </div> -->
        <div style="text-align:center;">
            <vue-avatar :image=uploadedImage :width=380 :height=380 :rotation="rotation" :scale="scale" ref="defaultvueavatar" @vue-avatar-editor:image-ready="onImageReady">
            </vue-avatar>
            <br>
            <div v-if="hasImage && !loading" style="margin: 0px 48px 8px 48px;">
                <label>Zoom:</label>
                <input type="range" min=1 max=3 step=0.02 v-model="scaleStr" />
                <div class="radio">
                    <hr />
                    <label for="rotateLeft"><i class="fas fa-portrait" style="margin: 4px 8px; transform: rotate(-90deg);"></i></label>
                    <input style="cursor:pointer;" type="radio" :checked="rotation == -90" v-model="rotation" name="rotationLeft" v-bind:value="rotationLeft" />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label for="rotateNone"><i class="fas fa-portrait" style="margin: 4px 8px;"></i></label>
                    <input style="cursor:pointer;" type="radio" :checked="rotation == 0" v-model="rotation" name="rotationNone" v-bind:value="rotationNone" />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label for="rotateRight"><i class="fas fa-portrait" style="margin: 4px 8px; transform: rotate(90deg);"></i></label>
                    <input style="cursor:pointer;" type="radio" :checked="rotation == 90" v-model="rotation" name="rotationRight" v-bind:value="rotationRight" />
                </div>
                <br>
                <button class="button" v-on:click="saveDefaultClicked">{{ $t('pages.employeeData.messages.saveEmployeeImage') }}</button>
            </div>
        </div>
    </b-modal>
    <b-modal ref="modal-error" centered :title="this.$t('global.notifications.error')">
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ errorTitle }}</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1" style="text-align: left;">
                <div>
                    <span>{{errorMessage}}</span>
                </div>
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button green right" @click="hideModal('modal-error')">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
    <b-modal ref="modal-info" centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ infoTitle }}</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1" style="text-align: left;">
                <div>
                    <span>{{infoMessage}}</span>
                </div>
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button green right" @click="hideModal('modal-info')">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
    <b-modal ref="modal-proceed-contract" centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ $t('pages.employeeData.messages.employeeCreatedHeader') }}</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1" style="text-align: left;">
                <div>
                    <span>{{ $t('pages.employeeData.messages.employeeCreatedBody') }}</span>
                </div>
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button right" @click="hideModal('modal-proceed-contract')">
                <div class="label">
                  {{ $t('global.ui.close') }}
                </div>
            </div>
            <div class="button green right" @click="proceedWithContract()">
                <div class="label">
                    {{ $t('pages.employeeData.messages.createContract') }}
                </div>
            </div>
        </template>
    </b-modal>
    <b-modal ref="modal-employee-account" centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ employee.accountId ? $t('pages.employeeData.messages.accountConnected') : $t('pages.employeeData.messages.accountNotFound') }}</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1" style="text-align: left;">
                <div>
                    <span v-if="employee.accountId">{{ $t('pages.employeeData.messages.disconnectAccount') }}</span>
                    <span v-else>
                      {{ $t('pages.employeeData.messages.connectAccount1', { email: employee.email }) }}
                      <br><br>
                      {{ $t('pages.employeeData.messages.connectAccount2') }}
                    </span>
                </div>
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <div class="button right" @click="hideModal('modal-employee-account')">
                <div class="label">
                    {{ employee.accountId ? $t('global.ui.cancel') : $t('global.ui.close') }}
                </div>
            </div>
            <div v-if="!employee.accountId" class="button green right" @click="linkEmployeeAccount()">
                <div class="label">
                    {{ $t('pages.employeeData.messages.connectAccountBtn') }}
                </div>
            </div>
            <div v-if="employee.accountId" class="button red left" @click="unlinkEmployeeAccount()">
                <div class="label">
                  {{ $t('pages.employeeData.messages.disconnectAccountBtn') }}
                </div>
            </div>
        </template>
    </b-modal>

    <b-modal ref="modal-employee-coresync" centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ $t('pages.employeeData.messages.syncEmployeeHeader') }}</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1" style="text-align: left;">
                <div>
                    <span>{{ $t('pages.employeeData.messages.syncEmployeeBody1') }}<br><br><strong>{{ $t('pages.employeeData.messages.syncEmployeeBody2') }}</strong><br><br></span>
                </div>
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <div class="button right" @click="hideModal('modal-employee-coresync')">
                <div class="label">
                  {{ $t('global.ui.cancel') }}
                </div>
            </div>
            <div class="button green right" @click="proceedCoreSync()">
                <div class="label">
                  {{ $t('pages.employeeData.messages.syncEmployeeBtn') }}
                </div>
            </div>
        </template>
    </b-modal>


    <employeeworkbalancecreation ref="employeeworkbalancecreation" ></employeeworkbalancecreation>
</div>
</template>

<script>
import grid from '../../uicomponents/grid.vue';
import dropdown from '../../uicomponents/dropdown.vue';
import employeecoredata from './EmployeeCoreData.vue';
import employeeplantype from './EmployeePlantype.vue';
import employeecontract from './EmployeeContract.vue';
import employeedocuments from './EmployeeDocuments.vue';
import employeeavailabilityskills from './EmployeeAvailabilitySkills.vue';
import employeeworkingtimeaccount from './EmployeeWorkingTimeAccount.vue';
import employeeuseraccount from './EmployeeUserAccount.vue';
import employeeworkbalancecreation from '../../workbalancecontext/EmployeeWorkBalanceCreation.vue';
import { mapState, mapGetters } from 'vuex';
import Vue from 'vue'
import {
    VueAvatar
} from 'vue-avatar-editor-improved'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import pdf from 'vue-pdf';
import Papa from 'papaparse';
export default {
    components: {
        pdf,
        grid,
        dropdown,
        employeecoredata,
        employeeplantype,
        employeecontract,
        employeedocuments,
        employeeavailabilityskills,
        employeeworkingtimeaccount,
        employeeuseraccount,
        employeeworkbalancecreation,
        VueAvatar
    },
    name: 'employeedata',
    data() {
        return {
            uiData: {},
            loadingStage: 0,
            showDetails: false,
            selectedTab: 0,
            selectedPage: null,
            uploading: false,
            scaleStr: "",
            scale: 1.0,
            rotation: 0.0,
            rotationLeft: -90,
            rotationNone: 0,
            rotationRight: 90,
            imageUploadModal: false,
            defaultImageUploadModal: false,
            uploadedImage: '',
            hasImage: false,
            employees: [],
            employeeTypeMap: {},
            employeeRulesMap: {},
            employeeContractMap: {},
            employeeWorkbalancesMap: {},
            employeeWorkbalances: [],
            collectiveContracts: [],
            spotMap: {},
            contractFiles: {},
            dataFiltered: [],
            loading: true,
            loadingText: '',
            dragWatch: -1,
            mouseCurrent: {
                x: 0,
                y: 0
            },
            mouseDragStart: {
                x: 0,
                y: 0
            },
            showImageUploadCircle: false,
            showWizardImageUploadCircle: false,
            scrolling: false,
            scrollTop: 150,
            collapseCoredata: true,
            collapsePlantype: true,
            collapseRules: true,
            collapseContract: false,
            collapseDocuments: true,
            dropdowns: [],
            imagecrops: [],
            nameFilter: '',
            gridData: {
                header: [{
                        label: '',
                        description: this.$t('global.ui.mdEmployeePicture'),
                        map: (i) => i.employeePicture !== null,
                        type: 'icon',
                        width: '50px',
                        enabled: !this.anonMode
                    },
                    {
                        label: this.$t('pages.employeeData.name'),
                        map: (i) => this.anonMode ? this.$t('roster.view.anonymousEmployee') : i.lastName + ' ' + i.firstName,
                        type: 'text',
                        width: '220px',
                        enabled: true
                    }
                ],
                data: []
            },
            spots: [],
            employeetypes: [],
            employeerules: [],
            employee: Object,
            prevEmployee: Object,
            savedEmployee: Object,
            createEmployeeWizardOpened: false,
            wizardPage: 1,
            creatingNewEmployee: false,
            newEmployee: Object,
            newEmployeeProfilePicture: null,
            newEmployeeProfilePictureBase64: null,
            imageForNewEmployee: false,
            filtersCountry: {},
            itemsCountry: [],
            filtersCitizen: {},
            itemsCitizen: [],
            filtersNationality: {},
            itemsNationality: [],
            genderCodes: ['M', 'F'],
            countryMap: {},
            citizenTypeMap: {},
            civilStatusMap: {},
            employmentTypeMap: {},
            filtersGender: {},
            itemsGender: [],
            units: [],
            filtersSpot: {},
            errorTitle: '',
            errorMessage: '',
            infoTitle: '',
            infoMessage: '',
            popupdisabled: true,
            buttonVariants: this.defaultButtonVariants(),
            showOkEmployee: true,
            showEmployeeWithInfo: true,
            showEmployeeWithWarningOrDanger: true,
            showEmployeeNameFilter: false,
            showInactiveEmployees: false,
            showActiveEmployees: true,
            allSkills: [],
            allEmployeeSkills: [],
            allEmployeeAvailabilities: [],
            iconsNav: [
                {label: this.$t('pages.employeeCoreData.newEmployee'), icon: 'fa-user-plus', callback: this.initNewEmployee},
                {label: this.$t('pages.employeeContext.personnelOverview'), icon: 'fa-file-pdf', callback: this.printEmployees},
            ],
            hideDocumentsUpload: false,

            editing: false,
            documentWarnings: {
                hasWarnings: false,
                expired: [],
                expiringSoon: []
            },
            displayedDocumentTypes: [],
            filterDropdownOptions: [],
            documentListView: false,
            useraccount: null,

        }
    },
    computed: {
        ...mapGetters([
            'imgCacheTimestamp',
            'storeId',
            'selectableStores',
            'employeeArray',
            'employeeMap',
            'skillArray',
            'spotArray',
            'employeeTypeArray',
            'collectiveContractMap',
            'allowedContractMap',
            'employeeContractArray',
            'employeeSkillArray',
            'employeeAvailabilityArray',
            'employeeFilesMap',
            'externalServicesMap',
            'employeeExternalDataMap',
            'uiDataMap',
            'holidayMap',
            'storeSettings',
            'userInfo',
            'employmentModelMap',
            'employeeEmploymentModelMap',
            'isSuperUser',
            'youthWorkConfigMap',
            'rosterFromTo',
            'collectiveContractMap',
            'notificationBellConfigState',
            'employeeTypeTemplateMap',
            'permissions',
            'anonMode',
            "mlCollectiveAgreementMap"
        ]),
        userFullname: function(){
            if(this.userInfo.firstname && this.userInfo.lastname){
                return this.userInfo.firstname + ' ' + this.userInfo.lastname
            } else {
                return 'User';
            }

        },
        remoteIdEmployeeMap() {
            let map = {};
            Object.values(this.employeeMap).forEach(e => {
                if(e.remoteId){
                    map[""+e.remoteId] = e;
                }
            })
            return map;
        },
        employeeEmployeeContractMap: function(){
            let map={};
            Object.values(this.employeeContractMap).forEach(c =>{
                if(!map[c.employeeId]){
                   map[c.employeeId] = [];
                }
                map[c.employeeId].push(c);
            });
            return map;
        },
        countryIdMap: function() {
            let map = {};
            this.uiDataMap.countries.forEach(item => {
                map[item.label_de] = item.id
            })
            return map;
        },
        countryCodeMap: function() {
            let map = {};
            this.uiDataMap.countries.forEach(item => {
                if(item.code){
                    map[item.code] = item.id
                }

            })
            return map;
        },

        dateOfBirth: {
            get: function () {
                var dateStr;
                if (this.employee.dob) {
                    dateStr = this.$helpers.extractDateString(this.employee.dob);
                }
                return dateStr;
            },
            set: function (val) {
                this.employee.dob = val;
            }
        },
        employeeContract: {
            get: function () {
                return this.employeeContractForEmployee(this.employee);
            }
        },
        pastEmployeeContracts: {
            get: function () {
                return this.employeeContractsForEmployeeWithType(this.employee, 0);
            }
        },
        futureEmployeeContracts: {
            get: function () {
                return this.employeeContractsForEmployeeWithType(this.employee, 2);
            }
        },
        employeeWarnings: {
            get: function () {
                return this.checkEmployeeData(this.employee, true);
            }
        },
        hbEditEmployeeDisabled(){
            return this.creatingNewEmployee || this.editing || this.selectedPage != 'coredata'
        },
        hasEmployeeEditPermission() {
            if (this.isSuperUser){
                return true;
            }
            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 11 && p.level > 2).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },
        hasEmployeeUnapprovePermission() {
            if (this.isSuperUser){
                return true;
            }
            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 64 && p.level > 2).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },
        hasEmployeeCreatePermission() {
            if (this.isSuperUser){
                return true;
            }
            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 10 && p.level > 2).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },

        hasFullEmployeeReadPermission() {
            if (this.isSuperUser)
                return true;

            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 9 && p.level > 2).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },
        hasEmployeeDeletePermission() {
            if (this.isSuperUser){
                return true;
            }
            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 12 && p.level > 2).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },
        hasEmployeeFileCreatePermission() {
            if (this.isSuperUser){
                return true;
            }
            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 82 && p.level > 2).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },
        hasEmployeeFileConfirmPermission() {
            if (this.isSuperUser){
                return true;
            }
            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 85 && p.level > 2).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },
        sideButtons() {
            let view = this;
            let buttons = [
            ];
            switch(this.selectedPage){
                case 'documents':

                    buttons = [
                    {
                        show: !this.creatingNewEmployee && !this.editing,
                        type: "block border-r",
                        icon: "fa-filter",
                        click: ($event) => {
                        view.OpenFilterDropdown($event);
                        },
                        tooltip: this.$t('global.ui.viewFilter')
                    },
                    {
                        show: !this.creatingNewEmployee && !this.editing,
                        type: "block border-r",
                        icon: "fa-eye",
                        click: ($event) => {
                            view.OpenDocumentsOptionsPopup($event);
                        }
                    }
                ];
                break;
            }
            buttons.push({
                show: !this.creatingNewEmployee && !this.editing,
                type: "block border-r",
                icon: "fa-print",
                tooltip: this.$t('global.ui.reportsExports'),
                click: ($event) => {view.OpenMenuDetails($event, this.reportMenuState)}
            });
            buttons.push({
                        show: !this.creatingNewEmployee && !this.editing,
                        type: "block",
                        icon: "fa-bars",
                        tooltip: this.$t('global.ui.additionalOptions'),
                        click: ($event) => {view.OpenMenuDetails($event, this.optionsMenuState)}
                    });
            return {
                buttons: buttons
            };
        },
        optionsMenuState(){
                let view = this;
                let state = {};

                state = {
                    componentref: 'burgermenustate',
                    groups: [],
                    items: []
                };
                let importGroup = {
                    label: this.$t('pages.employeeContext.import'),
                    items: [
                        {
                            icon: "fa-file-csv",
                            disabled: this.creatingNewEmployee || this.editing || !this.hasFullEmployeeReadPermission,
                            click: () => {
                                view.openCSVImportPopup();
                            },
                            closeOnClick: true,
                            text: this.$t('pages.employeeContext.importFromCsv'),
                            helperText: this.$t('pages.employeeContext.importFromCsvHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/43d6a505-b8ac-4215-852a-56fb6e466498/article/1272741889",
                        },
                        {

                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: "fa-file-csv",
                            click: () => { this.openUpdatePaymentByCSVPopup(); },
                            show:  !this.editing && !this.creatingNewEmployee,
                            text: this.$t('pages.employeeContext.employeeWagesFromCsv'),
                            helperText: this.$t('pages.employeeContext.employeeWagesFromCsvHelp'),
                        }
                    ]
                };
                state.groups.push(importGroup);

                let testEmplGroup = {
                    label: this.$tc('global.general.employee'),
                    items: [
                        {
                            classes: "employee-transfer",
                            type: "block green ",
                            disabled: this.creatingNewEmployee || this.editing || (this.employee != null && this.employee.dummy) || !this.hasFullEmployeeReadPermission,
                            icon: "fa-exchange-alt",
                            click: () => { this.openTransferEmployeeModal(this.employee); },
                            show:  this.employee != null && !this.employee.dummy,
                            text: this.$t('pages.employeeContext.transferEmployees'),
                            helperText: this.$t('pages.employeeContext.transferEmployeesHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/43d6a505-b8ac-4215-852a-56fb6e466498/article/2432040967",
                        },
                        {
                            classes: "add-employee",
                            //type: (this.employee != null && this.employee.dummy) ? "block orange border-r" : "block orange",
                            disabled: this.creatingNewEmployee || this.editing,
                            icon: "fa-user-plus",
                            click: () => { this.requestFirstNameForDummy(); },
                            show:  !this.editing && !this.creatingNewEmployee,
                            text: this.$t('pages.employeeContext.createTestEmployee'),
                            helperText: this.$t('pages.employeeContext.createTestEmployeeHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/43d6a505-b8ac-4215-852a-56fb6e466498/article/2500427777"
                        },
                        {
                            classes: "employee-picture-delete",
                            //type: "block red",
                            disabled: this.employee.employeePicture == null,
                            icon: "fa-portrait",
                            click: () => { this.deleteEmployeePicture(this.employee.id); },
                            show:  this.employee != null && !this.employee.dummy,
                            text: this.$t('pages.employeeContext.deleteEmployeePicture'),
                            helperText: this.$t('pages.employeeContext.deleteEmployeePictureHelp'),
                        },
                        {

                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: "fa-money-check-edit-alt",
                            click: () => { this.openMultiUpdatePaymentPopup(); },
                            show:  !this.editing && !this.creatingNewEmployee,
                            text: this.$t('pages.employeeContext.adjustEmployeeWageData'),
                            helperText: this.$t('pages.employeeContext.adjustEmployeeWageDataHelp'),
                        },


                    ]



                }
                state.groups.push(testEmplGroup);

                return state;
            },
        reportMenuState() {
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [],
                    items: []
                };

                let reportGroup = {
                    label: this.$t('roster.view.report'),
                    items: [
                    {
                            closeOnClick: true,
                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: 'fa-file-download',
                            text: this.$t('pages.employeeContext.personnelOverview'),
                            click: () => { view.printEmployees();},
                            tooltip: this.$t('pages.employeeContext.personnelOverview'),
                            title: this.$t('pages.employeeContext.personnelOverview'),
                            helperText: this.$t('pages.employeeContext.personnelOverviewHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
                        },{
                            closeOnClick: true,
                             disabled: !this.hasFullEmployeeReadPermission,
                            icon: 'fa-child',
                            text: this.$t('pages.employeeContext.underageOverview'),
                            click: () => { view.printUnderaged();},
                            helperText: this.$t('pages.employeeContext.underageOverviewHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
                       },{
                            closeOnClick: true,
                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: 'fa-child',
                            text: this.$t('pages.employeeContext.overviewHandicappedEligible'),
                            click: () => { view.printDisabled();},
                            helperText: this.$t('pages.employeeContext.overviewHandicappedEligibleHelp')
                       },{
                            closeOnClick: true,
                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: 'fa-child',
                            text: this.$t('pages.employeeContext.overviewFirstAid'),
                            click: () => { view.printFirstAid();},
                            helperText: this.$t('pages.employeeContext.overviewFirstAidHelp')
                       },{
                            closeOnClick: true,
                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: 'fa-file',
                            text: this.$t('pages.employeeContext.overviewDocuments'),
                            click: () => { view.printDocumentsOverview();},
                            helperText: this.$t('pages.employeeContext.overviewDocumentsHelp')
                       },{
                            closeOnClick: true,
                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: 'fa-file-pdf',
                            text: this.$t('pages.employeeContext.overviewThirdCountry'),
                            click: () => { view.printNonEUEmployeesPDF();},
                            helperText: this.$t('pages.employeeContext.overviewThirdCountryHelp')
                       }, {
                            closeOnClick: true,
                            disabled: !this.hasFullEmployeeReadPermission,
                            icon: 'fa-file-pdf',
                            text: this.$t('pages.employeeContext.overviewBirthdays'),
                            click: () => { view.printBirthdaysPDF();},
                            helperText: this.$t('pages.employeeContext.overviewBirthdaysHelp')
                       }, {
                            closeOnClick: true,
                            disabled: false,
                            icon: 'fa-file-pdf',
                            text: this.$t('pages.employeeContext.employmentDurationOverview'),
                            click: () => { view.printEmploymentDurationPDF();},
                            helperText: this.$t('pages.employeeContext.employmentDurationOverviewHelp')
                       }

                    ]
                };
                state.groups.push(reportGroup);

                return state;
            },
        displaymenuState(){
            let view = this;

            return {
                componentref: 'burgermenustate',
                groups: [
                    {
                        label: this.$t('global.ui.viewOptions'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: view.documentListView ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.documentListView ? this.$t('pages.employeeContext.documentList') : this.$t('pages.employeeContext.documentDirectories'),
                                click: () => {
                                    view.documentListView = !view.documentListView;
                                    localStorage.setItem("employeeDocumentListView", view.documentListView);
                                }
                            },

                        ]
                    },


                ],
                items: []
            };
        },
        headerButtons() {
            let view = this;
            let buttons = [];
            let helperLinks = [];

            switch(this.selectedPage){
                case 'coredata':
                    buttons = [
                        {
                            type: "block",
                            icon: "fa-sync-alt",
                            click: () => {
                                view.refresh(null, true, true);
                            },
                            tooltip: this.$t('global.general.refreshData')
                        },
                        {
                            classes: "edit-employee",
                            type: "block orange",
                            disabled: this.hbEditEmployeeDisabled || (this.employee != null && !this.employee.dummy) || !this.hasFullEmployeeReadPermission || !this.hasEmployeeEditPermission,
                            icon: "fa-user-check",
                            click: () => {
                                this.editCurrentEmployeeCoredata();
                            },
                            show:  !this.editing && !this.creatingNewEmployee && (this.employee != null && this.employee.dummy),
                            title: this.$t('pages.employeeContext.convertTestEmployee'),
                            helperText: this.$t('pages.employeeContext.convertTestEmployeeHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/43d6a505-b8ac-4215-852a-56fb6e466498/article/2500427777"
                        },
                        {
                            classes: "add-employee",
                            type: (this.employee != null && this.employee.dummy) ? "block green" : "block green  border-r",
                            disabled: this.creatingNewEmployee || this.editing || !this.hasFullEmployeeReadPermission || !this.hasEmployeeCreatePermission,
                            icon: "fa-user-plus",
                            click: () => { this.requestEmailForNewEmployee(); },
                            show:  !this.editing && !this.creatingNewEmployee,
                            tooltip: this.$t('pages.employeeContext.createEmployee'),
                            helperText: this.$t('pages.employeeContext.createEmployeeHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
                        },
                        {
                            classes: "edit-employee",
                            type: "block yellow",
                            disabled: this.hbEditEmployeeDisabled || !this.hasFullEmployeeReadPermission || !this.hasEmployeeEditPermission,
                            icon: "fa-user-edit",
                            click: () => {
                                this.editCurrentEmployeeCoredata();
                            },
                            show:  !this.editing && !this.creatingNewEmployee && (this.employee != null && !this.employee.dummy) && !this.anonMode,
                            tooltip: this.$t('pages.employeeContext.editEmployee'),
                            helperText: this.$t('pages.employeeContext.editEmployeeHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
                        },
                        {
                            classes: "update-employee",
                            type: "block green",
                            disabled: (!this.creatingNewEmployee && this.$refs.compcoredata != undefined && !this.$refs.compcoredata.pendingChanges),
                            icon: "fa-save",
                            click: () => {
                                this.checkEmail(this.$refs.compcoredata.savedEmployee.email, this.$refs.compcoredata.savedEmployee.id, true, this.saveEmployeeClicked);
                            },
                            show: this.creatingNewEmployee || this.editing,
                            tooltip: this.$t('global.ui.saveChanges'),
                            helperText: this.$t('pages.employeeContext.saveHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
                        },
                        {
                            classes: "update-employee",
                            type: "block cyan",
                            disabled: !this.creatingNewEmployee && this.$refs.compcoredata != undefined && !this.$refs.compcoredata.pendingChanges,
                            icon: "fa-save",
                            click: () => {
                                this.checkEmail(this.$refs.compcoredata.savedEmployee.email, this.$refs.compcoredata.savedEmployee.id, true, this.saveEmployeeClicked, true);
                            },
                            show: this.editing && (this.employee != null && !this.employee.dummy),
                            tooltip: this.$t('pages.employeeContext.saveChangesWithPDF'),
                            helperText: this.$t('pages.employeeContext.saveChangesWithPdfHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
                        },
                        {
                            classes: "cancel-edit",
                            type: "block red",
                            disabled: false,
                            icon: "fa-minus-circle",
                            click: () => {
                                this.$refs.compcoredata.cancelEditMode();
                            },
                            show: this.creatingNewEmployee || this.editing,
                            tooltip: this.$t('global.ui.cancel'),
                            title: this.$t('global.ui.cancel'),
                            helperText: this.$t('pages.employeeContext.cancelAndDiscard'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
                        },
                        {
                            classes: "employee-delete",
                            type: "block red",
                            disabled: this.creatingNewEmployee || this.editing,
                            icon: "fa-user-alt-slash",
                            click: () => { this.openDeleteEmployeeModal(this.employee); },
                            show:  this.employee != null && !this.employee.active && !(this.creatingNewEmployee || this.editing),
                            tooltip: this.$t('pages.employeeContext.deleteEmployees'),
                            helperText: this.$t('pages.employeeContext.deleteEmployeesHelp'),
                        },
                    ];
                    break;
                case 'contract':
                    buttons = [
                        {
                            classes: "add-contract",
                            type: "block green",
                            disabled: !this.hasEmployeeCreatePermission,
                            icon: "fa-file-medical",
                            click: () => {
                                this.$refs.employeecontract.openNewContractWizard();
                             },
                            show:  this.employeeContract == null,
                            tooltip: this.$t('pages.employeeData.messages.createContract'),
                            title: this.$t('pages.employeeData.messages.createContract'),
                            helperText: this.$t('pages.employeeContext.createContractHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1133871147"
                        },
                        {
                            classes: "edit-contract",
                            type: "block yellow",
                            disabled: !this.hasEmployeeEditPermission,
                            icon: "fa-file-signature",
                            click: () => {
                                this.$refs.employeecontract.openEditModal(this.employeeContract);
                            },
                            show:  this.employeeContract != null,
                            tooltip: this.$t('pages.employeeContext.changeActiveContract'),
                            helperText: this.$t('pages.employeeContext.changeActiveContractHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1133871147"
                        },
                        {
                            classes: "upload-contract",
                            type: (this.employeeContract != null && !this.employeeContract.approved) ? "block cyan border-r": "block cyan",
                            disabled: !this.hasEmployeeEditPermission,
                            icon: "fa-file-upload",
                            click: () => {
                                this.$refs.employeecontract.selectFileForUpload(this.employeeContract);
                            },
                            show:  this.employeeContract != null && this.employeeContract.fileId == null,
                            tooltip: this.$t('pages.employeeContext.uploadContractDocument'),
                            helperText: this.$t('pages.employeeContext.uploadContractDocumentHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1133871147"
                        },
                        {
                            classes: "approve-contract",
                            type: "block cyan",
                            disabled: !this.hasEmployeeEditPermission,
                            icon: "fa-check",
                            click: () => {
                                this.$refs.employeecontract.openApproveContractModal(this.employeeContract);
                            },
                            show:  this.employeeContract != null && !this.employeeContract.approved,
                            tooltip: this.$t('pages.employeeContract.messages.approveContractTitle'),
                            helperText: this.$t('pages.employeeContext.approveContractHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1133871147"
                        },
                        {
                            classes: "delete-contract",
                            type: "block red",
                            disabled: !this.hasEmployeeDeletePermission,
                            icon: "fa-times",
                            click: () => {
                                this.$refs.employeecontract.openDeleteContractModal(this.employeeContract);
                            },
                            show:  this.employeeContract != null && !this.employeeContract.approved,
                            tooltip: this.$t('pages.employeeContract.deleteContract'),
                            helperText: this.$t('pages.employeeContext.deleteContractHelp'),

                        },
                        {
                            classes: "unapprove-contract",
                            type: "block red",
                            disabled: !this.hasEmployeeUnapprovePermission,
                            icon: "fa-times",
                            click: () => {
                                this.$refs.employeecontract.openUnapproveContractModal(this.employeeContract);
                            },
                            show:  this.employeeContract != null && this.employeeContract.approved,
                            tooltip: this.$t('pages.employeeContext.cancelContractApproval'),
                        },
                        {
                            classes: "diff-contract",
                            type: "block cyan",
                            disabled: false,
                            icon: "fa-file-pdf",
                            click: () => {
                                this.$refs.employeecontract.OpenContractDiffReportPopup();
                            },
                            show: this.totalContractsCount > 1,
                            tooltip: this.$t('pages.employeeContext.changeReportAsPdf'),
                            helperText: this.$t('pages.employeeContext.changeReportAsPdfHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1133871147"
                        },

                    ];
                    break;
                case 'documents':
                    buttons = [
                        {
                            classes: "upload-file",
                            type: "block green",
                            disabled: this.hideDocumentsUpload || !this.hasEmployeeFileCreatePermission,
                            icon: "fa-file-upload",
                            click: () => {
                                this.$refs.documents.modalCreatefile = true;
                                setTimeout(() => { // give the modal some time to show up :-)
                                    view.$refs.documents.selectFileForUpload();
                                }, 100);
                             },
                            show:  true,
                            tooltip: this.$t('global.general.uploadDocument'),
                            helperText: this.$t('pages.employeeContext.uploadDocumentHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134133272"
                        },
                        {
                            classes: "fill-documents",
                            type: "block cyan",
                            disabled: false,
                            icon: "fa-file-code",
                            click: () => {
                                this.$refs.documents.startFillDocuments();
                             },
                            show:  !this.anonMode,
                            tooltip: this.$t('pages.employeeContext.fillDocuments'),
                            helperText: this.$t('pages.employeeContext.fillDocumentsHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/43d6a505-b8ac-4215-852a-56fb6e466498/article/1665040385"
                        },
                        {
                            classes: "upload-file",
                            type: "block green",
                            disabled: this.hideDocumentsUpload || !this.hasEmployeeFileConfirmPermission || (Object.values(this.employeeFilesMap).filter(f => f.employeeId == this.employee.id && !f.confirmed).length == 0),
                            icon: "fa-file-check",
                            click: () => {
                                this.$refs.documents.confirmAllEmployeeFile();

                             },
                            show:  true,
                            tooltip: this.$t('pages.employeeContext.confirmAllDocuments'),
                            helperText: this.$t('pages.employeeContext.confirmAllDocumentsHelp'),

                        },
                    ];
                    break;
                case 'availabilityskills':
                    buttons = [
                        {
                            classes: "add-availability",
                            type: "block green border-r",
                            disabled: false,
                            icon: "fa-business-time",
                            click: ($event) => {
                                this.$refs.compskills.openNewAvailabilityPopup($event);
                             },
                            show:  true,
                            tooltip: this.$t('pages.employeeContext.addAvailability'),
                            helperText: this.$t('pages.employeeContext.addAvailabilityHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                        },
                        {
                            classes: "add-skill",
                            type: "block green",
                            disabled: false,
                            icon: "fa-chalkboard-teacher",
                            click: ($event) => {
                                this.$refs.compskills.openNewSkillPopup($event);
                             },
                            show:  true,
                            tooltip: this.$t('store.structure.addSkill'),
                            helperText: this.$t('pages.employeeContext.addSkillHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                        }
                    ];
                    break;
                case 'plantype':
                    buttons = [
                        {
                            classes: "employee-transfer",
                            type: "block green ",
                            icon: "fa-link",
                            click: () => { this.$refs.compplantype.openLinkDefaultModal(); },
                            tooltip: this.$t('pages.employeeContext.linkToStandardPlanning'),
                            helperText: this.$t('pages.employeeContext.linkToStandardPlanningHelp'),
                        },
                    ]
                    helperLinks = [

                        {
                            title: this.$t('pages.employeeContext.planningBaseAndFreeTimeOptions'),
                            helperText: this.$t('pages.employeeContext.planningBaseAndFreeTimeOptionsHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134460933"
                        }
                    ];
                    break;
                case 'workingtimeaccount':
                    helperLinks = [
                        {
                            title: this.$t('pages.employeeData.workTime'),
                            helperText: this.$t('pages.employeeContext.workTimeHelp'),
                            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134198794"
                        }
                    ];
                    break;
                case 'useraccount':
                    buttons = [];
                    if(this.employee.accountId == null){
                        buttons.push(
                            {
                                classes: "account-link",
                                type: "block green",
                                disabled: false,
                                icon: "fa-link",
                                click: ($event) => {
                                    this.openEmployeeAccountModal();
                                },
                                show:  true,
                                tooltip: this.$t('pages.employeeContext.linkAccount'),
                                helperText: this.$t('pages.employeeContext.linkAccountHelp'),
                                //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                            }
                        );
                    } else {
                        if(this.useraccount == null || !this.useraccount.active ){
                            buttons.push(
                                {
                                    classes: "account-activate",
                                    type: "block green",
                                    disabled: false,
                                    icon: "fa-envelope",
                                    click: ($event) => {
                                        this.openActivationEmailPopup();
                                    },
                                    show:  true,
                                    tooltip: this.$t('pages.employeeContext.sendActivationLink'),
                                    helperText: this.$t('pages.employeeContext.sendActivationLinkHelp'),
                                        //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                                }
                            );
                        }
                        buttons.push(
                            {
                                    classes: "account-unlink",
                                    type: "block red",
                                    disabled: false,
                                    icon: "fa-times",
                                    click: ($event) => {
                                        this.openEmployeeAccountModal();
                                    },
                                    show:  true,
                                    tooltip: this.$t('pages.employeeData.messages.disconnectAccountBtn'),
                                    title: this.$t('pages.employeeContext.cancelLink'),
                                    helperText: this.$t('pages.employeeContext.cancelLinkHelp'),
                                    //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                            }
                        );
                    }


                    break;
            }

            helperLinks.push({
                icon: "fa-exchange-alt",
                title: this.$t('pages.employeeContext.transferEmployees'),
                helperText: this.$t('pages.employeeContext.transferEmployeesHelp') + this.$t('pages.employeeContext.topRightFunction'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/43d6a505-b8ac-4215-852a-56fb6e466498/article/2432040967"
            });

            helperLinks.push({
                icon: "fa-user-plus",
                title: this.$t('pages.employeeContext.createTestEmployee'),
                helperText: this.$t('pages.employeeContext.createEmployeeHelp') + this.$t('pages.employeeContext.topRightFunction'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/43d6a505-b8ac-4215-852a-56fb6e466498/article/2500427777"
            });

            helperLinks.push({
                icon: "fa-file-download",
                title: this.$t('pages.employeeContext.personnelOverviewUnderage'),
                helperText: this.$t('pages.employeeContext.personnelOverviewUnderageHelp') + this.$t('pages.employeeContext.topRightFunction'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1129578499"
            });


            helperLinks.push(
                {
                    icon: "fa-video",
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=mCzOWsM5aiI",
                    externalLabel: this.$t('pages.employeeContext.trainingVideoManageEmployees'),
                    cancelLabel: this.$t('global.ui.close')
                }
            );
            helperLinks.push(
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/11",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            );
            let state= {
                buttons: buttons,
                helperLinks: helperLinks,
                showListIconAlways: true
                };
            return state;
        },
        totalContractsCount(){
            let res = 0;
            if(this.employeeContract != null){
                res+=1;
            }
            if(this.futureEmployeeContracts != null){
                res+= this.futureEmployeeContracts.length;
            }
            if(this.pastEmployeeContracts != null){
                res+= this.pastEmployeeContracts.length;
            }
            return res;
        },
        mlWageGroupMap() {
            let map = {};
            Object.values(this.mlCollectiveAgreementMap)
            .forEach(ca => {
                ca.wage_groups.forEach(wg => {
                    map[wg.id] = wg;
                });

            });
            return map;
        },
    },
    watch: {
        storeId: function (val, oldVal){
            if(val != oldVal) this.refresh(null, true, true);
        },
        loadingStage: function (val, oldVal){
            console.log('EmployeeData - loading stage: ' + val + '/11');
            if(val >= 11){
                console.log('EmployeeData - loading done');
                this.loading = false;
            }
        },
        skillArray: function(val, oldVal){
            this.allSkills = val;
        },
        employeeArray:function (val, oldVal){
            this.prepareStoreEmployees(val, this.savedEmployee? this.savedEmployee.id : null);
        },
        spotArray: function (val, oldVal){
            this.updateSpots(val);
        },
        employeeTypeArray: function (val, oldVal){
            this.updateEmployeeTypes(val);
        },

        collectiveContractMap: function(val, oldVal){
            this.updateCollectiveContracts(Object.values(val));
            this.loadAllowedContracts();
        },
        allowedContractMap: function(val, oldVal){
            this.updateAllowedContracts(Object.values(val));
        },
        employeeContractArray: function(val, oldVal){
            this.updateEmployeeContracts(val);
            this.loadContractFiles(val);
            if (this.selectedPage === 'contract') {
                this.checkPartTimeAvailabilitiesForEmployee();
            }
        },
        employeeSkillArray: function(val, oldVal){
            this.allEmployeeSkills = val;
        },
        employeeAvailabilityArray: function(val, oldVal){
            this.allEmployeeAvailabilities = val;
        },
        scaleStr: function (val, oldVal) {
            this.scale = parseFloat(val);
        },
        nameFilter: function (val, oldVal) {
            this.filterGridData();
        },
        showOkEmployee: function(val, oldVal){
            this.filterGridData();
        },
        showEmployeeWithInfo: function(val, oldVal){
            this.filterGridData();
        },
        showEmployeeWithWarningOrDanger: function(val, oldVal){
            this.filterGridData();
        },
        showInactiveEmployees: function(val, oldVal){
            this.filterGridData();
        },
        showActiveEmployees: function(val, oldVal){
            this.filterGridData();
        },
        employee: function(val, oldVal){
            /* this.$helpers.log(this, 'watch()', val); */
            this.updateEmployeeGridDataMetadata();
            this.filterGridData();
        },
        uiDataMap: function(val, oldVal){
            this.uiData = val;
            this.uiData.countries.forEach(item => this.countryMap[item.id] = item.label_de);
            this.uiData.citizenTypes.forEach(item => this.citizenTypeMap[item.id] = item.label_de);
            this.uiData.civilStatuses.forEach(item => this.civilStatusMap[item.id] = item.label_de);
            if(!this.selectedPage) this.selectedPage = 'coredata';
        },
        storeSettings: function(val, oldVal){
            //this.$helpers.log(this, 'storeSettings', val, false);
        },
        externalServices: function(val, oldVal){
            this.updateExternalServices(val);
        }
    },
    props: {},
    created() {
        window.employeesettings = this;
        var settings = this;
    },
    mounted() {
        let view = this;
        let employeeIdToSelect = null;
        if(this.$parent.employeeIdToSelect != null){
            employeeIdToSelect = this.$parent.employeeIdToSelect;
            this.$parent.employeeIdToSelect = null;
        }
        let types = [];
        this.$helpers.documentTypes().forEach((t) => {
            types.push(t.value);
        });
        this.displayedDocumentTypes = types;
        let dListView = localStorage.getItem("employeeDocumentListView");
        if(dListView != null){
            this.documentListView = dListView;
        }
        view.refresh(employeeIdToSelect, true, true);
    },
    updated() {
        /* if (this.employee && !this.employee.firstName && this.gridData && this.gridData.data && this.gridData.data[0] && !this.creatingNewEmployee) {
            this.updateEmployeeGridDataMetadata();
            this.employee = this.dataFiltered[0];
            this.employee.selected = true;
            this.$forceUpdate();
            if (this.$refs.grid != undefined) this.$refs.grid.$forceUpdate();
        } */
    },
    destroyed() {
        var settings = this;

        if (document.querySelector('#imgupload')) document.querySelector('#imgupload').removeEventListener('change', settings.ProcessImageUpload);
        if (document.querySelector('#imguploadpublic')) document.querySelector('#imguploadpublic').removeEventListener('change', settings.ProcessImageUploadPublic);
    },
    methods: {

        OpenMenuDetails($event, state){
            let view = this;

            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: state,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        selectEmployeePage(page){
            if(this.selectedPage == 'coredata'){
                // check if currently editing before navigating to other employeepage
                this.checkEditingMode(() => this.selectedPage = page);
            }else{
                this.selectedPage = page;
            }
        },
        editCurrentEmployeeCoredata(){
            this.$refs.compcoredata.toggleEditMode();
            this.editing = true;
        },
        saveCurrentEmployeeCoredata(generateChangePdf=false){
            this.$refs.compcoredata.updateChangedFields(generateChangePdf);
            //update changedfields can fail, so we shouldnt immediately exit edit mode
            //this.editing = false;
        },
        filterGridData(){
            // filter by namefilter
            var filtered = this.gridData.data.slice();
            if (this.nameFilter !== '') {
                filtered = this.gridData.data.filter(e => (e.lastName.toLowerCase() + ' ' + e.firstName.toLowerCase()).normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(this.nameFilter.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) > -1);
            }

            // no errors
            if(!this.showOkEmployee){
                filtered = filtered.filter(e =>  e.metadata && e.metadata.warnings.length > 0);
            }

            // infos
            if(!this.showEmployeeWithInfo){
                filtered = filtered.filter(e =>  e.metadata && e.metadata.severity !== 'info');
            }

            // warnings
            if(!this.showEmployeeWithWarningOrDanger){
                filtered = filtered.filter(e =>  e.metadata && e.metadata.severity !== 'warning' && e.metadata.severity !== 'danger');
            }
            //active
            if(this.showActiveEmployees && !this.showInactiveEmployees){
                filtered = filtered.filter(e => e.active);
            }
            //inactive
            if(!this.showActiveEmployees && this.showInactiveEmployees){
                filtered = filtered.filter(e => !e.active);
            }
            if(!this.showActiveEmployees && !this.showInactiveEmployees){
                filtered = [];
            }


            this.dataFiltered = filtered;
            //this.dataFiltered.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1)
            this.dataFiltered.sort((a, b) => {
                var levels = {
                    'none': 0,
                    'ok': 0,
                    'info': 1,
                    'warning': 2,
                    'danger': 3
                };
                var levelA = a.metadata != undefined? levels[a.metadata.severity] : 0;
                var levelB = b.metadata != undefined? levels[b.metadata.severity] : 0;
                if(levelA > levelB){
                    return 1;
                }else if(levelA < levelB){
                    return -1;
                }
                return 0;
            });
            return this.dataFiltered;
        },
        LoadFilterDropdown(){
            let view = this;

            let items = [];
            this.$helpers.documentTypes().forEach((t) => {
                var option = {label: t.label, toggled: view.displayedDocumentTypes.includes(t.value), type: t.value};
                items.push(option);

            });


            items.push({label: this.$t('global.ui.all'), toggled: true, all: true, color: "#eeeeee"})
            this.filterDropdownOptions = items;
        },
        OpenFilterDropdown($event){
            let view = this;
            let target = $event.currentTarget;


            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'list',
                componentState: {
                    entries: view.filterDropdownOptions,
                },
                remainAfterSelect: true,
                pointerDirection: 0,
                iconsLeft: true,
                selectCallback: function($event, item, dropdown){
                    item.toggled = !item.toggled;

                    if(item.all) {
                        view.filterDropdownOptions.forEach(option => {
                            if(option.type ){
                                option.toggled = item.toggled;

                            }
                        })
                    }
                    view.displayedDocumentTypes = view.filterDropdownOptions.filter(o => o.toggled && !o.all).map(o => o.type);
                },
            });
        },
        ToggleDropDown: function ($event, selection, offsetx, offsety, pointerOffset) {
                if (!selection || selection.length === 0) return;
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                var dropdowns = this.dropdowns;
                /* if (selection === this.iconsNav && window.innerWidth <= 750) {
                    selection = this.iconsNavCollapsed;
                } */
                this.dropdowns.push({
                    items: selection,
                    el: event.currentTarget,
                    remainAfterSelect: true,
                    toggled: true,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    pointerOffset: pointerOffset,
                    onceSelected: function ($eventInner, item, dropdown) {
                        if (item.items && item.items.length > 0) {
                            var eventInner = $eventInner;
                            var boxInner = eventInner.currentTarget.getBoundingClientRect();
                            var temp = {
                                items: item.items,
                                el: eventInner.currentTarget,
                                offsetx: offsetx + 130,
                                offsety: offsety - 30,
                                posx: box.left + offsetx + 130,
                                toggled: true,
                                posy: boxInner.bottom - 30,
                                pointerDirection: 3,
                                pointerOffset: pointerOffset,
                                parentCallback: function () {
                                    dropdown.toggled = false
                                }
                            };
                            dropdowns.push(temp);
                        }else{
                            console.log('SELECTED:');
                            console.log(item);
                            item.callback();
                        }
                    }
                });
            },
        proceedCoreSync(){
            this.hideModal('modal-employee-coresync')
            let view = this;
            this.loading = true;
            this.loadingText = this.$t('pages.employeeData.loading.syncEmployees');
            this.$helpers.PostCall('/api/sec/employeesync', {})
                .then(async (response) => {
                    await this.$helpers.setTimeoutAsync(8000);
                    view.loadingText = this.$t('pages.employeeData.loading.matchEmployees');
                    await this.$helpers.setTimeoutAsync(5000);
                    view.loadingText = this.$t('pages.employeeData.loading.refreshCoreData');
                    await this.$helpers.setTimeoutAsync(5000);
                    view.loadingText = this.$t('pages.employeeData.loading.checkCoreData');
                    await this.$helpers.setTimeoutAsync(4000);
                    view.loadingText = this.$t('pages.employeeData.loading.saveData');
                    await this.$helpers.setTimeoutAsync(3000);
                    view.loadingText = this.$t('pages.employeeData.loading.syncDone');
                    await this.$helpers.setTimeoutAsync(3000);
                    view.loadingText = this.$t('pages.employeeData.loading.disposeOldData');
                    await this.$helpers.setTimeoutAsync(2000);
                    view.loadingText = this.$t('pages.employeeData.loading.loadNewData');
                    await this.$helpers.setTimeoutAsync(2000);
                    view.loadingText = this.$t('pages.employeeData.loading.refreshUI');
                    await this.$helpers.setTimeoutAsync(2000);
                    view.loadingText = this.$t('pages.employeeData.loading.oneMoment');
                    await this.$helpers.setTimeoutAsync(2000);
                    view.refresh(view.employee.id, true, true);
            });
        },
        refreshFromCore(){
            this.showModal('modal-employee-coresync');
        },
        refresh(employeeIdToSelect = null, force = false, loadingAnimation = true) {
            /* console.log('REFRESHING: ' + employeeIdToSelect + '|' + force); */
            let view = this;
            this.loading = true;
            this.loadingStage = 0;
            this.loadingText = this.$t('pages.employeeData.loading.employeeData');
            this.editing = false;
            if(this.employeeIdToSelect == null) this.employee = {};

            this.$helpers.GetStoreSettings()
            .then((map) => {
                this.loadingStage++;
            });


            this.$helpers.GetUiDataMap(force).then((uiData) => {
                this.uiData = uiData;
                this.uiData.countries.forEach(item => this.countryMap[item.id] = item.label_de);
                this.uiData.citizenTypes.forEach(item => this.citizenTypeMap[item.id] = item.label_de);
                this.uiData.civilStatuses.forEach(item => this.civilStatusMap[item.id] = item.label_de);
                if(!this.selectedPage) this.selectedPage = 'coredata';
                this.loadingStage++;
            });
            this.$helpers.GetSkillArray(force).then((skills) => {
                this.allSkills = skills;
                this.loadingStage++;
            });
            this.$helpers.GetEmployeeArray(force).then((empls) => {
                this.prepareStoreEmployees(empls, employeeIdToSelect, force);
                let employeePayload = {ids: []};
                let remoteIds = [];
                for (let i = 0; i < empls.length; i++) {
                    employeePayload.ids.push(empls[i].id);
                    if(empls[i].remoteId){
                        remoteIds.push(empls[i].remoteId);
                    }
                }
                let params = {};
                let from = this.$helpers.getMomentUTC().startOf('month').add(-12, 'months');
                let to = this.$helpers.getMomentUTC().startOf('month').add(2, 'months');
                params.from = from.format();
                params.to = to.format();
                this.loadingStage++;
                this.$helpers.GetAllEmployeeWorkbalancesMapForEmployees(employeePayload, params, force, true).then((emplWorkBalances) => {
                    this.employeeWorkbalances = emplWorkBalances;
                });

                this.$helpers.GetEmploymentModelMap(force).then(employmentModelMap => {

                    this.$helpers.GetEmployeeEmploymentModelMap(remoteIds, force).then(employeeEmploymentModelMap => {

                    });
                });

                this.$helpers.GetYouthWorkConfigMap(force);
                this.$helpers.GetHolidayMap(force, false, this.$helpers.getCurrentMonthMomentTZ().year());

            });
            this.$helpers.GetSpotArray(force).then((spots) => {
                this.updateSpots(spots);
                this.updateEmployeeGridDataMetadata();
                view.$helpers.GetEmployeeExternalDataMap(force).then((externalData) => {


                    view.$helpers.GetExternalServicesMap(force).then((services) => {
                        this.loadingStage++;
                    });
                });

            });
            this.$helpers.GetCollectiveContractMap(force).then((map) => {
                view.$helpers.GetMlCollectiveAgreementMap();
                this.updateCollectiveContracts(Object.values(map));
                this.loadAllowedContracts(force);
                this.updateEmployeeGridDataMetadata();
                this.loadingStage++;
            });
            this.$helpers.GetEmployeeContractArray(true).then((contracts) => {
                this.updateEmployeeContracts(contracts);
                this.loadContractFiles(contracts);
                this.updateEmployeeGridDataMetadata();
                this.loadingStage++;
            });
            this.$helpers.GetEmployeeTypeArray(force).then((types) => {
                this.updateEmployeeTypes(types);
                this.updateEmployeeGridDataMetadata();
                this.loadingStage++;
            });
            this.$helpers.GetEmployeeRulesArray(force).then((rules) => {
                this.updateEmployeeRules(rules);
                this.updateEmployeeGridDataMetadata();
                this.loadingStage++;
            });
            this.$helpers.GetEmployeeSkillArray(force).then((emplSkills) => {
                this.allEmployeeSkills = emplSkills;
                this.updateEmployeeGridDataMetadata();
                this.loadingStage++;
            });
            this.$helpers.GetEmployeeAvailabilityArray(force).then((emplAvailabilities) => {
                this.allEmployeeAvailabilities = emplAvailabilities;
                this.updateEmployeeGridDataMetadata();
                this.loadingStage++;
            });

            this.reloadEmployeeFiles(force);
            /* let view = this;
            view.loading = false; */
        },
        checkPartTimeAvailabilitiesForEmployee(){
            let view = this;
            if (view.employee.id !== undefined) {
                let employeeAvailabilities = view.employeeAvailabilityArray.filter(a => {
                    return a.employeeId === view.employee.id;
                });
                let partTimeTypes = this.uiData.partTimeTypes.map(item => {return {label: item.label_de, value: item.id}});
                let partTimeType = null;
                let currentPartTimeContract = false;
                let futurePartTimeContract = false;
                view.employeeContractsForEmployeeWithType(view.employee, 2).forEach(c => {
                    if (c.contractType === 2 && c.partTimeType != null) {
                        futurePartTimeContract = true;
                        partTimeType = c.partTimeType;
                    }
                });
                view.employeeContractsForEmployeeWithType(view.employee, 1).forEach(c => {
                    if (c.contractType === 2 && c.partTimeType != null) {
                        currentPartTimeContract = true;
                        partTimeType = c.partTimeType;
                    }
                });

                if ((currentPartTimeContract || futurePartTimeContract) && employeeAvailabilities.length === 0) {
                  this.$helpers.OpenPopup({
                    type: 'datafill',
                    pointerDirection: 0,
                    componentState: {
                      entries: [],
                      description: this.$t('pages.employeeContext.availabilitySkills', [view.employee.firstName, view.employee.lastName,
                              currentPartTimeContract ? this.$t('pages.employeeContext.current') : this.$t('pages.employeeContext.future'), partTimeTypes.find(ptt => ptt.value === partTimeType).label]),
                      selectCallback: function (data) {
                          view.selectedPage = 'availabilityskills';
                      },
                      selectCallback2: function (data) {},
                      positiveButtonLabel: this.$t('pages.employeeContext.switchToAvailabilities'),
                      positiveButtonLabel2: this.$t('global.ui.accept'),
                    },
                    header: this.$t('pages.employeeContext.availabilities'),
                    centered: true,
                    remainAfterSelect: false,
                    expanded: true,
                  });
                }
            }
        },
        onImageReady() {
            this.scaleStr = "1";
            this.rotation = 0;
            this.hasImage = true;
        },
        commitCurrentEmployeeToStore(){
            this.$store.commit('setEmployeeMapEntry', this.employee);
        },
        saveClicked() {
            var view = this;
            var img = this.$refs.vueavatar.getImageScaled();
            var urlString = img.toDataURL();
            var seconds = new Date().getTime() / 1000;
            var imgFile = this.$helpers.dataURLtoFile(urlString, 'profile_picture_' + seconds + '.jpg');
            if (this.imageForNewEmployee) {
                this.newEmployeeProfilePicture = imgFile;
                this.newEmployeeProfilePictureBase64 = urlString;
                this.uploading = false;
                this.hasImage = false;
                this.imageUploadModal = false;
                this.uploadedImage = null;
                requestAnimationFrame(function () {
                    view.$forceUpdate();
                });
            } else {
                this.uploading = true;
                this.setEmployeePicture(this.employee.id, imgFile).then((result) => {
                    if (view.employee != undefined) {
                        view.employee.employeePicture = result.data.data;
                        view.commitCurrentEmployeeToStore();
                    }
                    for (let i = 0; i < view.employees.length; i++) {
                        if (view.employees[i].id == view.employee.id) {
                            view.employees[i].employeePicture = result.data.data;
                        }
                    }
                    for (let i = 0; i < view.dataFiltered.length; i++) {
                        if (view.dataFiltered[i].id == view.employee.id) {
                            view.dataFiltered[i].employeePicture = result.data.data;
                        }
                    }
                    view.$store.commit("setImgCacheTimestamp", {imgCacheTimestamp: Date.now()});
                    view.uploading = false;
                    view.hasImage = false;
                    view.imageUploadModal = false;
                    view.uploadedImage = null;
                    requestAnimationFrame(function () {
                        view.$forceUpdate();
                    });
                }).catch(error2 => {
                    view.uploading = false;
                    view.hasImage = false;
                    view.imageUploadModal = false;
                    view.uploadedImage = null;
                    console.log(error2);
                });
            }
        },
        saveDefaultClicked() {
            var view = this;
            var img = this.$refs.defaultvueavatar.getImageScaled();
            var urlString = img.toDataURL();
            var seconds = new Date().getTime() / 1000;
            var imgFile = this.$helpers.dataURLtoFile(urlString, 'profile_picture_' + seconds + '.jpg');
            this.uploading = true;
            this.setDefaultEmployeePicture(imgFile).then((result) => {
                view.uploading = false;
                view.hasImage = false;
                view.defaultImageUploadModal = false;
                view.uploadedImage = null;
                requestAnimationFrame(function () {
                    view.$forceUpdate();
                });
            }).catch(error2 => {
                view.uploading = false;
                view.hasImage = false;
                view.defaultImageUploadModal = false;
                view.uploadedImage = null;
                console.log(error2);
            });
        },
        prepareStoreEmployees(empls, employeeIdToSelect = null, force = false) {
            var app = this;
            var processed = [];
            empls.forEach(e => {
                if(employeeIdToSelect != null){
                    if(employeeIdToSelect != e.id) e.selected = false;
                }else{
                    e.selected = false;
                }
            });
            app.employees = empls;
            app.employees.sort((a, b) => {
                let aName = a.lastName + " " + a.firstName;
                let bName = b.lastName + " " + b.firstName;
                return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
            });
            app.gridData.data = app.employees;
            app.dataFiltered = app.gridData.data.slice();
            app.dataFiltered.sort((a, b) => {
                let aName = a.lastName + " " + a.firstName;
                let bName = b.lastName + " " + b.firstName;
                return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
            });
            app.updateEmployeeGridDataMetadata();
            let filtered = this.filterGridData();
            if (filtered.length > 0) {
                if(employeeIdToSelect != null && app.employee && app.employee.id != undefined && employeeIdToSelect != app.employee.id) app.employee.selected = false;
                //app.updateEmployeeGridDataMetadata();
                if (employeeIdToSelect) {
                    for (var i = 0; i < filtered.length; i++) {
                        if (filtered[i].id == employeeIdToSelect) {
                            console.log('Employee ID found and selected!');
                            app.employee = filtered[i];
                        }
                    }
                } else {
                    console.log('Employee ID to select not set or not found, selecting first employee');

                    app.employee = filtered[0];
                }

                app.savedEmployee = Object.assign({}, app.employee);
                app.employee.selected = true;
                this.$forceUpdate();
            }
        },
        updateEmployeeTypes: function (data) {
            var i;
            let ttypes = {}
            for (i = 0; i < data.length; i++) {
                var item = data[i];
                data[i]['label'] = item.name;
                ttypes[item.id] = item;
            }
            this.employeeTypeMap = ttypes;
            this.employeetypes = data;
            this.updateEmployeeGridDataMetadata();
        },
        employeeTypeUpdated(employee, employeeType){
            this.employees.forEach(empl => { if(empl.id == employee.id) empl.typeId = employeeType.id; });
            this.employee.typeId = employeeType.id;
            this.commitCurrentEmployeeToStore();
            this.employee.metadata = this.checkEmployeeData(this.employee, true);
            this.$forceUpdate();
        },
        employeeRulesUpdated(employee, ruleId){
            this.employees.forEach(empl => { if(empl.id == employee.id) empl.ruleId = ruleId; });
            this.employee.ruleId = ruleId;
            this.commitCurrentEmployeeToStore();
            this.employee.metadata = this.checkEmployeeData(this.employee, true);
            this.$forceUpdate();
        },
        employeeYouthWorkConfigUpdated(employee, youthWorkConfig){
            this.employees.forEach(empl => { if(empl.id == employee.id) empl.youthWorkConfigId = youthWorkConfig.id; });
            this.employee.youthWorkConfigId = youthWorkConfig.id;
            this.commitCurrentEmployeeToStore();
            this.employee.metadata = this.checkEmployeeData(this.employee, true);
            this.$forceUpdate();
        },
        employeeAvailablityAdded(availability){
            this.allEmployeeAvailabilities.push(availability);
            this.$store.commit('setEmployeeAvailabilityMapEntry', availability);
            this.$forceUpdate();
        },
        employeeAvailabilityUpdated(availability){
            for(var i = 0; i < this.allEmployeeAvailabilities.length; i++){
                let av = this.allEmployeeAvailabilities[i];
                if(av.id == availability.id){
                    this.allEmployeeAvailabilities[i] = availability;
                }
            }
            this.$store.commit('setEmployeeAvailabilityMapEntry', availability);
            this.$forceUpdate();
        },
        employeeAvailablityDeleted(deletedAvailability){
            const index = this.allEmployeeAvailabilities.findIndex(availability => availability.id === deletedAvailability.id);
            if (~index) {
                this.allEmployeeAvailabilities.splice(index, 1);
            }
            this.$store.commit('deleteEmployeeAvailabilityMapEntry', deletedAvailability);
            this.$forceUpdate();
        },
        employeeSkillAdded(employeeSkill){
            this.allEmployeeSkills.push(employeeSkill);
            this.$store.commit('setEmployeeSkillMapEntry', employeeSkill);
            this.$forceUpdate();
        },
        employeeSkillUpdated(employeeSkill){
            this.allEmployeeSkills.forEach((s) => {
                if(s.id == employeeSkill.id) s.value = employeeSkill.value;
            });
            this.$store.commit('setEmployeeSkillMapEntry', employeeSkill);
        },
        employeeSkillDeleted(deletedEmployeeSkill){
            const index = this.allEmployeeSkills.findIndex(eSkill => eSkill.id === deletedEmployeeSkill.id);
            if (~index) {
                this.allEmployeeSkills.splice(index, 1);
            }
            this.$store.commit('deleteEmployeeSkillMapEntry', deletedEmployeeSkill);
            this.$forceUpdate();
        },
        updateEmployeeRules: function (data) {
            var i;
            let trules = {}
            var rulesArray = [];
            for (i = 0; i < data.length; i++) {
                var item = data[i];
                rulesArray.push({
                    id: item.id,
                    name: item.name,
                    label: item.name,
                    rules: item
                });
                trules[item.id] = item;
            }
            this.employeeRulesMap = trules;
            this.employeerules = rulesArray;
            this.updateEmployeeGridDataMetadata();
        },
        updateEmployeeContracts: function (data) {
            var i;
            let tcontracts = {}
            for (i = 0; i < data.length; i++) {
                tcontracts[data[i].id] = data[i];
            }
            this.employeeContractMap = tcontracts;
            this.updateEmployeeGridDataMetadata();
        },
        updateEmployeeGridDataMetadata(){
            if(this.dataFiltered){
                this.dataFiltered.forEach(empl => {
                    empl['metadata'] = this.checkEmployeeData(empl, false);
                });
            }
            this.filterGridData();
            if (this.$refs.grid != undefined) this.$refs.grid.$forceUpdate();
        },
        loadContractFiles(contracts) {
            for (var i = 0; i < contracts.length; i++) {
                var contract = contracts[i];
                if (contract.fileId) {
                    let fileId = contract.fileId;
                    let view = this;
                    let url = '/api/sec/employeefile';

                    url = this.$helpers.appendParam("id", fileId, url, '/api/sec/employeefile');
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
                    url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

                    this.axios({
                        method: 'get',
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url
                    }).then((response) => {
                        var f = response.data;
                        this.contractFiles[f.id] = f;
                    });
                }
            }
        },
        updateCollectiveContracts: function (data) {
            let collectiveContracts = [];
            for (let i = 0; i < data.length; i++) {
                data[i]['allowed'] = false;
                collectiveContracts.push(data[i]);
            }
            this.collectiveContracts = collectiveContracts;
        },
        loadAllowedContracts: function (force) {
            this.$helpers.GetEmployeeTypeTemplateMap().then((map) => {
                return this.$helpers.GetAllowedContractMap(force);
            }).then((map) => {
                this.updateAllowedContracts(Object.values(map));
            });
        },
        updateAllowedContracts: function (data) {
            for (let i = 0; i < data.length; i++) {
                var cur = data[i];
                this.collectiveContracts.forEach(c => {
                    if(c.id == cur.collectiveContractId){
                        c.allowed = true;
                    }
                });
            }
            this.updateEmployeeGridDataMetadata();
        },
        createAllowedContracts: function(items, collectiveContractId){

            let view = this;
            let url = '/api/sec/allowedcontract/multi';

            let params = {
                storeId: this.$store.state.storeId,
            };

            let payload = {
                requests: []
            }
            items.forEach(i => {
                let req = {
                    collectiveContractId: collectiveContractId,
                    weekTimeRegular: i.weekTimeRegular,
                    weekWorkDaysRegular: i.weekWorkDaysRegular,
                    workTimeFactor: this.storeSettings.workTimeFactor,
                    additionalMonthWorkTime: 0,
                    monthTimeRegular: Math.round(i.weekTimeRegular*(this.storeSettings.workTimeFactor/Math.pow(10,7)))
                }
                payload.requests.push(req)
            })

            if(payload.requests.length == 0){
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.noContractModelsCreated'));
            } else {
                this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {

                    view.$store.commit("invalidateState", {states: ["employeeTypeTemplateMapState", "employeeTypeMapState", "allowedContractMapState"]});
                    view.refresh(null, true, true);
                    view.$helpers.success(view.$t('global.notifications.success'), (view.storeSettings.country == 1 ? this.$t('store.collectiveContracts.title') : this.$t('store.modelContracts')) +' wurden erfolgreich hinzugefügt');
                }).catch(function (error) {

                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.addedError'));
                })
            }



        },
        updateSpots: function (data = null) {
            if(!data){
                data = this.spotArray;
            }
            var i;
            let tspots = {};
            var spotsArray = [];
            for (i = 0; i < data.length; i++) {
                let item = data[i];
                item.label = item.name;
                tspots[item.id] = item;
                spotsArray.push(item);
            }
            this.spotMap = tspots;
            this.spots = spotsArray;
        },
        employeeTypeForEmployee(employee) {
            var type = this.employeeTypeMap[employee.typeId];
            return type;
        },
        employeeRulesForEmployee(employee, rulesOnly=true) {
            var rules = this.employeeRulesMap[employee.ruleId];
            if (rules) {
                if(rulesOnly){
                    return rules.rules;
                }
            }
            return rules;
        },
        employeeContractForEmployee(employee, date  = null) {
            let contract;
            Object.values(this.employeeContractMap).forEach(c => {
                if(c.employeeId == employee.id){
                    if (this.contractType(c, date) == 1) {
                        contract = c;
                    }
                }
            });
            return contract;
        },
        earliestFutureContractForEmployee(employee){
            let contract = null;
            let td = this.$helpers.getMomentTZ().startOf('day');
            Object.values(this.employeeContractMap).forEach(c => {
                if(c.employeeId == employee.id){
                    let contractFrom = this.$helpers.getMomentFromStringTZ(c.from);
                    if(contractFrom >= td){
                        if(contract == null){
                            contract = c;
                        } else {
                            let currentFrom = this.$helpers.getMomentFromStringTZ(contract.from);
                            if(contractFrom < currentFrom){
                                contract;
                            }
                        }
                    }
                }
            })
            return contract;
        },
        employeeContractsForEmployeeWithType(employee, type, date = null) {
            var c = [];
            var keys = Object.keys(this.employeeContractMap);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (this.employeeContractMap[key].employeeId == employee.id) {
                    let contract = this.employeeContractMap[key];
                    if (this.contractType(contract, date) == type) c.push(contract);
                }
            }
            return c;
        },
        employeeAvailabilitiesForEmployee(employee){
            var result = [];
            this.allEmployeeAvailabilities.forEach(av => {
                if(av.employeeId == employee.id) result.push(av);
            });
            return result;
        },
        employeeWorkbalancesForEmployee(employee){
            var result = [];
            this.employeeWorkbalances.forEach(b => {
                if(b.employeeId == employee.id) result.push(b);
            });
            return result;
        },
        employeeSkillsForEmployee(employee){
            var result = [];
            this.allEmployeeSkills.forEach(sk => {
                if(sk.employeeId == employee.id) result.push(sk);
            });
            return result;
        },
        contractType(c, date = null) {
            let now = this.$helpers.getMomentTZ();
            if(date){
                now = date;
            }
            let fromDate = this.$helpers.getMomentFromStringTZ(c.from);
            if (c.to) {
                let toDate = this.$helpers.getMomentFromStringTZ(c.to);
                if (toDate < now) {
                    return 0;
                }
            }
            if (fromDate < now) return 1;
            if (fromDate > now) return 2;
            return -1;
        },
        employeeContractAdded(contract) {
            this.employeeContractMap[contract.id] = contract;
            this.$store.commit('setEmployeeContractMapEntry', contract);
            this.$store.commit("invalidateState", {states: ['currentMonthEmployeeContractMapState']});
            this.$forceUpdate();
            this.refresh(this.employee.id, true);
        },
        employeeContractUpdated(contract) {
            this.employeeContractMap[contract.id] = contract;
            this.$store.commit('setEmployeeContractMapEntry', contract);
            this.$store.commit("invalidateState", {states: ['currentMonthEmployeeContractMapState']});
            this.$forceUpdate();
            this.refresh(this.employee.id, true);
        },
        employeeContractDeleted(contract) {
            delete this.employeeContractMap[contract.id];
            this.$store.commit('deleteEmployeeContractMapEntry', contract);
            this.$store.commit("invalidateState", {states: ['currentMonthEmployeeContractMapState']});

            this.$forceUpdate();
            this.refresh(this.employee.id, true);
        },
        contractFileAdded(contractId, contractFile) {
            var c = this.employeeContractMap[contractId];
            c.fileId = contractFile.id;
            this.$store.commit('setEmployeeContractMapEntry', c);
            let docs = this.$refs.documents;
            if(docs != null){
                docs.refresh();
            }

        },
        contractFileDeleted(fileId) {
            var keys = Object.keys(this.employeeContractMap);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (this.employeeContractMap[key].fileId == fileId) {
                    this.unlinkContractFile(this.employeeContractMap[key].id);
                }
            }
        },
        contractApproved(contractId) {
            this.employeeContractMap[contractId].approved = true;
            this.refresh(this.employee.id, true);
        },
        unlinkContractFile(contractId) {
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeecontract';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
            url = this.$helpers.appendParam("employeeId", this.employee.id, url, '/api/sec/employeecontract');

            let payload = {
                id: contractId,
                fileId: "",
                approved: false,
                approvedBy: "",
                approvalDate: "",
                updateFields: ["fileId", "approved", "approvedBy", "approvalDate"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.employeeContractMap[contractId].fileId = null;
                view.employeeContractMap[contractId].approved = false;
                delete view.employeeContractMap[contractId].approvedBy;
                delete view.employeeContractMap[contractId].approvalDate;
                view.$store.commit('setEmployeeContractMapEntry', view.employeeContractMap[contractId]);
                view.$forceUpdate();
                view.$refs.employeecontract.$forceUpdate();
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            });
        },
        UploadImage(forNewEmployee) {
            if(this.employee != null && !this.employee.dummy){
                this.imageForNewEmployee = forNewEmployee;
                this.imageUploadModal = true;
            }

        },
        UploadDefaultImage() {
            this.defaultImageUploadModal = true;
        },
        GetProfilePictureUrl(employee, size = null, urlOnly = false) {
            if (employee.employeePicture == null || this.anonMode) {
                var port = location.port;
                var url = location.protocol + '//' + location.hostname + '/img/avatar_white.png';
                if(port != "80" && port != "443"){
                    url = location.protocol + '//' + location.hostname + ':' + location.port + '/img/avatar_white.png';
                }

                if(urlOnly) return url;
                return 'var(--contrast-1) no-repeat center/cover url(/img/avatar.png)';
            } else {
                var imgUrl = employee.employeePicture.server + "/api/file?id=" + employee.employeePicture.fileId + "&accessToken=" + employee.employeePicture.accessToken + '&s=' + this.imgCacheTimestamp;
                if (size) imgUrl = imgUrl + '&thumb=' + size;
                if(urlOnly) return imgUrl;
                return 'var(--contrast-1) no-repeat center/cover  url(' + imgUrl + ')';
            }
        },
        setEmployeePicture(employeeId, profilePictureFile) {
            let view = this;
            let url = '/api/sec/employee/picture';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/picture');
            let formData = new FormData();
            formData.append("employeeId", employeeId);
            formData.append('file', profilePictureFile);

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt,
                    'Content-Type': 'multipart/form-data'
                },
                url: url,
                data: formData
            }).catch(error =>
                Promise.reject({
                    msg: view.$t('pages.employeeContext.profileImageError')
                })
            )
        },
        setDefaultEmployeePicture(profilePictureFile) {
            let view = this;
            let url = '/api/sec/employee/picture/default';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/picture/default');
            let formData = new FormData();
            formData.append('file', profilePictureFile);

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt,
                    'Content-Type': 'multipart/form-data'
                },
                url: url,
                data: formData
            }).catch(error =>
                Promise.reject({
                    msg: view.$t('pages.employeeContext.profileImageError')
                })
            )
        },
        deleteEmployeePicture(employeeId) {
            let view = this;
            window.app.popupalerts.push({header: this.$t('pages.employeeContext.deleteEmployeePicture'),
                description: this.$t('pages.employeeContext.deleteImageQuery'),
                hidden: false,
                callbackAccept: function(popup){
                    popup.loading = true;

                    let url = '/api/sec/employee/picture';

                    let params = {
                        storeId: view.$store.state.storeId,
                        id: employeeId
                    }

                    view.axios({
                        method: 'delete',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + view.$store.state.jwt,
                            'Content-Type': 'multipart/form-data'
                        },
                        url: url,
                    }).then(response => {
                        popup.loading = false;
                        popup.hidden = true;
                        view.employee.employeePicture = null;
                        view.commitCurrentEmployeeToStore();

                        view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.ui.deletedX', [view.$t('pages.employeeContext.image')]));
                    }).catch(error => {
                        popup.loading = false;
                        popup.hidden = true;
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deletedErrorX', [view.$t('pages.employeeContext.image')]));
                    });
                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;

            }});
        },
        ChangeEmployee(employee) {
            for (var x in this.gridData.data) {
                this.gridData.data[x].selected = false;
            }

            this.employee = employee;
            this.savedEmployee = Object.assign({}, this.employee);
            this.employee.selected = true;

            this.checkEmployeeData(this.employee, true);
            this.editing = false;
            if(!this.employeeContract && this.selectedPage == 'plantype') this.selectedPage = 'coredata';
        },
        employeeWithId(id){
            let empl;
            this.employees.forEach((e) => {
                if(e.id == id) {
                    empl = e;
                }
            });
            return empl;
        },
        reloadEmployeeFiles(force = true){
            let view = this;
            this.$helpers.GetEmployeeFilesMap(force)
            .then((map) => {
                view.LoadFilterDropdown();
            }).catch(error => {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.errorLoadingDocuments'));
            });
        },

        checkEmployeeData(employee, updateUi){
            var active = employee.active;
            var warnings = [];
            var severity = 'none';
            var link = '';
            var color = 'var(--col-ok)';
            var buttonVariants = this.defaultButtonVariants();
            if(!active){
                buttonVariants = {
                    'coredata': '',
                    'contract': '',
                    'documents': '',
                    'plantype': '',
                    'availabilityskills': '',
                    'useraccount': ''
                };
                severity = 'inactive';
                warnings.push(this.$t('pages.employeeContext.employeeDeactivated'));
                link = 'coredata';
            }else{
                //console.log('Check employee data for ' + employee.firstName + ' ' + employee.lastName);
                var emplContract = this.employeeContractForEmployee(employee);
                var emplType = this.employeeTypeForEmployee(employee);
                var emplRules = this.employeeRulesForEmployee(employee);
                var pastContracts = this.employeeContractsForEmployeeWithType(employee, 0);
                var futureContracts = this.employeeContractsForEmployeeWithType(employee, 2);
                var emplSkills = this.employeeSkillsForEmployee(employee);
                var emplDocuments = [];
                if(!emplContract){
                    severity = this.updateSeverity(severity, 'info');
                    buttonVariants.contract = this.updateSeverity(buttonVariants.contract, 'info');
                    if(pastContracts.length > 0){
                        warnings.push(this.$t('pages.employeeContext.invalidContract'));
                        link = 'contract';
                    }
                    if(futureContracts.length > 0){
                        warnings.push(this.$t('pages.employeeContext.notYetValid'));
                        if(emplType){
                            buttonVariants.plantype = this.updateSeverity(buttonVariants.plantype, 'info');
                        }else{
                            buttonVariants.plantype = this.updateSeverity(buttonVariants.plantype, 'warning');
                        }
                        link = 'contract';
                    }
                    if(pastContracts.length == 0 && futureContracts.length == 0){
                        warnings.push(this.$t('pages.employeeContext.noValidContract'));
                        if(emplType){
                            buttonVariants.plantype = this.updateSeverity(buttonVariants.plantype, 'info');
                        }else{
                            buttonVariants.plantype = this.updateSeverity(buttonVariants.plantype, 'warning');
                        }
                        link = 'contract';
                    }
                }

                if(this.storeSettings && !this.storeSettings.simpleMode){
                    if(emplContract && emplType){
                        // check diff contract <--> plantype
                        var ccId = emplContract.collectiveContractId;
                        var cc;
                        if(this.collectiveContracts){
                            this.collectiveContracts.forEach(c => {if(c.id == ccId) cc = c; });
                        }
                        var contractWeek = emplContract.weekTimeRegular;
                        if(cc) contractWeek = cc.weekTimeRegular;
                        var et = emplType;
                        if(et){
                            var etWeek = et.weekTimeRegular;
                            var diff = Math.abs(((etWeek/contractWeek) - 1) * 100);
                            if(diff > 5){
                                //console.log('diff contract <--> employeetype: ' + diff);
                                buttonVariants.plantype = this.updateSeverity(buttonVariants.plantype, 'warning');
                                severity = this.updateSeverity(severity, 'warning');
                                link = 'plantype';
                                warnings.push(this.$t('pages.employeeContext.deviationHourContract'));
                            }
                        }
                    }
                    if(emplContract && !emplType){
                        //console.log('employee type missing')
                        buttonVariants.plantype = this.updateSeverity(buttonVariants.plantype, 'danger');
                        severity = this.updateSeverity(severity, 'danger');
                        link = 'plantype';
                        warnings.push(this.$t('pages.employeeContext.noPlanningContext'));
                    }
                    if(emplContract && emplType && !emplRules){
                        buttonVariants.plantype = this.updateSeverity(buttonVariants.plantype, 'danger');
                        severity = this.updateSeverity(severity, 'danger');
                        link = 'plantype';
                        warnings.push(this.$t('pages.employeeContext.noFreeTimeOptions'));
                    }
                }



                if(!emplSkills || emplSkills.length == 0){
                    buttonVariants.availabilityskills = this.updateSeverity(buttonVariants.availabilityskills, 'danger');
                    severity = this.updateSeverity(severity, 'danger');
                    link = 'availabilityskills';
                    warnings.push(this.$t('pages.employeeContext.noSkills'));
                }
                if(!employee.accountId){
                    buttonVariants.useraccount = this.updateSeverity(buttonVariants.useraccount, 'warning');
                }
            }
            var icon = "";
            switch(severity){
                case 'info':
                    color = 'var(--col-info)';
                    icon = 'info-circle';
                    break;
                case 'warning':
                    color = 'var(--col-warning)';
                    icon = 'exclamation-circle';
                    break;
                case 'danger':
                    color = 'var(--col-danger)';
                    icon = 'exclamation';
                    break;
                case 'inactive':
                    color = 'var(--contrast-1)';
                    icon = 'info-circle';
            }
            var data = {
                'severity': severity,
                'warnings': warnings,
                'icon': icon,
                'link': link,
                'color': color,
                'buttonVariants': buttonVariants
            };

            if(updateUi){
                this.buttonVariants = this.defaultButtonVariants();
                this.buttonVariants = buttonVariants;
            }
            return data;
        },
        defaultButtonVariants(){
            return {
                'coredata': 'success',
                'contract': 'success',
                'documents': 'success',
                'plantype': 'success',
                'availabilityskills': 'success',
                'workingtimeaccount': 'success',
                'useraccount': 'success',
            };
        },
        updateSeverity(curVal, newVal){
            var sev = 'info';
            if(curVal == 'none' || curVal == 'info') return newVal;
            if(curVal == 'warning' && newVal == 'danger') return newVal;
            if(curVal == 'danger') return curVal;
            return newVal;
        },
        employeeWarningsTooltipText(){
            var warnings = this.employeeWarnings.warnings;
            var txt = "";
            for (var i = 0; i < warnings.length; i++){
                if(i > 0) txt += " | ";
                txt += warnings[i];
            }
            return txt;
        },
        Init(items, config) {},
        hideModal(ref) {
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },
        openMultiUpdatePaymentPopup() {
            let view = this;
            //first find all current active contracts
            let now = this.$helpers.getMomentTZ().startOf('day');
            let employeeItems = Object.values(this.employeeMap).filter(employee => {
                if(employee.active && view.employeeEmployeeContractMap[employee.id] != null && view.employeeEmployeeContractMap[employee.id].length > 0){
                    return true;
                } else {
                    return false;
                }
            }).map(employee => {return {label: employee.lastName+" "+employee.firstName, value: employee.id}})
            employeeItems.sort((a,b)=> {
                if(a.label.toUpperCase() < b.label.toUpperCase()){
                    return -1;
                } else if (a.label.toUpperCase() < b.label.toUpperCase()){
                    return 1;
                }
                return 0;
            })
            let paymentTypeItems = this.uiData.paymentTypes.map(item => {return {label: item.label_de, value: item.id}} );
            let wageTypeItems = this.uiData.wageTypes.map(item => {return {label: item.label_de, value: item.id, selected: item.id == 4}} );
            let nightWorkModeItems = this.uiData.nightWorkModes.map(item => {return {label: item.label_de, value: item.id}} );
            let allowedContractItems = Object.values(this.allowedContractMap).sort((a, b) => a.weekTimeRegular-b.weekTimeRegular).map(item => {
                let cc = view.collectiveContractMap[item.collectiveContractId]
                return {label: cc.name+" "+(item.weekTimeRegular/60.0).toFixed(2)+"h/"+item.weekWorkDaysRegular+"T", value: item.id }
            })
            let employmentModelItems = Object.values(this.employmentModelMap).sort((a, b) => a.name.localeCompare(b.name)).map(item => {return {label: item.name, value: item.id}})
            let employmentGroups = new Set();
            Object.values(this.employeeContractMap).forEach(c => {
                if(c.employmentGroup != null){
                    employmentGroups.add(c.employmentGroup);
                }
            });
            let employmentGroupItems = Array.from(employmentGroups).sort((a, b) => a.localeCompare(b)).map(item => {return {label: item, value: item}});

            let wageGroups = new Set();
            Object.values(this.employeeContractMap).forEach(c => {
                if(c.mlWageGroup != null && view.mlWageGroupMap[c.mlWageGroup] != null){
                    wageGroups.add(view.mlWageGroupMap[c.mlWageGroup]);
                }
            });
            let wageGroupItems = Array.from(wageGroups).sort((a, b) => a.name.localeCompare(b.name)).map(item => {return {label: item.name, value: item.id}});

            let dataEntries = [];
            dataEntries.push({label: this.$t('pages.employeeContext.selectByContractModel'), key: 'selectByCollectiveContract', hidden: false, type: 'bool', value: false, });
            dataEntries.push({label: this.$t('pages.employeeContext.selectByEmploymentModel'), key: 'selectByEmploymentModel', hidden: false, type: 'bool', value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByCollectiveContract');
                    let flag2 = datafill.entries.find(i => i.key == 'selectByEmploymentGroup');
                    let flag3 = datafill.entries.find(i => i.key == 'selectByWageGroup');

                    if(flag1.value || flag2.value || flag3.value){
                        entryBeforeUpdate.value = false;
                        entryBeforeUpdate.hidden = true;
                    }  else  {
                        entryBeforeUpdate.hidden = false;
                    }


                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContext.selectByEmploymentGroup'), key: 'selectByEmploymentGroup', hidden: false, type: 'bool', value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByCollectiveContract');
                    let flag2 = datafill.entries.find(i => i.key == 'selectByEmploymentModel');
                    let flag3 = datafill.entries.find(i => i.key == 'selectByWageGroup');

                    if(flag1.value || flag2.value || flag3.value){
                        entryBeforeUpdate.value = false;
                        entryBeforeUpdate.hidden = true;
                    }  else  {
                        entryBeforeUpdate.hidden = false;
                    }


                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContext.selectByTariffGroup'), key: 'selectByWageGroup', hidden: false, type: 'bool', value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByCollectiveContract');
                    let flag2 = datafill.entries.find(i => i.key == 'selectByEmploymentModel');
                    let flag3 = datafill.entries.find(i => i.key == 'selectByEmploymentGroup');

                    if(flag1.value || flag2.value || flag3.value){
                        entryBeforeUpdate.value = false;
                        entryBeforeUpdate.hidden = true;
                    }  else  {
                        entryBeforeUpdate.hidden = false;
                    }


                    return entryBeforeUpdate;
                }
            });

            dataEntries.push({label: this.$t('global.ui.allEmployees'), key: 'allEmployees', hidden: false, type: 'bool', value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByCollectiveContract');
                    let flag2 = datafill.entries.find(i => i.key == 'selectByEmploymentModel');
                    let flag3 = datafill.entries.find(i => i.key == 'selectByEmploymentGroup');
                    let flag4 = datafill.entries.find(i => i.key == 'selectByWageGroup');

                    if(flag1.value || flag2.value || flag3.value || flag4.value){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    } else {
                        entryBeforeUpdate.hidden = false;

                    }
                    if(entryBeforeUpdate.value){
                        flag1.value = false;
                        flag1.hidden = true;
                        flag2.value = false;
                        flag2.hidden = true;
                        flag3.value = false;
                        flag3.hidden = true;
                        flag4.value = false;
                        flag4.hidden = true;
                    } else {
                        flag1.hidden = flag2.value || flag3.value || flag4.value;
                        flag2.hidden = flag1.value || flag3.value || flag4.value;
                        flag3.hidden = flag1.value || flag2.value || flag4.value;
                        flag4.hidden = flag1.value || flag2.value || flag3.value;
                    }

                    return entryBeforeUpdate;
                }
            });

            dataEntries.push({label: this.$t('store.modelContracts'), key: 'allowedContracts', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: allowedContractItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByCollectiveContract').value;

                    if(flag1){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }

            });
            dataEntries.push({label: this.$t('pages.employeeContext.employmentModels'), key: 'employmentModels', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employmentModelItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByEmploymentModel').value;

                    if(flag1){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }

            });
            dataEntries.push({label: this.$t('pages.employeeContext.employmentGroups'), key: 'employmentGroups', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employmentGroupItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByEmploymentGroup').value;

                    if(flag1){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }

            });
            dataEntries.push({label: this.$t('pages.employeeContext.tariffGroups'), key: 'wageGroups', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: wageGroupItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByWageGroup').value;

                    if(flag1){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }

            });
            dataEntries.push({label: this.$t('pages.employeeContext.exempt'), key: 'exceptEmployees', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employeeItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByCollectiveContract').value;
                    let flag2 = datafill.entries.find(i => i.key == 'selectByEmploymentModel').value;
                    let flag3 = datafill.entries.find(i => i.key == 'selectByEmploymentGroup').value;
                    let flag4 = datafill.entries.find(i => i.key == 'selectByWageGroup').value;
                    if(flag1 || flag2 || flag3 || flag4){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }

            });
            dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: false,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employeeItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag1 = datafill.entries.find(i => i.key == 'selectByCollectiveContract').value;
                    let flag2 = datafill.entries.find(i => i.key == 'allEmployees').value;
                    let flag3 = datafill.entries.find(i => i.key == 'selectByEmploymentModel').value;
                    let flag4 = datafill.entries.find(i => i.key == 'selectByEmploymentGroup').value;
                    let flag5 = datafill.entries.find(i => i.key == 'selectByWageGroup').value;
                    if(flag1 || flag2 || flag3 || flag4 || flag5){
                        entryBeforeUpdate.hidden = true;
                    } else {
                        entryBeforeUpdate.hidden = false;

                    }

                    return entryBeforeUpdate;
                }

            });
            dataEntries.push({label: this.$t('pages.employeeContext.adjustWage'), key: 'updatePayment', hidden: false, type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContract.paymentType'), key: 'paymentType', type: 'dropdownsearch', hidden: view.$helpers.CheckDatafillKeysForHidden('updatePayment'),
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectFirst: true,
                    items: paymentTypeItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let paymentFlag = datafill.entries.find(i => i.key == 'updatePayment').value;
                    let selectByWageGroup = datafill.entries.find(i => i.key == 'selectByWageGroup').value;
                    if(paymentFlag && !selectByWageGroup){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContract.wageType'), key: 'wageType', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectedItem: wageTypeItems.find(i => i.value == 4),
                    items: wageTypeItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let paymentFlag = datafill.entries.find(i => i.key == 'updatePayment').value;
                    let paymentTypeFlag = datafill.entries.find(i => i.key == 'paymentType').value;
                    let selectByWageGroup = datafill.entries.find(i => i.key == 'selectByWageGroup').value;
                    if(paymentFlag && paymentTypeFlag == 2 && !selectByWageGroup){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContract.payment'), key: 'payment', hidden: view.$helpers.CheckDatafillKeysForHidden('updatePayment'), type: 'text', value: '0',
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let paymentFlag = datafill.entries.find(i => i.key == 'updatePayment').value;
                    let selectByWageGroup = datafill.entries.find(i => i.key == 'selectByWageGroup').value;
                    if(paymentFlag && !selectByWageGroup){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContext.adjustAdditionalPayment'), key: 'updateExtraPayment', hidden: false, type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContract.extraPayment'), key: 'extraPayment', hidden: view.$helpers.CheckDatafillKeysForHidden('updateExtraPayment'), type: 'text', value: '0'});

            dataEntries.push({label: this.$t('pages.employeeContext.adjustOvertimeBonus'), key: 'updateOvertimeBonus', hidden: false, type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContract.overtimeBonusHour'), key: 'overtimeBonusHour', hidden: view.$helpers.CheckDatafillKeysForHidden('updateOvertimeBonus'), type: 'text', value: '0'});
            dataEntries.push({label: this.$t('pages.employeeContract.overtimeBonusFlat'), key: 'overtimeBonusShift', hidden: view.$helpers.CheckDatafillKeysForHidden('updateOvertimeBonus'), type: 'text', value: '0'});

            dataEntries.push({label: this.$t('pages.employeeContext.adjustNightWork'), key: 'updateNightWork', hidden: false, type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContext.adjustNightWorkActive'), key: 'updateExistingNightWorkOnly', hidden: view.$helpers.CheckDatafillKeysForHidden('updateNightWork'), type: 'bool', value: true});
            dataEntries.push({label: this.$t('pages.employeeContext.deactivateNightWork'), key: 'deactivateNightWork', hidden: view.$helpers.CheckDatafillKeysForHidden('updateNightWork'), type: 'bool', value: false});

            dataEntries.push({label: this.$t('pages.employeeContext.adjustNightWorkInterval'), key: 'updateNightWorkTimes', hidden: view.$helpers.CheckDatafillKeysForHidden('updateNightWork'), type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContract.nightWorkFrom'), key: 'nightWorkFrom', hidden: view.$helpers.CheckDatafillKeysForHidden('updateNightWorkTimes'), type: 'timeframe', value: this.$helpers.getMomentTZ().startOf('day').hours(22), focusProceedKey: 'nightWorkTo'}),
            dataEntries.push({label: this.$t('pages.employeeContract.nightWorkTo'), key: 'nightWorkTo', hidden: view.$helpers.CheckDatafillKeysForHidden('updateNightWorkTimes'), type: 'timeframe', value: this.$helpers.getMomentTZ().startOf('day').hours(6)}),

            dataEntries.push({label: this.$t('pages.employeeContext.adjustMinNightWork'), key: 'updateMinNightWorkTime', hidden: view.$helpers.CheckDatafillKeysForHidden('updateNightWork'), type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContext.minNightWork'), key: 'minNightWorkTime', hidden: view.$helpers.CheckDatafillKeysForHidden('updateMinNightWorkTime'), type: 'slider',
            value: 0,
            slider: {
                min: 0,
                max: 12*60,
                value: 0,
                hideMin: true,
                hideMax: true,
                step: 15,
                DisplayLabel: (x) => { return (x/60.0).toFixed(2)+'h';},
                inputControl: true,
                sliderInput: (x) => {return (x * 60.0)},
                labelToInt: (x) => {return x.slice(0, -1)},
            }})

            dataEntries.push({label: this.$t('pages.employeeContext.adjustNightWorkMode'), key: 'updateNightWorkMode', hidden: view.$helpers.CheckDatafillKeysForHidden('updateNightWork'), type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContext.nightWorkMode'), key: 'nightWorkMode', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: false,
                    styleLight: true,
                    items: nightWorkModeItems,
                    selectFirst: true,

                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag = datafill.entries.find(i => i.key == 'updateNightWork').value;
                    let flag2 = datafill.entries.find(i => i.key == 'updateNightWorkMode').value;

                    if(flag && flag2){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContext.nightWorkBonusAsPercentage'), key: 'useNightWorkBonusHourPercentage', hidden: true, type: "bool", value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag = datafill.entries.find(i => i.key == 'updateNightWork').value;
                    let flag2 = datafill.entries.find(i => i.key == 'updateNightWorkMode').value;
                    let mode = datafill.entries.find(i => i.key == 'nightWorkMode').value;
                    if((flag && !flag2) || (flag && flag2 && (mode == 1 || mode == 3 || mode == 5))){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContext.percentageRate'), key: 'nightWorkBonusPercentage', hidden: true, type: 'slider', value: 0,
                slider: {min: 0, max: 100, value: 0, step: 1, hideMin: true, hideMax: true, inputControl: true,
                    sliderInput: (x) => {return x}, labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (x) => {return x + '%'}, shorterDisplayLabel: (x) => {return x}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag = datafill.entries.find(i => i.key == 'useNightWorkBonusHourPercentage').value;

                    if(flag){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.slider.value = 0;
                        entryBeforeUpdate.value = 0

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContract.nightWorkBonusHour'), key: 'nightWorkBonusHour', hidden: true, type: 'text', value: '0',
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag = datafill.entries.find(i => i.key == 'updateNightWork').value;
                    let flag2 = datafill.entries.find(i => i.key == 'updateNightWorkMode').value;
                    let flag3 = datafill.entries.find(i => i.key == 'useNightWorkBonusHourPercentage').value;
                    let mode = datafill.entries.find(i => i.key == 'nightWorkMode').value;
                    if(((flag && !flag2) || (flag && flag2 && (mode == 1 || mode == 3 || mode == 5))) && !flag3){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = '0'

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContract.nightWorkBonusFlat'), key: 'nightWorkBonusShift', hidden: true, type: 'text', value: '0',
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let flag = datafill.entries.find(i => i.key == 'updateNightWork').value;
                    let flag2 = datafill.entries.find(i => i.key == 'updateNightWorkMode').value;
                    let mode = datafill.entries.find(i => i.key == 'nightWorkMode').value;
                    if((flag && !flag2) || (flag && flag2 && (mode == 1 || mode == 2 || mode == 4))){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = '0'

                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: this.$t('pages.employeeContext.adjustEmploymentGroup'), key: 'updateEmploymentGroup', hidden: true, type: 'bool', value: false});
            dataEntries.push({label: this.$t('pages.employeeContract.employmentGroup'), key: 'employmentGroup', hidden: view.$helpers.CheckDatafillKeysForHidden('updateEmploymentGroup'), type: 'text', value: ''});

            dataEntries.push({label: this.$t('pages.employeeContext.adjustComment'), key: 'updateComment', hidden: false, type: 'bool', value: false});
            dataEntries.push({label: this.$t('global.general.comment'), key: 'comment', hidden: view.$helpers.CheckDatafillKeysForHidden('updateComment'), type: 'text', value: ''});


            dataEntries.push({label: this.$t('pages.employeeContext.adjustContractsDirectly'), key: 'updateCurrent', hidden: false, type: 'bool', value: false});
            let changeDate = this.$helpers.getMomentTZ().add(1, 'months').startOf('month');
            dataEntries.push({label: this.$t('pages.employeeContract.changeDate'), key: 'changeDate', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('updateCurrent'), type: 'date', value: changeDate}),

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {

                    entries: dataEntries,
                    selectCallback: function (data) {
                        let now = view.$helpers.getMomentTZ().startOf('day');
                        let currentContracts = [];
                        let updatableContracts = [];
                        let updateFieldsMap = {};
                        let cowMap = {};
                        Object.keys(view.employeeEmployeeContractMap).forEach(key => {
                            let employmentModelId = view.employeeMap[key].remoteId != null ? (view.employeeEmploymentModelMap[view.employeeMap[key].remoteId] != null ? view.employeeEmploymentModelMap[view.employeeMap[key].remoteId].employmentModelId : null): null;

                            if(data.allEmployees ||
                               data.employees.includes(key) ||
                               (data.selectByCollectiveContract && !data.exceptEmployees.includes(key)) ||
                               (data.selectByEmploymentGroup && !data.exceptEmployees.includes(key)) ||
                               (data.selectByWageGroup && !data.exceptEmployees.includes(key)) ||
                               (data.selectByEmploymentModel && !data.exceptEmployees.includes(key) && data.employmentModels.includes(employmentModelId))){

                                let contracts = view.employeeEmployeeContractMap[key];

                                if(data.selectByCollectiveContract && contracts != null){
                                    contracts = contracts.filter(c => data.allowedContracts.includes(c.collectiveContractId));
                                }
                                if(data.selectByEmploymentGroup && contracts != null){
                                    contracts = contracts.filter(c => data.employmentGroups.includes(c.employmentGroup));
                                }
                                if(data.selectByWageGroup && contracts != null){
                                    contracts = contracts.filter(c => data.wageGroups.includes(c.mlWageGroup));
                                }

                                if(data.updateCurrent){
                                    //get current active contract

                                    let currentContract = contracts.find(c => {
                                        let cFrom = view.$helpers.getMomentFromStringTZ(c.from);
                                        let cTo = c.to != null ? view.$helpers.getMomentFromStringTZ(c.to) : null;
                                        if(cFrom <= now && (cTo == null || cTo > now)){
                                            return true;
                                        } else {
                                            return false;
                                        }

                                    })
                                    if(currentContract != null){
                                        currentContracts.push(currentContract);
                                        cowMap[currentContract.id] = false;
                                    }
                                } else {
                                    //changeDate exists
                                    //first find all contracts where from == changeDate, because those need to be updated directly

                                    let currentContract = contracts.find(c => {
                                        let cFrom = view.$helpers.getMomentFromStringTZ(c.from);

                                        if(cFrom.year() == data.changeDate.year() && cFrom.month() == data.changeDate.month() && cFrom.date() == data.changeDate.date()){
                                            return true;
                                        } else {
                                            return false;
                                        }

                                    })
                                    if(currentContract != null){
                                        currentContracts.push(currentContract);
                                        cowMap[currentContract.id] = false;
                                    } else {
                                        //find contract where changeDate lies within contract from - to range
                                        let cowContract = contracts.find(c => {
                                            let cFrom = view.$helpers.getMomentFromStringTZ(c.from);
                                            let cTo = c.to != null ? view.$helpers.getMomentFromStringTZ(c.to) : null;
                                            if(cFrom < data.changeDate && (cTo == null || cTo > data.changeDate)){
                                                return true;
                                            } else {
                                                return false;
                                            }

                                        })
                                        if(cowContract != null){
                                            currentContracts.push(cowContract);
                                            cowMap[cowContract.id] = true;
                                        }
                                    }

                                }

                            }
                        })
                        //view.sendActivationEmail();
                        currentContracts.forEach(c => {
                            let contractCopy = Object.assign({}, c);
                            updateFieldsMap[contractCopy.id] = [];
                            let updateFlag = false;
                            if(cowMap[contractCopy.id] == true){
                                contractCopy.from = data.changeDate.format();
                            }
                            if(data.updateEmploymentGroup){
                                contractCopy.employmentGroup = data.employmentGroup;
                                updateFieldsMap[contractCopy.id].push("employmentGroup");
                                updateFlag = true;
                            }
                            if(data.updatePayment && contractCopy.mlWageGroup == null){
                                contractCopy.paymentType = data.paymentType;
                                updateFieldsMap[contractCopy.id].push("paymentType");
                                if(data.paymentType == 2) {
                                    contractCopy.wageType = data.wageType;
                                } else {
                                    contractCopy.wageType = 4; //Monatslohn
                                }
                                updateFieldsMap[contractCopy.id].push("wageType");
                                contractCopy.payment = view.$helpers.euroInputToCents(data.payment);
                                updateFieldsMap[contractCopy.id].push("payment");
                                updateFlag = true;


                            }
                            if(data.updateExtraPayment){
                                contractCopy.extraPayment = view.$helpers.euroInputToCents(data.extraPayment);
                                updateFieldsMap[contractCopy.id].push("extraPayment");
                                updateFlag = true;
                            }
                            if(data.updateOvertimeBonus){
                                contractCopy.overtimeBonusHour = view.$helpers.euroInputToCents(data.overtimeBonusHour);
                                updateFieldsMap[contractCopy.id].push("overtimeBonusHour");
                                contractCopy.overtimeBonusShift = view.$helpers.euroInputToCents(data.overtimeBonusShift);
                                updateFieldsMap[contractCopy.id].push("overtimeBonusShift");
                                updateFlag = true;
                            }
                            if(data.updateComment){
                                contractCopy.comment = data.comment;
                                updateFieldsMap[contractCopy.id].push("comment");
                                updateFlag = true;
                            }
                            if(data.updateNightWork){
                                if(!data.updateExistingNightWorkOnly || contractCopy.calculateNightWork) {
                                    let allowedContract = contractCopy.collectiveContractId != null ? view.allowedContractMap[contractCopy.collectiveContractId] : null;
                                    let collectiveContract = allowedContract != null ? view.collectiveContractMap[allowedContract.collectiveContractId] : null;
                                    if(data.deactivateNightWork){
                                        contractCopy.calculateNightWork = false;
                                        updateFieldsMap[contractCopy.id].push("calculateNightWork");
                                        contractCopy.nightWorkBonusHour = 0;
                                        updateFieldsMap[contractCopy.id].push("nightWorkBonusHour");
                                        contractCopy.nightWorkBonusShift = 0;
                                        updateFieldsMap[contractCopy.id].push("nightWorkBonusShift");
                                        contractCopy.nightWorkBonusPercentage = 0;
                                        updateFieldsMap[contractCopy.id].push("nightWorkBonusPercentage")



                                    } else {
                                        contractCopy.calculateNightWork = true;
                                        updateFieldsMap[contractCopy.id].push("calculateNightWork");

                                        if(data.updateNightWorkMode){
                                            contractCopy.nightWorkMode = data.nightWorkMode;
                                            updateFieldsMap[contractCopy.id].push("nightWorkMode");

                                        }
                                        if(contractCopy.nightWorkMode == null){
                                            if(collectiveContract){
                                                contractCopy.nightWorkMode = collectiveContract.nightWorkMode;
                                            } else {
                                                contractCopy.nightWorkMode = 1;
                                            }
                                            updateFieldsMap[contractCopy.id].push("nightWorkMode");


                                        }
                                        if(contractCopy.nightWorkCutoff == null) {
                                            if(collectiveContract){
                                                contractCopy.nightWorkCutoff = collectiveContract.nightWorkCutoff;
                                            } else {
                                                contractCopy.nightWorkCutoff = 50;
                                            }
                                            updateFieldsMap[contractCopy.id].push("nightWorkCutoff");
                                        }
                                        if(contractCopy.nightWorkFrom == null) {
                                            if(collectiveContract){
                                                contractCopy.nightWorkFrom = collectiveContract.nightWorkFrom;
                                            } else {
                                                contractCopy.nightWorkFrom = "20:00";
                                            }
                                            updateFieldsMap[contractCopy.id].push("nightWorkFrom");
                                        }

                                        if(contractCopy.nightWorkTo == null) {
                                            if(collectiveContract){
                                                contractCopy.nightWorkTo = collectiveContract.nightWorkTo;
                                            } else {
                                                contractCopy.nightWorkFrom = "06:00";
                                            }
                                            updateFieldsMap[contractCopy.id].push("nightWorkTo");
                                        }
                                        if(data.updateNightWorkTimes){
                                            contractCopy.nightWorkFrom = data.nightWorkFrom.format("HH:mm");
                                            updateFieldsMap[contractCopy.id].push("nightWorkFrom");
                                            contractCopy.nightWorkTo = data.nightWorkTo.format("HH:mm");
                                            updateFieldsMap[contractCopy.id].push("nightWorkTo");
                                        }
                                        if(data.updateMinNightWorkTime){
                                            contractCopy.minNightWorkTime = data.minNightWorkTime;
                                            updateFieldsMap[contractCopy.id].push("minNightWorkTime");
                                        }
                                        if(contractCopy.nightWorkMode == 1){
                                            let nightWorkBonusHour = 0;
                                            if(data.useNightWorkBonusHourPercentage){
                                                let hourlyWage = view.$helpers.CalculateHourlyWage(contractCopy);
                                                nightWorkBonusHour = Math.round(hourlyWage * data.nightWorkBonusPercentage / 100.0);
                                                updateFieldsMap[contractCopy.id].push("useNightWorkBonusPercentage");
                                                

                                                contractCopy.nightWorkBonusPercentage =  data.nightWorkBonusPercentage;
                                                updateFieldsMap[contractCopy.id].push("nightWorkBonusPercentage")

                                            } else {
                                                nightWorkBonusHour = view.$helpers.euroInputToCents(data.nightWorkBonusHour);
                                                contractCopy.nightWorkBonusPercentage = 0;
                                                updateFieldsMap[contractCopy.id].push("nightWorkBonusPercentage")
                                            }
                                            contractCopy.nightWorkBonusHour = nightWorkBonusHour;
                                            updateFieldsMap[contractCopy.id].push("nightWorkBonusHour");
                                            contractCopy.nightWorkBonusShift = view.$helpers.euroInputToCents(data.nightWorkBonusShift);
                                            updateFieldsMap[contractCopy.id].push("nightWorkBonusShift");
                                        } else if(contractCopy.nightWorkMode == 3 || contractCopy.nightWorkMode == 5) {
                                            let nightWorkBonusHour = 0;
                                            if(data.useNightWorkBonusHourPercentage){
                                                let hourlyWage = view.$helpers.CalculateHourlyWage(contractCopy);
                                                nightWorkBonusHour = Math.round(hourlyWage * data.nightWorkBonusPercentage / 100.0);
                                                updateFieldsMap[contractCopy.id].push("useNightWorkBonusPercentage");
                                                
                                                contractCopy.nightWorkBonusPercentage =  data.nightWorkBonusPercentage;
                                                updateFieldsMap[contractCopy.id].push("nightWorkBonusPercentage")
                                            } else {
                                                nightWorkBonusHour = view.$helpers.euroInputToCents(data.nightWorkBonusHour);
                                                contractCopy.nightWorkBonusPercentage = 0;
                                                updateFieldsMap[contractCopy.id].push("nightWorkBonusPercentage")
                                            }
                                            contractCopy.nightWorkBonusHour = nightWorkBonusHour;
                                            updateFieldsMap[contractCopy.id].push("nightWorkBonusHour");
                                            contractCopy.nightWorkBonusShift = 0;
                                            updateFieldsMap[contractCopy.id].push("nightWorkBonusShift");
                                        } else  if(contractCopy.nightWorkMode == 2 || contractCopy.nightWorkMode == 4){
                                            contractCopy.nightWorkBonusHour = 0;
                                            updateFieldsMap[contractCopy.id].push("nightWorkBonusHour");
                                            contractCopy.nightWorkBonusShift = view.$helpers.euroInputToCents(data.nightWorkBonusShift);
                                            updateFieldsMap[contractCopy.id].push("nightWorkBonusShift");
                                            contractCopy.nightWorkBonusPercentage = 0;
                                            updateFieldsMap[contractCopy.id].push("nightWorkBonusPercentage")

                                        }

                                    }

                                    updateFlag = true;
                                }


                            }
                            updatableContracts.push(contractCopy);


                        })
                        view.recursiveContractUpdate(updatableContracts, updateFieldsMap, cowMap, data.changeDate);

                    },
                },
                header: this.$t('pages.employeeContext.adjustEmployeeWageData'),
                remainAfterSelect: false,
                expanded: true,
                centered: true,
                width: '1000px'
            });

        },
        openUpdatePaymentByCSVPopup() {
            let view = this;
            //first find all current active contracts
            let description = "this.$t('pages.employeeContext.updatePaymentHelp')"

            let paymentTypeItems = this.uiData.paymentTypes.map(item => {return {label: item.label_de, value: item.id}} );
            let wageTypeItems = this.uiData.wageTypes.map(item => {return {label: item.label_de, value: item.id, selected: item.id == 4}} );


            let dataEntries = [{label: this.$t('global.ui.csvFile'), accept: ".csv", key: 'file', hidden: false, type: 'file', value: null}];

            dataEntries.push({label: this.$t('pages.employeeContract.paymentType'), key: 'paymentType', type: 'dropdownsearch', hidden: false,
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectFirst: true,
                    items: paymentTypeItems
                },
            });
            dataEntries.push({label: this.$t('pages.employeeContract.wageType'), key: 'wageType', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectedItem: wageTypeItems.find(i => i.value == 4),
                    items: wageTypeItems
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let paymentTypeFlag = datafill.entries.find(i => i.key == 'paymentType').value;
                    if(paymentTypeFlag == 2){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;

                    }

                    return entryBeforeUpdate;
                }
            });

            dataEntries.push({label: this.$t('pages.employeeContext.adjustContractsDirectly'), key: 'updateCurrent', hidden: false, type: 'bool', value: false});
            let changeDate = this.$helpers.getMomentTZ().add(1, 'months').startOf('month');
            dataEntries.push({label: this.$t('pages.employeeContract.changeDate'), key: 'changeDate', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('updateCurrent'), type: 'date', value: changeDate}),

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    description: description,
                    entries: dataEntries,
                    selectCallback: function (data) {

                        view.parseCSVImport(data.file[0], null, ';')
                        .then(parsedEmployeeArray => {
                            let foundEmployees = new Set();
                            let matchingEntries = [];
                            let unmatchingEntries = [];
                            parsedEmployeeArray.forEach(e => {
                                if((e.personnelId != null || (e.firstName != null && e.lastName != null)) && e.payment != null){
                                    let fn = e.firstName != null ? e.firstName : '-Unbekannt-';
                                    let ln = e.lastName != null ? e.lastName : '-Unbekannt-';
                                    let checkPN = e.personnelId != null;

                                    let emp = Object.values(view.employeeMap)
                                    .find(emp => {
                                        if(checkPN){
                                            return emp.personnelId == e.personnelId;
                                        } else {
                                            return (emp.firstName.toLocaleLowerCase() == fn.toLocaleLowerCase() && emp.lastName.toLocaleLowerCase() == ln.toLocaleLowerCase())
                                        }

                                    });

                                    if(emp != null){
                                        if(!foundEmployees.has(emp.id)){
                                            foundEmployees.add(emp.id);
                                            matchingEntries.push({id: emp.id, payment: e.payment});
                                        }

                                    } else {
                                        unmatchingEntries.push(e);
                                    }

                                } else {
                                    unmatchingEntries.push(e);
                                }


                            })
                            return {matchingEntries: matchingEntries, unmatchingEntries: unmatchingEntries};
                        }).then(matchResult => {
                            let now = view.$helpers.getMomentTZ().startOf('day');
                            let currentContracts = [];
                            let updatableContracts = [];
                            let updateFieldsMap = {};
                            let cowMap = {};

                            let employees = [];
                            let paymentMap = {};
                            matchResult.matchingEntries.forEach(e => {
                                employees.push(e.id);
                                paymentMap[e.id] = e.payment
                            })

                            Object.keys(view.employeeEmployeeContractMap).forEach(key => {

                                if(employees.includes(key)){

                                    let contracts = view.employeeEmployeeContractMap[key];

                                    if(data.selectByCollectiveContract && contracts != null){
                                        contracts = contracts.filter(c => data.allowedContracts.includes(c.collectiveContractId));
                                    }
                                    if(data.selectByEmploymentGroup && contracts != null){
                                        contracts = contracts.filter(c => data.employmentGroups.includes(c.employmentGroup));
                                    }

                                    if(data.updateCurrent){
                                        //get current active contract

                                        let currentContract = contracts.find(c => {
                                            let cFrom = view.$helpers.getMomentFromStringTZ(c.from);
                                            let cTo = c.to != null ? view.$helpers.getMomentFromStringTZ(c.to) : null;
                                            if(cFrom <= now && (cTo == null || cTo > now)){
                                                return true;
                                            } else {
                                                return false;
                                            }

                                        })
                                        if(currentContract != null){
                                            currentContracts.push(currentContract);
                                            cowMap[currentContract.id] = false;
                                        }
                                    } else {
                                        //changeDate exists
                                        //first find all contracts where from == changeDate, because those need to be updated directly

                                        let currentContract = contracts.find(c => {
                                            let cFrom = view.$helpers.getMomentFromStringTZ(c.from);

                                            if(cFrom.year() == data.changeDate.year() && cFrom.month() == data.changeDate.month() && cFrom.date() == data.changeDate.date()){
                                                return true;
                                            } else {
                                                return false;
                                            }

                                        })
                                        if(currentContract != null){
                                            currentContracts.push(currentContract);
                                            cowMap[currentContract.id] = false;
                                        } else {
                                            //find contract where changeDate lies within contract from - to range
                                            let cowContract = contracts.find(c => {
                                                let cFrom = view.$helpers.getMomentFromStringTZ(c.from);
                                                let cTo = c.to != null ? view.$helpers.getMomentFromStringTZ(c.to) : null;
                                                if(cFrom < data.changeDate && (cTo == null || cTo > data.changeDate)){
                                                    return true;
                                                } else {
                                                    return false;
                                                }

                                            })
                                            if(cowContract != null){
                                                currentContracts.push(cowContract);
                                                cowMap[cowContract.id] = true;
                                            }
                                        }

                                    }

                                }
                            })
                            //view.sendActivationEmail();
                            currentContracts.forEach(c => {
                                if(paymentMap[c.employeeId] != null){
                                    let contractCopy = Object.assign({}, c);
                                    updateFieldsMap[contractCopy.id] = [];

                                    if(cowMap[contractCopy.id] == true){
                                        contractCopy.from = data.changeDate.format();
                                    }

                                    contractCopy.paymentType = data.paymentType;
                                    updateFieldsMap[contractCopy.id].push("paymentType");
                                    if(data.paymentType == 2) {
                                        contractCopy.wageType = data.wageType;
                                    } else {
                                        contractCopy.wageType = 4; //Monatslohn
                                    }
                                    updateFieldsMap[contractCopy.id].push("wageType");
                                    contractCopy.payment = paymentMap[c.employeeId];
                                    updateFieldsMap[contractCopy.id].push("payment");

                                    updatableContracts.push(contractCopy);

                                }

                            })
                            view.recursiveContractUpdate(updatableContracts, updateFieldsMap, cowMap, data.changeDate);
                        }).catch(error => {
                            console.log(error);
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.importDataError'));
                        })


                    },
                },
                header: this.$t('pages.employeeContext.employeeWageCsv'),
                remainAfterSelect: false,
                expanded: true,
                centered: true,
                width: '700px'
            });

        },
        recursiveContractUpdate(contracts, updateFieldsMap, cowMap, changeDate){
            let view = this;
            if(contracts.length > 0){
                let contract = contracts.pop();
                view.loading = true;
                let employee = view.employeeMap[contract.employeeId];
                let changedKeys = updateFieldsMap[contract.id];

                let contractRecalcDate = cowMap[contract.id] == true ? changeDate : view.$helpers.getMomentFromStringTZ(contract.from);

                let updateFuture;

                if(contract.collectiveContractId != null){
                    let cc = view.collectiveContractMap[view.allowedContractMap[contract.collectiveContractId].collectiveContractId];
                    let contractFrom = contractRecalcDate;

                    let changedCollectiveContractKeys = view.$helpers.checkContractForCollectiveContractChanges(contract, cc, contractFrom);
                    changedCollectiveContractKeys.forEach(key => {
                        if(changedKeys.includes(key) == false){
                            changedKeys.push(key);
                        }

                    });
                }
                if(contract.mlWageGroup != null){
                    let waResult = view.$helpers.findWageAmountForEmploymentGroup(contract, view.mlWageGroupMap, contractRecalcDate);
                    if(waResult.validMlWageAmounts.length > 0){
                        let selectedWageAmount = waResult.selectedWageAmount;
                        contract.payment = selectedWageAmount.amount;
                        contract.paymentType = selectedWageAmount.paymentType;
                        contract.wageType = selectedWageAmount.wageType;

                        if((contract.paymentType == 1 || contract.wageType == 4) && contract.weekTimeRegular < contract.fullTimeCutoff){

                            if(contract.collectiveContractId != null && view.storeSettings.workTimeMode == 0){
                                let fullTime = (contract.fullTimeCutoff * (view.storeSettings.workTimeFactor/Math.pow(10,7)))/60.0;
                                let hourlyWage = contract.payment / fullTime;
                                let contractTime = (contract.weekTimeRegular * (view.allowedContractMap[contract.collectiveContractId].workTimeFactor/Math.pow(10,7)))/60.0;

                                contract.payment = hourlyWage * contractTime;
                            } else {
                                let ratio = contract.weekTimeRegular /contract.fullTimeCutoff;
                                contract.payment = contract.payment * ratio;
                            }



                        }
                        if(changedKeys.includes("payment") == false){
                            changedKeys.push("payment");
                        }
                        if(changedKeys.includes("paymentType") == false){
                            changedKeys.push("paymentType");
                        }
                        if(changedKeys.includes("wageType") == false){
                            changedKeys.push("wageType");
                        }
                    }
                }

                if(contract.nightWorkBonusPercentage > 0){
                    let hourlyWage = view.$helpers.CalculateHourlyWage(contract);
                    let nightWorkBonusHour = Math.round(hourlyWage * contract.nightWorkBonusPercentage / 100.0);
                    contract.nightWorkBonusHour = nightWorkBonusHour;
                    if(!changedKeys.includes("nightWorkBonusHour")){
                        changedKeys.push("nightWorkBonusHour");
                    }
                    
                }

                if(employee != null){
                    let workExperienceYears = view.employee.workExperience != null ? view.employee.workExperience/12.0 : 0;
                    let nonEmploymentYears = (view.employee.nonEmploymentTime != null ? view.employee.nonEmploymentTime/12.0 : 0);
                    let ac =  this.employeeEmployeeContractMap[employee.id] != null ?  this.employeeEmployeeContractMap[employee.id] : [];
                    let workEntryDate = this.$helpers.getEmployeeEntryDate(employee, ac);
                    let ccId = contract.collectiveContractId ? (view.allowedContractMap[contract.collectiveContractId] ? view.allowedContractMap[contract.collectiveContractId].collectiveContractId : null) : null;
            
                    let vacEntitlement = Math.round(view.$helpers.calculateContractVacationEntitlement(view.storeSettings, workEntryDate, contractRecalcDate, workExperienceYears, nonEmploymentYears, contract.weekWorkDaysRegular, ccId) * 24 * 60);
                    
                    if(this.$helpers.hasAutomaticVacationEntitlement(this.storeSettings) && vacEntitlement > contract.vacationTime){
                        contract.vacationTime = vacEntitlement;
                        if(changedKeys.includes("vacationTime") == false){
                            changedKeys.push("vacationTime");
                        }
                    }
                    
                }
                if(changedKeys.length > 0){
                    view.loadingText = this.$t('pages.employeeContext.updateContract', [employee.lastName, employee.firstName]);
                    if(cowMap[contract.id] == true){
                        updateFuture = this.$helpers.copyOnWriteEmployeeContract(contract, contract.id, contract.employeeId, changeDate);
                    } else {
                        updateFuture = this.$helpers.updateEmployeeContractCall(changedKeys, contract, contract.id, contract.employeeId);
                    }
                } else {
                    updateFuture = Promise.resolve();

                }


                updateFuture.then(response => {
                    view.recursiveContractUpdate(contracts, updateFieldsMap, cowMap, changeDate);
                }).catch(error => {

                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.updateContractError', [employee.lastName, employee.firstName]));
                    view.recursiveContractUpdate(contracts, updateFieldsMap, cowMap, changeDate);
                })
            } else {
                view.loading = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.employeeContext.contractsUpdated'));
                view.refresh(null, true, true);
            }
        },
        openActivationEmailPopup() {
            let view = this;
            this.hideModal('modal-employee-account');
            let dataEntries = [];
            let description = this.$t('pages.employeeContext.activateEmployeeQuery')

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    description: description,
                    entries: dataEntries,
                    selectCallback: function (data) {
                        view.sendActivationEmail();
                    },
                },
                header: this.$t('pages.employeeContext.activateEmployee'),
                remainAfterSelect: false,
                expanded: true,
                centered: true
            });
        },
        sendActivationEmail() {
            let view = this;
            let url = '/api/sec/employee/account/activate';
            let params =  {
                storeId: this.$store.state.storeId,
                id: this.employee.id
            }
            let payload = {
                registrationSource: this.storeSettings.name+ (this.storeSettings.description != null ? (" - "+this.storeSettings.description) : "")
            };




            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let returnCode = response.data.data;
                if(returnCode == 1){
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.employeeContext.alreadyActive'));
                } else {
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.employeeContext.activationEmailSend'));
                }

            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.activateAccountError'));
                console.log(error)
            })
        },
        openCSVImportPopup() {
            let view = this;
            let externalServiceItems = Object.values(this.externalServicesMap).map(i => {return {label: i.name, value: i.id}});
            externalServiceItems.push({label: view.$t('pages.employeeContext.noExternalService'), value: null});
            let dataEntries = [
                {label: this.$t('global.ui.csvFile'), accept: ".csv", key: 'file', hidden: false, type: 'file', value: null},
                {label: this.$t('pages.employeeContext.createNewEmployees'), key: 'acceptNewEmployees', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.updateContracts'), key: 'updateContracts', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.service'), key: 'externalServiceId', disabled: false, hidden: false, type: 'dropdownsearch', value: null, flexGroup: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: externalServiceItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                          }
                },
                {label: view.$t('pages.employeeContext.adoptCreatedEmployees'), key: 'acceptExistingImmediately', hidden: false, type: 'bool', value: false},
            ];


            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (importf) {
                        if(importf.file.length > 0){
                            view.loadEmployeeExternalData(importf.externalServiceId)
                            .then(externalData => {
                                //match externalId to remoteId
                                let externalIdMap = {}

                                externalData.forEach(d => {
                                    if(d.externalId != null && d.externalId.length > 0){
                                        let employee = view.employeeMap[d.employeeId];
                                        if(employee != null){
                                            externalIdMap[d.externalId] = employee;
                                        }
                                    }
                                });

                                //match first name + last name + email to remoteId
                                let emailNameMap = {};

                                Object.values(view.employeeMap).forEach(emp => {
                                    if(emp.email != null){
                                        let key = emp.firstName+"_"+emp.lastName+"_"+emp.email;
                                        key = key.toLocaleLowerCase().trim();
                                        emailNameMap[key] = emp;
                                    }

                                })

                                view.parseCSVImport(importf.file[0], importf.externalServiceId, ';')
                                .then(parsedEmployeeArray => {
                                    let uniqueEmails = [];

                                    parsedEmployeeArray.forEach(e => {
                                        if(uniqueEmails.includes(e.email)){
                                            e.email =  null;
                                            let newUpdateFields = [];
                                            e.updateFields.forEach(f => {
                                                if(f != "email"){
                                                    newUpdateFields.push(f);
                                                }
                                            })
                                            e.updateFields = newUpdateFields;
                                        } else {
                                            uniqueEmails.push(e.email);
                                        }
                                    })
                                    let missingContracts = view.getMissingAllowedContracts(parsedEmployeeArray);
                                    if(missingContracts.length == 0){
                                        let resultArray = [];
                                        let employeeArray = [];
                                        parsedEmployeeArray.forEach(e => {
                                            if(e.externalEmployeeId != null && externalIdMap[""+e.externalEmployeeId]){
                                                let employee = externalIdMap[""+e.externalEmployeeId]
                                                e.remoteId = employee.remoteId;
                                                if(e.email == null){
                                                    e.email = employee.email;
                                                }

                                                resultArray.push(e);
                                            } else if(e.firstName != null && e.lastName != null && e.firstName.length > 0 && e.lastName.length > 0) {
                                                let key  = null;
                                                if(e.email != null){
                                                    key = e.firstName+"_"+e.lastName+"_"+e.email;
                                                    key = key.toLocaleLowerCase().trim();
                                                }
                                                if(key != null && emailNameMap[key] != null){
                                                    e.remoteId = emailNameMap[key].remoteId;
                                                    resultArray.push(e);
                                                } else {
                                                    employeeArray.push(e);
                                                }

                                            }
                                        })
                                        if(employeeArray.length > 0){
                                            return view.getCandidates(employeeArray)
                                            .then(candidateArray => {
                                                return view.handleEmployeeImportStep(employeeArray, candidateArray, resultArray, importf.acceptExistingImmediately);
                                            }).then(finalResultArray => {
                                                return view.importEmployeeData(finalResultArray, importf.acceptNewEmployees, importf.updateContracts);
                                            })
                                        } else {
                                            return view.importEmployeeData(resultArray, importf.acceptNewEmployees, importf.updateContracts);
                                        }
                                    } else {
                                        view.displayMissingAllowedContractsMessage(missingContracts);
                                        return new Promise((resolve, reject) => {
                                            reject("Missing contracts!")
                                        })
                                    }



                                }).then(res => {
                                    view.refresh(null, true, true);

                                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.employeeContext.employeeImported'));
                                }).catch(error => {
                                    console.log(error);
                                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.importDataError'));
                                })
                            }).catch(error => {
                                console.log(error);
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                            })


                        } else {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.noImportFileSelected'));
                        }
                    },
                },
                header: this.$t('pages.employeeContext.importEmployeeData'),
                remainAfterSelect: false,
                expanded: true,
                centered: true
            });
        },
        loadEmployeeExternalData(externalServiceId){
            let view = this;
            let url = '/api/sec/employeeexternaldata';

            let params = {
                storeId: this.$store.state.storeId,
                externalServiceId: externalServiceId
            }

            if(externalServiceId != null){
                return new Promise((resolve, reject)=> {
                    view.axios({
                        method: 'get',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                    }).then(data => {
                        resolve(data.data);
                    }).catch(error => {
                        reject(error);
                    })

                })
            } else {
                console.log("B")
                return new Promise((resolve, reject)=> {
                    resolve([]);
                })
            }
        },
        getMissingAllowedContracts(parsedEmployeeArray){
            let view = this;
            let missingContracts = {}
            parsedEmployeeArray.forEach(e => {
                if(e.weekTimeRegular != null && e.weekWorkDaysRegular != null){
                    let ac = Object.values(view.allowedContractMap).find(a => a.weekTimeRegular == e.weekTimeRegular && a.weekWorkDaysRegular == e.weekWorkDaysRegular);
                    if(ac == null){
                        missingContracts[e.weekTimeRegular+"-"+e.weekWorkDaysRegular] = {weekTimeRegular: e.weekTimeRegular, weekWorkDaysRegular: e.weekWorkDaysRegular};
                    }
                }
            })
            return Object.values(missingContracts);
        },
        displayMissingAllowedContractsMessage(missingContracts){
            let view = this;
            let description  = "";

            description +="<p><b style='color: red'>" + this.$t('global.ui.warning') + "!</b></p>"
            description += "<p>" + this.$t('pages.employeeContext.importErrorHelp', [(this.storeSettings.country == 1 ? this.$t('store.collectiveContracts.title') : this.$t('store.modelContracts'))]) + "</p>"
            description += "<ul>";
            missingContracts.forEach(c => {
                    description +="<li>" + this.$t('pages.employeeContext.weeklyHoursDays', [c.weekTimeRegular/60.0, c.weekWorkDaysRegular])+ "</li>";
            })
            description += "</ul>";
            let dataEntries = [];
            if(this.isSuperUser){
                let collectiveContractItems = Object.values(this.collectiveContractMap)
                .filter(c => c.country == view.storeSettings.country)
                .map(i => {return {label: i.name, value: i.id}})
                .sort((a, b) => {return (a.label == "Systemgastronomie")? -1 : (b.label == "Systemgastronomie")? 1 : (a.label > b.label)? -1 : (b.label > a.label)? 1 : 0; })
                ;

                dataEntries = [

                    {label: this.$t('pages.employeeContext.createContractModels'), key: 'createMissingContracts', hidden: false, type: 'bool', value: false},

                    {label: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')), key: 'collectiveContractId', disabled: false, hidden: view.$helpers.CheckDatafillKeysForHidden('createMissingContracts'), type: 'dropdownsearch', value: null, flexGroup: false,
                            dropdownSearchState:{
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: collectiveContractItems,
                                selectMultiple: false,
                                selectedItems: [],
                                selectedItem: null,
                                onceSelected: function ($event, item, searchbar){
                                },
                                styleLight: true,
                                placeholder: this.$t('store.settings.pleaseSelect'),
                            }
                    },

                ];
            }


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,

                    selectCallback: function(data){
                        if(view.isSuperUser && data.createMissingContracts && data.collectiveContractId){
                            view.createAllowedContracts(missingContracts, data.collectiveContractId);
                        }
                    },

                },
                header: '<div class="label" style="font-size: 22px;font-weight:200;">IMPORT</div><div class="label" style="font-size: 22px;font-family: DistrictProBold;font-weight:800;">' + this.$t('global.notifications.error').toUpperCase() + '</div>',
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        parseCSVImport(file, externalServiceId = null, delimiter){
            let view = this;
            // TODO translate csv import
            return new Promise((resolve, reject) => {
                Papa.parse(file,
                {
                    header: true,
                    delimiter: delimiter,
                    skipEmptyLines: true,
                    transformHeader: (header) => {
                        if(header){
                            header = header.trim().toLowerCase();
                        }
                        if(header == "externalid" || header == "externe id" || header == "mitarbeiter_id"){
                            return "externalEmployeeId";
                        }
                        if(header == "mitarb-nr" || header == "mitarbeiternummer" || header == "personalnummer" || header == "pers.nr."){
                            return "personnelId";
                        }
                        if(header == "nachname" || header == "familienname" || header == "name"){
                             return "lastName";
                        }
                        if(header == "vorname"){
                            return "firstName";
                        }
                        if(header == "geburtsdatum"){
                            return "dob"
                        }
                        if(header == "lohn" || header == "bruttolaufend_vereinbarung" || header == "stundenlohn" || header == "gehalt" || header == "monatslohn"){
                            return "payment"
                        }
                        if(header == "lohntyp"){
                            return "wageType"
                        }
                        if(header == "zahlungstyp"){
                            return "paymentType"
                        }
                        if(header == "svnr" || header == "svnr kurz" || header == "svnr." || header == "svcode_10_stellig"){
                            return "socialsecurity"
                        }
                        if(header == "staatsangehörigkeit" || header == "ländername" || header =="nationalität" || header == "nation"){
                            return "nationality";
                        }
                        if(header == "strasse" || header == "straße" || header == "adresse"){
                            return "address";
                        }
                        if(header == "hausnummer"){
                            return "addressnumber";
                        }
                        if(header == "ort" || header == "stadt"){
                            return "city";
                        }
                        if(header == "plz" || header == "postleitzahl"){
                            return "postalCode"
                        }
                        if(header == "e-mail" || header == "e-mail-adresse" || header == "email" || header == "verbindung"){
                            return "email"
                        }
                        if(header == "mobil" || header =="mobilephone" || header == "verbindung1" || header == "telefon"){
                            return "mobilephone";
                        }
                        if(header == "gender" || header =="geschlecht"){
                            return "gender";
                        }
                        if(header == "iban"){
                            return "iban"
                        }
                        if(header == "swift/bic" || header == "bic"){
                            return "bic"
                        }
                        if(header == "ersteintrittsdatum"){
                            return "workEntryDate"
                        }
                        if(header == "eintrittsdatum" || header == "vertragsdatum" || header == "dvp-beginn"){
                            return "contractStart"
                        }
                        if(header == "austrittsdatum" || header == "dvp-ende"){
                            return "contractEnd"
                        }
                        if(header == "wochenstunden" || header == "wochenmodell" || header == "gazwoche" || header == "wö. az"){
                            return "weekTimeRegular"
                        }
                        if(header == "urlaubstage" || header == "urlaubsanspruch"){
                            return "vacationTime"
                        }
                        if(header == "urlaubstage"){
                            return "vacationTime"
                        }
                        if(header == "wochentage" || header == "tagewoche"){
                            return "weekWorkDaysRegular"
                        } else {
                            return "no_matching_field";
                            //return header;
                        }

                    },
                    complete: (result, file) => {
                        console.log(result)
                        view.cleanupAndExtendImportData(result.data, externalServiceId);
                        resolve(result.data);
                    },
                    error: (error, file) => {
                        reject(error);

                    }
                })
            })

        },
        cleanupAndExtendImportData(data, externalServiceId = null){
            let view = this;
            data.forEach(entry => {

                if(entry.postalCode){
                    let pCode = entry.postalCode.trim().split(" ");
                    if(pCode.length > 0){
                        entry.postalCode = pCode[0];
                    }
                    if(pCode.length > 1){
                        let city = "";
                        for(let i = 0; i<pCode.length; i++){
                            if(i != 0){
                                city+=pCode[i]+" ";
                            }
                        }
                        city = city.trim();
                        entry.city = city;
                    }
                }
                if(entry.address && entry.addressnumber){
                    entry.address = entry.address+" "+entry.addressnumber;
                    delete entry.addressnumber;
                }
                if(entry.email){
                    entry.email = entry.email.toLowerCase().trim();
                }
                if(entry.gender){
                    let v = entry.gender.toLowerCase().trim();
                    if(v == "m" || v == "mann" || v == "männlich" || v == 'maennlich' || v == 'maskulin'){
                        entry.gender = 'M';
                    } else if(v == 'f' || v == 'frau' || v == 'weiblich' || v == 'w' || v == 'feminin'){
                        entry.gender = 'F';
                    } else {
                        entry.gender = 'D'
                    }
                }
                if(entry.payment){
                    if(entry.payment.includes(",")){
                        entry.payment = entry.payment.replace(",",".");
                    }
                    entry.payment = Math.round(parseFloat(entry.payment) * 100);
                }
                if(entry.wageType == null){
                    entry.wageType = 4;
                } else {
                    entry.wageType = parseInt(entry.wageType);
                }
                if(entry.paymentType == null){
                    entry.paymentType = 2;
                } else {
                    entry.paymentType = parseInt(entry.paymentType);
                }
                if(entry.wageType > 4 || entry.wageType < 1){
                    entry.wageType = 4;
                }
                if(entry.paymentType > 2 || entry.paymentType < 1){
                    entry.paymentType = 2;
                }
                if(externalServiceId != null){
                    entry.externalServiceId = externalServiceId;
                }

                entry.nationality = this.countryIdMap[entry.nationality] ? this.countryIdMap[entry.nationality] : (this.countryCodeMap[entry.nationality] ? this.countryCodeMap[entry.nationality]: null);
                if(entry.dob){
                    let split;
                    if(entry.dob.includes("/")){
                        split = entry.dob.trim().split("/");
                    } else if(entry.dob.includes("-")){
                        split = entry.dob.trim().split("-");
                    } else {
                        split = entry.dob.trim().split(".");
                    }

                    let fixedDob = "";
                    split.forEach(str => {
                        if(str.length < 2){
                            fixedDob+="0"+str+".";
                        } else {
                            fixedDob+=str+".";
                        }
                    })
                    if(fixedDob.length > 0){
                        fixedDob = fixedDob.substring(0, fixedDob.length -1);
                    }
                    if(entry.dob.includes("/")){
                        entry.dob = this.$helpers.getMomentFromStringUTC(fixedDob, "MM.DD.YYYY").format();
                    } else if(entry.dob.includes("-")){
                        entry.dob = this.$helpers.getMomentFromStringUTC(fixedDob, "YYYY.MM.DD").format();
                    } else {
                        entry.dob = this.$helpers.getMomentFromStringUTC(fixedDob, "DD.MM.YYYY").format();
                    }
                    if(entry.dob == "Invalid date"){
                        entry.dob = null;
                    }
                }

                entry.dob = entry.dob ? entry.dob : null;
                if(entry.workEntryDate){
                    entry.workEntryDate = this.parseFixedDateForCSVImport(entry.workEntryDate);
                }
                if(entry.contractStart){
                    entry.contractStart = this.parseFixedDateForCSVImport(entry.contractStart);

                }
                entry.contractStart  = entry.contractStart  ? entry.contractStart  : null;
                if(entry.contractStart){

                    entry.weekTimeRegular = entry.weekTimeRegular ? Math.round(parseFloat(entry.weekTimeRegular) *60) : 40*60;
                    entry.weekWorkDaysRegular = entry.weekWorkDaysRegular ? Math.round(parseFloat(entry.weekWorkDaysRegular)) : 5;
                    if(entry.contractEnd){
                        entry.contractEnd = this.parseFixedDateForCSVImport(entry.contractEnd);
                    }
                    entry.contractEnd  = entry.contractEnd  ? entry.contractEnd  : null;
                    //add 1 day to exit date
                    if(entry.contractEnd){
                        let ed = this.$helpers.getMomentFromStringTZ(entry.contractEnd);

                        ed = ed.add(1, 'days').startOf('day');
                        entry.contractEnd = ed.format();
                    }
                    entry.vacationTime = entry.vacationTime ? Math.round(parseFloat(entry.vacationTime))*24*60 : null;
                } else {
                    entry.weekTimeRegular = null;
                    entry.weekWorkDaysRegular = null;
                    entry.vacationTime = null;
                    entry.contractEnd = null;
                }
                let updateFields = [];
                Object.keys(entry).forEach(key => {
                    if(key == "no_matching_field"){
                        delete entry[key];
                    }else{
                        if(!view.$helpers.isEmpty(entry[key])){
                            updateFields.push(key);
                        } else {
                            entry[key] = null;
                        }
                    }


                });
                entry.updateFields = updateFields;
            })
        },
        parseFixedDateForCSVImport(dateString){
           let result = null;
           let split;
           if(dateString.includes("/")){
                split = dateString.trim().split("/");
            } else if(dateString.includes("-")){
                split = dateString.trim().split("-");
            } else {
                split = dateString.trim().split(".");
            }

            let fixedDateString = "";
            split.forEach(str => {
                if(str.length < 2){
                    fixedDateString+="0"+str+".";
                } else {
                   fixedDateString+=str+".";
                }
            })
            if(fixedDateString.length > 0){
                fixedDateString = fixedDateString.substring(0, fixedDateString.length -1);
            }
            if(dateString.includes("/")){
                result = this.$helpers.getMomentFromStringTZ(fixedDateString, "MM.DD.YYYY").format();
            } else if(dateString.includes("-")){
                result = this.$helpers.getMomentFromStringTZ(fixedDateString, "YYYY.MM.DD").format();
            } else {
                result = this.$helpers.getMomentFromStringTZ(fixedDateString, "DD.MM.YYYY").format();
            }
            if(result == "Invalid date"){
                result = null;
            }
            return result;
        },
        importEmployeeData(data, acceptNewEmployees = false, updateContracts = false){
            let view = this;
            let url = '/api/sec/employee/import';

            let params = {
                storeId: this.$store.state.storeId,
                companyId: this.$store.state.companyId,
                updateOnly: !acceptNewEmployees,
                updateContracts: updateContracts
            }
            let payload = {
                storeId: this.$store.state.storeId,
                requests: data.filter(entry => entry.updateFields.length > 0),
            }

            if(payload.requests.length > 0){
                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }else {
                return new Promise((reject, resolve)=> {
                    resolve([]);
                })
            }

        },
        requestEmailForNewEmployee(){
            let view = this;

            let dataEntries = [
                {label: this.$t('pages.employeeContext.emailQuery') + ': ', key: 'email', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '500px'}},
                {flexDivider: true, styles: {'margin-bottom': '23px'}},
            ];

            this.$helpers.OpenPopup({
                elRelative: event.currentTarget,
                type: 'datafill',
                pointerDirection: 0,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (data) {
                        view.checkEmail(data.email);
                    }
                },
                header: this.$t('pages.employeeContext.checkEmail'),
                centered: true,
                remainAfterSelect: false,
                expanded: true,
            });
        },
        requestFirstNameForDummy(){
            let view = this;
            let spotItems = [];
            Object.values(view.spotMap).forEach(s => spotItems.push({label: s.name, value: s.id}));
            let dataEntries = [
                {label: this.$t('pages.employeeContext.testEmployeeFirstname'), key: 'firstName', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '500px'}},
                {label: this.$tc('shift.main.position'), key: 'spotId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: spotItems,
                    selectFirst: true,
                    selectMultiple: false,
                    selectedItems: [],
                    onceSelected: function ($event, item, searchbar){
                  },
                      styleLight: true,
                  }},
            ];

            this.$helpers.OpenPopup({
                elRelative: event.currentTarget,
                type: 'datafill',
                pointerDirection: 0,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (data) {
                        let dummyEmployee = {
                            spotId: data.spotId,
                            typeId: null,
                            ruleId: null,
                            title: null,
                            prefix: null,
                            firstName: data.firstName,
                            postfix: null,
                            lastName: "TEST",
                            dob: null,
                            workEntryDate: null,
                            gender: "D",
                            religion: null,
                            socialsecurity: null,
                            disability: false,
                            driverslicense: false,
                            dlExpiry: null,
                            firstaidcourse: false,
                            faExpiry: null,
                            mobilephone: null,
                            homephone: null,
                            email: null,
                            country: 0,
                            address: null,
                            postalCode: null,
                            city: null,
                            iban: null,
                            bic: null,
                            nationality: 0,
                            citizenType: 0,
                            civilStatus: 0,
                            employedSince: null,
                            guardianName: null,
                            guardianAddress: null,
                            socialInsuranceRegistered: true,
                            useRosterChecks: true,
                            workExperience: null,
                            nonEmploymentTime: null,
                            dummy: true,
                            external: false
                        }
                        view.createNewDummyEmployee(dummyEmployee);
                    }
                },
                header: this.$t('pages.employeeContext.createTestEmployee'),
                centered: true,
                remainAfterSelect: false,
                expanded: true,
            });
        },
        saveEmployeeClicked(generateChangePdf=false){
            if(this.creatingNewEmployee){
                this.$refs.compcoredata.createEmployee();
            }else if(this.editing){
                if(this.employee.dummy){
                    let e = this.$refs.compcoredata.getChangedEmployee();
                    this.startCandidateProcess(e);
                } else {
                    this.saveCurrentEmployeeCoredata(generateChangePdf);
                }

            }
        },
        checkEditingMode(callback){
            if(this.editing || this.creatingNewEmployee){
                if(this.$refs.compcoredata != undefined && this.$refs.compcoredata.pendingChanges){
                    let desc = this.$t('pages.employeeContext.saveQuery');
                    let view = this;
                    window.app.popupalerts.push({header: this.$t('pages.employeeContext.unsavedChanges'), number: null, description: desc, hidden: false, callbackAccept: function(popup){
                            popup.hidden = true;
                            view.checkEmail(view.$refs.compcoredata.savedEmployee.email, view.$refs.compcoredata.savedEmployee.id, true, view.saveEmployeeClicked);
                            callback();
                        }, acceptLabel: this.$t('global.ui.save'), callbackCancel: function(popup){
                            popup.hidden = true;
                            view.$refs.compcoredata.cancelEditMode();
                            callback();
                        }, cancelLabel: this.$t('pages.employeeContext.discard'), disableCancel: false
                    });
                }else{
                    this.$refs.compcoredata.cancelEditMode();
                    callback();
                }
            }else{
                callback();
            }
        },
        checkEmail(email, emplId = null, onSave=false, callback=null, callbackParam = null){
            let empl = null;
            if(email != null && email != undefined && email != "" && !this.$helpers.isBlank(email)){
                let email_lower = email.toLowerCase().trim();
                this.employeeArray.forEach((e) => {
                    let e_email = e.email ? e.email.toLowerCase().trim() : e.email;
                    if(e_email == email_lower && e.id != emplId) empl = e;
                });
            }
            if(onSave){
                if(empl == null && callback != null){
                    if(callbackParam){
                        callback(callbackParam);
                    }else{
                        callback();
                    }
                }else{
                    let desc = this.$t('pages.employeeContext.emailInUseHelp', [empl.lastName, empl.firstName, (empl.active? '':this.$t('pages.employeeContext.employeeDeactivatedBubble'))]);
                    let view = this;
                    window.app.popupalerts.push({header: this.$t('pages.employeeContext.emailInUse'), number: null, description: desc, hidden: false, callbackAccept: function(popup){
                            popup.hidden = true;
                        }, disableCancel: true
                    });
                }
            }else{
                if(empl == null){
                    this.initNewEmployee(email);
                }else{
                    let desc = empl.active? this.$t('pages.employeeContext.emailInUseHelp', [empl.lastName, empl.firstName, '']) : this.$t('pages.employeeContext.emailDeactivated');
                    let view = this;
                    window.app.popupalerts.push({header: this.$t('pages.employeeContext.emailInUse'), number: null, description: desc, hidden: false, callbackAccept: function(popup){
                            if(!empl.active){
                                view.ChangeEmployee(empl);
                                view.activateEmployee(view.editCurrentEmployeeCoredata);
                            }
                            popup.hidden = true;
                        }, disableCancel: true
                    });
                }
            }
        },
        initNewEmployee(email = null) {
            this.selectedPage = 'coredata';
            this.newEmployee = {
                spotId: null,
                typeId: null,
                ruleId: null,
                title: "",
                prefix: "",
                firstName: "",
                postfix: "",
                lastName: "",
                dob: null,
                workEntryDate: null,
                gender: "",
                religion: "",
                socialsecurity: null,
                disability: false,
                driverslicense: false,
                dlExpiry: null,
                firstaidcourse: false,
                faExpiry: null,
                mobilephone: "",
                homephone: "",
                email: email ? email.toLowerCase().trim() : email,
                country: 0,
                address: undefined,
                postalCode: undefined,
                city: undefined,
                iban: "",
                bic: "",
                nationality: 0,
                citizenType: 0,
                civilStatus: 0,
                employedSince: null,
                guardianName: "",
                guardianAddress: "",
                socialInsuranceRegistered: false,
                useRosterChecks: true,
                workExperience: null,
                nonEmploymentTime: null,
                external: false,
                maxAppEmployeePreferences: null,
                sortPriority: 1
            }

            this.creatingNewEmployee = true;
            this.prevEmployee = this.employee;
            this.employee = this.newEmployee;
        },
        resetEmployee() {
            this.employee = this.prevEmployee;
            this.newEmployee = {
                spotId: null,
                typeId: null,
                ruleId: null,
                title: "",
                prefix: "",
                firstName: "",
                postfix: "",
                lastName: "",
                dob: null,
                workEntryDate: null,
                gender: "M",
                religion: "",
                socialsecurity: null,
                disability: false,
                driverslicense: false,
                dlExpiry: null,
                firstaidcourse: false,
                faExpiry: null,
                mobilephone: "",
                homephone: "",
                email: null,
                country: 0,
                address: undefined,
                postalCode: undefined,
                city: undefined,
                iban: "",
                bic: "",
                nationality: 0,
                citizenType: 0,
                civilStatus: 0,
                employedSince: null,
                guardianName: "",
                guardianAddress: "",
                socialInsuranceRegistered: false,
                useRosterChecks: true,
                workExperience: null,
                nonEmploymentTime: null,
                external: false,
                maxAppEmployeePreferences: null,
                sortPriority: 1
            }
        },
        employeeCreationCancelled(){
            this.resetEmployee();
            this.creatingNewEmployee = false;
            this.editing = false;

            this.$forceUpdate();
        },
        handleEmployeeImportStep(employeeImportArray, candidateArray, resultArray, acceptExistingImmediately = false){
            let view = this;
            if(employeeImportArray.length != candidateArray.length){

                return new Promise((resolve, reject) => reject("Import and candidate array of different size"));
            }
            if(employeeImportArray.length == 0) {
                return new Promise((resolve, reject) => resolve(resultArray));
            } else {
                let employee = employeeImportArray.pop();
                let candidates = candidateArray.pop();
                candidates = this.transformCandidateResult(candidates);

                if(candidates.length == 0){
                    resultArray.push(employee);
                    return this.handleEmployeeImportStep(employeeImportArray, candidateArray, resultArray, acceptExistingImmediately);
                } else {
                    let matchesInStore = candidates.filter(e => e.score == 100 && view.remoteIdEmployeeMap[""+e.value]);

                    let otherMatches = candidates.filter(e => e.score == 100);
                    let matches = matchesInStore ? matchesInStore : otherMatches;

                    if(matches != null && matches.length == 1 && matches[0].value && acceptExistingImmediately){
                        employee.remoteId = matches[0].value;
                        resultArray.push(employee);
                        return this.handleEmployeeImportStep(employeeImportArray, candidateArray, resultArray, acceptExistingImmediately);
                    } else {
                        if(matchesInStore.length > 0){
                            candidates = matchesInStore;
                        }
                        if(employee.email != null){
                            //email is not null => only show candidates with same email, if such employee exists
                            let emailCandidate = candidates.filter(e => view.remoteIdEmployeeMap[""+e.value] != null && view.remoteIdEmployeeMap[""+e.value].email != null && view.remoteIdEmployeeMap[""+e.value].email.toLocaleLowerCase() == employee.email.toLocaleLowerCase());
                            if(emailCandidate.length > 0){
                                candidates = emailCandidate;
                            }

                        }
                        return this.openCandidateChooserPopup(employee, candidates).then(e => {
                            resultArray.push(e);
                            return this.handleEmployeeImportStep(employeeImportArray, candidateArray, resultArray, acceptExistingImmediately);
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createdErrorX', [view.$t('global.menubar.employees')]));
                            console.log(error)
                        })
                    }

                }

            }
        },
        startCandidateProcess(newEmployee){
            let view = this;
            let employees = [newEmployee]
            this.getCandidates(employees)
            .then(candidateResult => {
                let selectableItems = view.transformCandidateResult(candidateResult[0]);
                if(selectableItems.length > 0){
                    view.openCandidateChooserPopup(newEmployee, selectableItems).then(e => {
                        if(e.dummy && view.editing){
                            view.transformDummyEmployee(e);
                        } else {
                            view.createNewEmployee(e);
                        }

                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createdErrorX', [view.$t('global.menubar.employees')]));
                        console.log(error)
                    })
                } else {
                    if(newEmployee.dummy && view.editing){
                        view.transformDummyEmployee(newEmployee);
                    } else {
                        view.createNewEmployee(newEmployee);
                    }

                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createdErrorX', [view.$t('global.menubar.employees')]));
                console.log(error)
            })
        },
        getCandidates(employees){
            let view = this;

            let payload = {
                data: []
            }
            employees.forEach(employee => {
                let entry = {
                    firstname: employee.firstName,
                    lastname: employee.lastName,
                }
                if(employee.dob != null){
                    entry.date_of_birth = this.$helpers.getMomentFromStringTZ(employee.dob).format("YYYY-MM-DD");
                }
                if(employee.socialsecurity != null){
                    entry.socialsecurity = employee.socialsecurity;
                }
                payload.data.push(entry);
            })
            let url = '/api/sec/employee/candidates';
            let params ={
                storeId: this.$store.state.storeId,
                companyId: this.$store.state.companyId
            }
            return new Promise((resolve, reject) => {
                this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    let resultData = response.data;
                    //Testdata
                    /*resultData = [{
                        input: {
                            firstName: "Thaddäus",
                            lastName: "Spiegel",
                            dob: "1966-12-29"
                        },
                        result: {
                            matches: [
                                {
                                    id: 414,
                                    firstname: "Thaddäus",
                                    lastname: "Spiegel",
                                    date_of_birth: "1966-12-29 00:00:00",
                                    socialsecurity: null,
                                    company_id: 30
                                }
                            ],
                            candidates: [
                                {
                                    id: 3261,
                                    firstname: "Maximial",
                                    lastname: "Mustermann",
                                    date_of_birth: "2000-01-20 00:00:00",
                                    socialsecurity: "1524",
                                    company_id: 30,
                                    score: 84
                                },
                                {
                                    id: 5366,
                                    firstname: "Max",
                                    lastname: "Mustermann",
                                    date_of_birth: "1966-12-28 09:25:00",
                                    socialsecurity: null,
                                    company_id: 30,
                                    score: 93
                                }
                            ]
                        }

                    }]*/
                    resolve(resultData );
                }).catch(function (error) {
                    reject(error);

                });
            })

        },
        transformCandidateResult(candidateResult){
            let candidates = candidateResult.result.candidates;
            let matches = candidateResult.result.matches;
            let selectableItems = []
            candidates.forEach(candidate => {
                let bd = candidate.date_of_birth != null ? this.$helpers.getMomentFromStringTZ(candidate.date_of_birth).format("DD.MM.YYYY") : '';
                let item = {label: candidate.firstname+" "+candidate.lastname+" "+bd+" "+candidate.score+"%", value: candidate.id, score: candidate.score};
                selectableItems.push(item);
            })
            matches.forEach(candidate => {
                let bd = candidate.date_of_birth != null ? this.$helpers.getMomentFromStringTZ(candidate.date_of_birth).format("DD.MM.YYYY") : '';
                let item = {label: candidate.firstname+" "+candidate.lastname+" "+bd+" 100%", value: candidate.id, score: 100};
                selectableItems.push(item);
            })
            selectableItems.sort((a, b) => {
                return -(a.score - b.score);
            })
            return selectableItems;
        },
        openCandidateChooserPopup(newEmployee, selectableItems){
            let view = this;
            let entries = [];

            selectableItems.unshift({label: this.$t('pages.employeeContext.createEmployee'), value: 'createNew'});


            let description = this.$t('pages.employeeContext.matchEmployeeHelp')

            entries.push(
            {label: this.$t('pages.employeeContext.matchEmployee'), key: 'remoteId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: selectableItems,
                    selectMultiple: false,
                    selectedItems: [],
                    selectFirst: false,
                    styleLight: true,

                }
            });

            return new Promise((resolve, reject) => {
                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: entries,
                        errorCheck: [
                            (entries) => {
                               if(entries.hasOwnProperty('remoteId') && entries['remoteId'] == null){
                                   return {key: 'remoteId', type: 'error', label: view.$t('pages.employeeContext.matchEmployee'), text: view.$t('pages.employeeContext.pleaseSelectOption')}
                               } else {
                                   return null
                               }
                           },
                       ],
                        description: description,
                        selectCallback: function (item) {
                            if(item.remoteId == null){
                                reject(view.$t('pages.employeeContext.pleaseSelectOption'))
                            } else {
                                if(!item.createWithoutId && item.remoteId != 'createNew'){
                                    newEmployee.remoteId = item.remoteId;
                                }
                                else if(item.remoteId == 'createNew'){
                                    newEmployee.remoteId = null;
                                }
                                resolve(newEmployee);
                            }


                        }
                    },
                    header: this.$t('pages.employeeContext.createEmployee') + ': '+newEmployee.firstName+" "+newEmployee.lastName,
                    centered: true,
                    expanded: true,
                });
            })

        },
        createNewEmployee(newEmployee) {
            let view = this;
            let url = '/api/sec/employee';
            let params = {
                storeId: this.$store.state.storeId,
                companyId: this.$store.state.companyId
            }

            let payload = {
                storeId: this.$store.state.storeId,
                socialInsuranceRegistered: newEmployee.socialInsuranceRegistered != null ? newEmployee.socialInsuranceRegistered : false,
            }

            for (var property in newEmployee) {
                if (!this.$helpers.isEmpty(newEmployee[property])) {
                    payload[property] = newEmployee[property];
                    if(property == 'email'){
                        payload[property] = newEmployee[property].toLowerCase().trim();
                    }
                }

            }

            this.$helpers.log(this, 'createNewEmployee()', [newEmployee, payload]);
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                var employee = response.data.data;
                view.employees.push(employee);
                view.employee = employee;
                if(newEmployee.spotId != undefined && newEmployee.spotId != null){
                    let url = '/api/sec/employee/linkspot';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
                    let payload =  {
                        id: view.employee.id,
                        spotId: newEmployee.spotId,
                        deleteOldSkill: false,
                        skillValue: 10,
                    }

                    this.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        if(response.data.type && response.data.type == 'SUCCESS'){
                            view.employee.spotId = newEmployee.spotId;
                            view.commitCurrentEmployeeToStore();

                            view.creatingNewEmployee = false;
                            view.refresh(employee.id, true);
                            view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('global.menubar.employees')]));

                            window.app.popupalerts.push({header: this.$t('pages.employeeContext.linkAccount'), number: null, description: view.$t('pages.employeeContext.linkQuery'), hidden: false, callbackAccept: function(popup){
                                    // link account
                                    view.linkEmployeeAccount();
                                    popup.hidden = true;
                                    view.showModal('modal-proceed-contract');
                                }, callbackCancel: function(popup){
                                    // proceed without link
                                    popup.hidden = true;
                                    view.showModal('modal-proceed-contract');
                                }, acceptLabel: view.$t('global.ui.yes'), cancelLabel: view.$t('global.ui.no'), disableCancel: false
                            });
                        }
                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.saveUnitError'));
                        //view.$emit('updated', view.employee.id, true)
                        //view.editing = false;

                        console.log(error)
                    })
                }else{
                    view.commitCurrentEmployeeToStore();

                    view.creatingNewEmployee = false;
                    view.refresh(employee.id, true);
                    view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('global.menubar.employees')]));

                    window.app.popupalerts.push({header: this.$t('pages.employeeContext.linkAccount'), number: null, description: view.$t('pages.employeeContext.linkQuery'), hidden: false, callbackAccept: function(popup){
                            // link account
                            view.linkEmployeeAccount();
                            popup.hidden = true;
                            view.showModal('modal-proceed-contract');
                        }, callbackCancel: function(popup){
                            // proceed without link
                            popup.hidden = true;
                            view.showModal('modal-proceed-contract');
                        }, acceptLabel: view.$t('global.ui.yes'), cancelLabel: view.$t('global.ui.no'), disableCancel: false
                    });
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), error);
                console.log(error)
                console.log(error.message);
            });
        },
        createNewDummyEmployee(newEmployee) {
            let view = this;
            let url = '/api/sec/employee/dummy';
            let params = {
                storeId: this.$store.state.storeId,
                companyId: this.$store.state.companyId
            }


            let payload = {
                storeId: this.$store.state.storeId,
                socialInsuranceRegistered: newEmployee.socialInsuranceRegistered != null ? newEmployee.socialInsuranceRegistered : false,
            }

            for (var property in newEmployee) {
                if (!this.$helpers.isEmpty(newEmployee[property])) {
                    payload[property] = newEmployee[property];
                }

            }

            this.$helpers.log(this, 'createNewDummyEmployee()', [newEmployee, payload]);
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                var employee = response.data.data;
                view.employees.push(employee);
                view.employee = employee;
                if(newEmployee.spotId != undefined && newEmployee.spotId != null){
                    let url = '/api/sec/employee/linkspot';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
                    let payload =  {
                        id: view.employee.id,
                        spotId: newEmployee.spotId,
                        deleteOldSkill: false,
                        skillValue: 10,
                    }

                    this.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        if(response.data.type && response.data.type == 'SUCCESS'){
                            view.employee.spotId = newEmployee.spotId;
                            view.commitCurrentEmployeeToStore();

                            view.creatingNewEmployee = false;
                            view.refresh(employee.id, true);
                            view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('pages.employeeContext.testEmployee')]));


                        }
                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.saveUnitError'));
                        //view.$emit('updated', view.employee.id, true)
                        //view.editing = false;

                        console.log(error)
                    })
                }else{
                    view.commitCurrentEmployeeToStore();

                    view.creatingNewEmployee = false;
                    view.refresh(employee.id, true);
                    view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('pages.employeeContext.testEmployee')]));


                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), error);
                console.log(error)
                console.log(error.message);
            });
        },
        transformDummyEmployee(employee) {
            let view = this;
            let ok = true;
            let pnOk = true;
            this.$refs.compcoredata.mandatoryFields.forEach(field => {
                let fOk = !this.$refs.compcoredata.mandatoryAndMissing(field);
                ok = ok && fOk;
                if(field == "personnelId" && !fOk){
                    pnOk = false;
                }
            })
            if(ok){
                let url = '/api/sec/employee/dummy';
                let params = {
                    storeId: this.$store.state.storeId,
                    companyId: this.$store.state.companyId
                }

                let payload = {
                    storeId: this.$store.state.storeId,
                    socialInsuranceRegistered: employee.socialInsuranceRegistered != null ? employee.socialInsuranceRegistered : false,
                    updateFields: []
                }

                for (let property in employee) {
                    if(property == 'email' && !this.$helpers.isEmpty(employee[property])){
                        payload[property] = employee[property].toLowerCase().trim();
                    } else {
                        payload[property] = employee[property];
                    }
                    payload.updateFields.push(property)

                }

                this.$helpers.log(this, 'transformDummyEmployee()', [employee, payload]);
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    params: params,
                    data: payload
                }).then(response => {
                    var employee = response.data.data;
                    view.employees.push(employee);
                    view.employee = employee;
                    if(employee.spotId != undefined && employee.spotId != null){
                        let url = '/api/sec/employee/linkspot';
                        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
                        let payload =  {
                            id: view.employee.id,
                            spotId: employee.spotId,
                            deleteOldSkill: false,
                            skillValue: 10,
                        }

                        this.axios({
                            method: 'put',
                            headers: {
                                'AUTHORIZATION': "bearer "+this.$store.state.jwt
                            },
                            url: url,
                            data: payload
                        }).then(response => {
                            if(response.data.type && response.data.type == 'SUCCESS'){
                                view.employee.spotId = employee.spotId;
                                view.commitCurrentEmployeeToStore();

                                view.editing = false;
                                view.refresh(employee.id, true);
                                view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('global.menubar.employees')]));

                                window.app.popupalerts.push({header: this.$t('pages.employeeContext.linkAccount'), number: null, description: view.$t('pages.employeeContext.linkQuery'), hidden: false, callbackAccept: function(popup){
                                        // link account
                                        view.linkEmployeeAccount();
                                        popup.hidden = true;

                                    }, callbackCancel: function(popup){
                                        // proceed without link
                                        popup.hidden = true;

                                    }, acceptLabel: view.$t('global.ui.yes'), cancelLabel: view.$t('global.ui.no'), disableCancel: false
                                });
                            }
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.saveUnitError'));
                            //view.$emit('updated', view.employee.id, true)
                            //view.editing = false;

                            console.log(error)
                        })
                    }else{
                        view.commitCurrentEmployeeToStore();

                        view.editing = false;
                        view.refresh(employee.id, true);
                        view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('global.menubar.employees')]));

                        window.app.popupalerts.push({header: this.$t('pages.employeeContext.linkAccount'), number: null, description: view.$t('pages.employeeContext.linkQuery'), hidden: false, callbackAccept: function(popup){
                                // link account
                                view.linkEmployeeAccount();
                                popup.hidden = true;

                            }, callbackCancel: function(popup){
                                // proceed without link
                                popup.hidden = true;

                            }, acceptLabel: view.$t('global.ui.yes'), cancelLabel: view.$t('global.ui.no'), disableCancel: false
                        });
                    }
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), error);
                    console.log(error)
                    console.log(error.message);
                });
            } else {
                if(!pnOk){
                    this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheckPN'));
                } else {
                    this.$helpers.error(this.$t('pages.employeeCoreData.errorSavingHeader'), this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheck'));
                }

            }

        },
        openDeleteEmployeeModal(employee){
            let view = this;
            let description = view.$t('pages.employeeContext.deleteEmployeeQuery', [employee.firstName, employee.lastName]) +
                              "<b>" + view.$t('global.ui.warning') + ":</b> <ul>"+
                              "<li>" + view.$t('pages.employeeContext.deleteEmpHelp1') + "</li>"+
                              "<li>" + view.$t('pages.employeeContext.deleteEmpHelp2') + "</li></ul><br>"+
                              view.$t('pages.employeeContext.deleteEmpHelp3') + "'<b>DELETE</b>':";
            let dataEntries = [];
            dataEntries.push({label: this.$t('indicator.main.confirmDelete'), key: "confirmDeletion", hidden: false, type: 'text', value: ''});


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                        (entries) => {
                            if(entries['confirmDeletion'] == null || entries['confirmDeletion'].length == 0 || entries['confirmDeletion'] != 'DELETE'){
                                return {key: 'confirmDeletion', type: 'error', label: view.$t('global.notifications.error'), text: view.$t('pages.employeeContext.confirmInvalid')}
                            } else {
                                return null
                            }
                        },

                    ],
                    description: description,
                    selectCallback: function (data) {
                        if(data.confirmDeletion == 'DELETE'){
                            view.deleteEmployee(employee);
                        } else {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.main.deleteUnconfirmed'));
                        }

                    }
            },
                header: view.$t('pages.employeeContext.finalDelete'),
                expanded: true,
                centered: true
             });

        },
        deleteEmployee(employee){
            let view = this;
            let url = '/api/sec/employee';

            let params = {
                storeId: view.$store.state.storeId,
                id: employee.id
            }

            view.axios({
                method: 'delete',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.ui.deletedX', [view.$t('global.menubar.employees')]));
                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'employeePreferenceMapState', 'employeeContractMapState', 'currentMonthEmployeeContractMapState', 'employeeWorkbalanceMapState', 'employeeMapState', 'employeeAvailabilityMapState']});
                view.refresh(null, true);
                view.$forceUpdate();
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deletedErrorX', [view.$t('global.menubar.employees')]));
                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'employeePreferenceMapState', 'employeeContractMapState', 'currentMonthEmployeeContractMapState', 'employeeWorkbalanceMapState', 'employeeMapState', 'employeeAvailabilityMapState']});
                view.refresh(null, true);
             });
        },
        openTransferEmployeeModal(employee){
            let view = this;
            let description = view.$t('pages.employeeContext.transferEmployeeQuery', [employee.firstName, employee.lastName]);
            let storeItems = this.selectableStores.map(i => {return {label: i.label, value: i}});
            let dataEntries = [];
            dataEntries.push(
                {
                    label: view.$t('pages.employeeContext.targetStore'), key: 'store', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: storeItems,
                        selectMultiple: false,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: view.$t('pages.employeeContext.selectStore'),
                    }
                }
            );
            dataEntries.push({label: view.$t('global.ui.copyX', [view.$tc('global.ui.contracts', 2)]), key: 'copyContract',hidden: false, type: "bool", value: false});
            dataEntries.push({label: view.$t('global.ui.copyX', [view.$t('global.menubar.workbalance')]), key: 'copyWorkBalances',hidden: true, type: "bool", value: true,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let copyContract = datafill.entries.find(i => i.key == 'copyContract').value;
                    if(copyContract){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = true;
                    }
                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: view.$t('global.ui.copyX', [view.$t('global.menubar.preferences')]), key: 'copyEmployeePreferences', hidden: true, type: "bool", value: true,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let copyContract = datafill.entries.find(i => i.key == 'copyContract').value;
                    if(copyContract){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = true;
                    }
                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({label: view.$t('global.ui.copyX', [view.$t('pages.employeeData.documents')]), key: 'copyEmployeeFiles',hidden: false, type: "bool", value: true});
            let from = this.$helpers.getMomentTZ().endOf('month').add(1, 'days').startOf('day').format();
            dataEntries.push( {label: this.$t('global.general.contractStart'), key: 'contractStart', hidden: true, type: 'date', value: from,
                               computed: (datafill, lastVal, entryBeforeUpdate) => {
                                    let copyContract = datafill.entries.find(i => i.key == 'copyContract').value;
                                    if(copyContract){
                                        entryBeforeUpdate.hidden = false;
                                    } else {
                                        entryBeforeUpdate.hidden = true;
                                    }
                                    return entryBeforeUpdate;
                                }
            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (data) {
                        let payload = {}
                        payload.employeeId = employee.id;
                        if(data.store){
                            payload.targetStoreId = data.store.id;
                            payload.targetCompanyId = data.store.companyId;
                        }
                        if(data.copyContract && data.contractStart != null){
                            payload.copyContract = true;
                            payload.contractDate = data.contractStart.format();

                        } else {
                            payload.copyContract = false;
                        }
                        if(data.copyContract && data.copyEmployeePreferences){
                            payload.copyEmployeePreferences = data.copyEmployeePreferences;
                            payload.ewbToDate = data.contractStart.format();
                        } else {
                            payload.copyEmployeePreferences = false;
                        }
                        if(data.copyEmployeeFiles){
                            payload.copyEmployeeFiles = data.copyEmployeeFiles;

                        } else {
                            payload.copyEmployeeFiles = false;
                        }


                        if(data.copyContract && data.copyWorkBalances){
                            payload.copyWorkBalances = data.copyWorkBalances;
                            payload.ewbToDate = data.contractStart.clone().startOf('month').add(-1, 'days').format();
                        } else {
                            payload.copyWorkBalances = false;
                        }
                        view.checkEmployeeExistsForTargetStore(payload)
                        .then(res => {
                            return view.checkEmployeeContractForTargetStore(payload);
                        })
                        .then(res => {
                            if(data.copyWorkBalances){
                                window.setTimeout(() => {
                                    view.RecalculateCurrentMonthWorkbalances(employee.id, data.contractStart.month(), data.contractStart.year())
                                    .then(res => {
                                        view.transferEmployee(payload);
                                    }).error(error => {
                                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.monthEndRecalcError'));
                                        console.log(error);
                                    })
                                }, 200);

                            } else {
                                view.transferEmployee(payload);
                            }
                        }).catch(error => {

                            let errordesc = view.$t('pages.employeeContext.employeeTransferError') + ":<br/><p><b>"+error.message+"</b></p>"
                            view.$helpers.OpenPopup({
                                type: 'datafill',
                                componentState: {
                                    entries: [],
                                    description: errordesc,
                                    selectCallback: function (data) {

                                    }
                                },
                                header: view.$t('pages.employeeContext.transferError'),
                                expanded: true,
                                centered: true
                            });
                            view.$helpers.error(view.$t('global.notifications.error'), error.message);
                        })



                    }
                },
                header: this.$t('pages.employeeContext.transferEmployees'),
                expanded: true,
                centered: true
             });

        },
        checkEmployeeExistsForTargetStore(payload){
            let view = this;
            let employee = view.employeeMap[payload.employeeId];
            return new Promise((resolve, reject) => {
                if(employee.email != null){
                    let url = "/api/sec/employee"
                    let params = {
                        storeId: payload.targetStoreId,
                        email: employee.email
                    }
                    view.axios({
                        method: 'get',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + view.$store.state.jwt
                        },
                        url: url,
                    }).then(response => {
                        let existingEmployee = response.data.find(e => e.email == employee.email);
                        if(existingEmployee != null){
                           reject(new Error(view.$t('pages.employeeContext.existsInTargetStore')+existingEmployee.lastName+" "+existingEmployee.firstName))
                        } else {
                           resolve();
                        }

                    }).catch(function (error) {
                        reject(new Error(view.$t('global.notifications.dataLoadingError')))

                    });
                } else {
                    resolve();
                }
            }).then(res => {
                return new Promise((resolve, reject) => {
                    let url = "/api/sec/employee"
                    let params = {
                        storeId: payload.targetStoreId,
                        remoteId: employee.remoteId
                    }
                    view.axios({
                        method: 'get',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + view.$store.state.jwt
                        },
                        url: url,
                    }).then(response => {
                        let existingEmployee = response.data.find(e => e.remoteId == employee.remoteId);
                        if(existingEmployee != null){
                           reject(new Error(view.$t('global.notifications.empInTargetStore')+existingEmployee.lastName+" "+existingEmployee.firstName))
                        } else {
                           resolve();
                        }

                    }).catch(function (error) {
                        reject(new Error(view.$t('global.notifications.dataLoadingError')))

                    });
                })
            });
        },
        checkEmployeeContractForTargetStore(payload){
            let view = this;
            if(payload.copyContract){
                let contracts = Object.values(this.employeeContractMap)
                                .filter(c => c.employeeId == payload.employeeId).sort((a, b) => view.$helpers.getMomentFromStringTZ(b.from).unix() - view.$helpers.getMomentFromStringTZ(a.from).unix());

                if(contracts.length > 0){
                    let lastContract = contracts[0];
                    if(lastContract.collectiveContractId != null){
                        //need to check if target Store has same allowed contract model
                        let allowedContract = view.allowedContractMap[lastContract.collectiveContractId];
                        return new Promise( (resolve, reject) => {
                            let url = "/api/sec/allowedcontract"
                            let params = {
                                storeId: payload.targetStoreId,
                            }
                            view.axios({
                                method: 'get',
                                params: params,
                                headers: {
                                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                                },
                                url: url,
                            }).then(response => {
                                let validAllowedContract = response.data.find(d => d.collectiveContractId == allowedContract.collectiveContractId && d.weekTimeRegular == allowedContract.weekTimeRegular);
                                if(validAllowedContract != null){
                                    resolve();
                                } else {
                                    reject(new Error(view.$t('pages.employeeContext.targetStoreModelMissing', [view.storeSettings.country == 1 ? view.$t('pages.employeeContext.collectiveContractModel') : view.$t('pages.employeeContract.contractModel')])))
                                }

                            }).catch(function (error) {
                                reject(new Error(view.$t('pages.employeeContext.contractDataError')))

                            });
                        })
                    } else {
                        //need to check if target store allows contracts without allowedContract
                        return new Promise( (resolve, reject) => {
                            let url = "/api/sec/storesettings"
                            let params = {
                                storeId: payload.targetStoreId,
                                id: payload.targetStoreId,
                            }
                            view.axios({
                                method: 'get',
                                params: params,
                                headers: {
                                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                                },
                                url: url,
                            }).then(response => {
                                if(!response.data.collectiveContractRequired){
                                    resolve();
                                } else {
                                    reject(new Error(view.$t('pages.employeeContext.targetStoreError', [view.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')])))
                                }

                            }).catch(function (error) {
                                reject(new Error(view.$t('pages.employeeContext.loadingStoreConfigError')))

                            });
                        })
                    }
                } else {
                    return new Promise((resolve, reject) => {
                        resolve();
                    })
                }
            } else {
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        RecalculateCurrentMonthWorkbalances(employeeId, month, year) {
            let view = this;
            let employeeIds = [employeeId];

            let yearDate = this.$helpers.getMomentFromValuesUTC(year, Math.max(0, month-1), 1).add(1, 'months');

            view.loading= true;
            view.loadingText =this.$t('pref.main.updateMonthEndClosings')
            return this.$refs.employeeworkbalancecreation.recalculatePastInvalid(yearDate, employeeIds).then(res => {
                view.loading = false;
                view.loadingText =""
                return new Promise((accept, resolve) => {
                    accept(true);
                })
            }).catch(error => {
                view.loading = false;
                view.loadingText =""
                console.log(error);
                return new Promise((accept, resolve) => {
                    accept(false);
                })
            });
        },
        transferEmployee(data){
            let view = this;
            let url = '/api/sec/employee/transfer';

            let params = {
                storeId: view.$store.state.storeId,

            }
            let payload  = {
                employeeId: data.employeeId,
                targetStoreId: data.targetStoreId,
                targetCompanyId: data.targetCompanyId,
                copyContract: data.copyContract,
                copyWorkBalances: data.copyWorkBalances,
                copyEmployeePreferences: data.copyEmployeePreferences,
                copyEmployeeFiles: data.copyEmployeeFiles,
                ewbToDate: data.ewbToDate,
                contractDate: data.contractDate,
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.employeeContext.employeeTransferred'));

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.transferEmployeeError'));

             });
        },

        proceedWithContract(){
            this.hideModal('modal-proceed-contract');
            this.selectedPage = 'contract';
        },
        openEmployeeActivateDeactiveModal(){
            let view = this;
            let employee = this.employee;
            if(employee){
                if(employee.active){
                    if(this.employeeContract != null && this.employeeContract.to != null && this.$helpers.getMomentFromStringTZ(this.employeeContract.to).isAfter(this.$helpers.getMomentTZ())){
                        let endDate = this.$helpers.getMomentFromStringTZ(this.employeeContract.to).format("DD.MM.YYYY");
                        let description = view.$t('pages.employeeContext.cantDeactivate') +
                                          view.$t('pages.employeeContext.cantDeactivateHelp');
                        view.$helpers.OpenPopup({
                            type: 'datafill',
                            componentState: {
                                entries: [],

                                description: description,
                                selectCallback: function (data) {

                                }
                            },
                            header: view.$t('pages.employeeContext.deactivateNotPossible'),
                            expanded: true,
                            centered: true
                        });
                    } else {
                        let description = view.$t('pages.employeeContext.activeCanPlan') + "<br/>" +
                            view.$t('pages.employeeContext.deactivateQuery', [employee.lastName, employee.firstName]) + "<br/>"+
                              "<b style='color: red'>" + view.$t('global.ui.warning') + ":</b> <ul>"+
                              "<li>" + view.$t('pages.employeeContext.deactivateHelp1') + "</li>"+
                              "<li>" + view.$t('pages.employeeContext.deactivateHelp2') + "</li>"+
                              "<li>" + view.$t('pages.employeeContext.deactivateHelp3') + "</li>"+
                              "<li>" + view.$t('pages.employeeContext.deactivateHelp4') + "</li></ul><br>"+
                              view.$t('pages.employeeContext.deactivateHelp5') + " '<b>DEAKTIVIEREN</b>':";
                        let dataEntries = [];
                        dataEntries.push({label: view.$t('pages.employeeContext.unlinkAccount'), key: "deleteAccountId", hidden: true, type: 'bool', value: true});
                        dataEntries.push({label: view.$t('pages.employeeContext.removeUserRole'), key: "deleteRole", hidden: false, type: 'bool', value: false});
                        dataEntries.push({label: view.$t('pages.employeeContext.confirmDeactivation'), key: "confirmDeactivate", hidden: false, type: 'text', value: ''});


                        view.$helpers.OpenPopup({
                            type: 'datafill',
                            componentState: {
                                entries: dataEntries,
                                errorCheck: [
                                        (entries) => {
                                            if(entries['confirmDeactivate'] == null || entries['confirmDeactivate'].length == 0 || entries['confirmDeactivate'] != 'DEAKTIVIEREN'){
                                                return {key: 'confirmDeactivate', type: 'error', label: view.$t('global.notifications.error'), text: view.$t('pages.employeeContext.confirmInvalid')}
                                            } else {
                                                return null
                                            }
                                        },

                                ],
                                description: description,
                                selectCallback: function (data) {
                                    if(data.confirmDeactivate == 'DEAKTIVIEREN'){
                                        view.deactivateEmployee(data.deleteAccountId, data.deleteRole);
                                    } else {
                                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.confirmInvalid'));
                                    }

                                }
                            },
                            header: view.$t('pages.employeeData.messages.deactivateEmployee'),
                            expanded: true,
                            centered: true
                        });
                    }

                } else {
                    let description = view.$t('pages.employeeContext.inactiveCantPlan') + "<br/>" +
                              view.$t('pages.employeeContext.activateQuery')

                    window.app.popupalerts.push({header: view.$t('pages.employeeData.messages.activateEmployee'),
                        description: description,
                        hidden: false,
                        callbackAccept: function(popup){
                            popup.loading = true;


                            view.activateEmployee(() => {
                                popup.loading = false;
                                popup.hidden = true;
                            }, () => {
                                popup.loading = false;
                                popup.hidden = true;
                            })

                        }, callbackCancel: function(popup){
                            popup.loading = false;
                            popup.hidden = true;

                    }});
                }

            }


        },
        openEmployeeAccountModal(){
            this.showModal('modal-employee-account');
        },
        linkEmployeeAccount(){
            let view = this;
            let url = '/api/sec/employee/linkaccount';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkaccount');
            url = this.$helpers.appendParam("id", this.employee.id, url, '/api/sec/employee/linkaccount');

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.employee.accountId=response.data.data;
                view.commitCurrentEmployeeToStore();
                view.employees.forEach(e => { if(e.id == view.employee.id) e.accountId=response.data.data; });
                view.dataFiltered.forEach(e => { if(e.id == view.employee.id) e.accountId=response.data.data; });
                view.hideModal('modal-employee-account');
                view.updateEmployeeGridDataMetadata();
                view.$helpers.success(view.$t('pages.employeeData.messages.accountConnected'), '');
            }).catch(function (error) {
                view.hideModal('modal-employee-account');
                view.$helpers.error(view.$t('global.notifications.error'), error);
                console.log(error)
            })
        },
        unlinkEmployeeAccount(){
            let view = this;
            let url = '/api/sec/employee/unlinkaccount';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/unlinkaccount');
            url = this.$helpers.appendParam("id", this.employee.id, url, '/api/sec/employee/unlinkaccount');

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.employee.accountId=null;
                view.useraccount = null;
                view.commitCurrentEmployeeToStore();
                view.employees.forEach(e => { if(e.id == view.employee.id) e.accountId=null; });
                view.dataFiltered.forEach(e => { if(e.id == view.employee.id) e.accountId=null; });
                view.hideModal('modal-employee-account');
                view.updateEmployeeGridDataMetadata();
                view.$helpers.success(view.$t('pages.employeeContext.linkRemoved'), '');
            }).catch(function (error) {
                view.hideModal('modal-employee-account');
                view.$helpers.error(view.$t('global.notifications.error'), error);
                console.log(error)
            })
        },

        openFutureShiftWarningPopup(months){
            let view = this;
            let description = view.$t('pages.employeeContext.cantDeactivateWithShifts') + ": <br/>";

            let dataEntries = [];
            months.forEach(month => {
                let label = this.$helpers.getMomentFromStringTZ(month).format("MMMM YYYY");
                dataEntries.push({label: label, key: label, hidden: false, type: 'bool', value: true, disabled: true})

            })


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (data) {

                    },

                },
                header: this.$t('global.ui.warning'),
                expanded: true,
                centered: true
            });
        },
        fetchFutureShiftMonths(){
            let view = this;
            let url = '/api/sec/planshift/futuremonth';


            let params = {
                storeId: this.$store.state.storeId,
                employeeId: this.employee.id,
            }


            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            });
        },
        deactivateEmployee(deleteAccountId = false, deleteRole = false){


            let view = this;
            let url = '/api/sec/employee/deactivate';


            let contract = this.employeeContractForEmployee(this.employee);
            let deactDate = this.$helpers.getMomentTZ().add(1, 'days').startOf('day');
            let deleteContract = false;
            let isFutureContract = false;

            if(contract){
                let contractStartDate = this.$helpers.getMomentFromStringTZ(contract.from);
                if(deactDate <= contractStartDate){
                    deleteContract = true;
                }
            } else {
                contract = this.earliestFutureContractForEmployee(this.employee);
                if(contract){
                    let contractStartDate = this.$helpers.getMomentFromStringTZ(contract.from);
                    if(deactDate <= contractStartDate){
                        deleteContract = true;
                        isFutureContract = true;
                    }
                }
            }
            let datestring = deactDate.format();


            let params = {
                storeId: this.$store.state.storeId,
                id: this.employee.id,
                contractId: contract != null ? (contract.to == null || isFutureContract ? contract.id : null) : null,
                exitDate: datestring,
                deleteContract: deleteContract,
                deleteAccountId: deleteAccountId,
                deleteRole: deleteRole
            }


            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.employee.active=false;
                if(deleteAccountId){
                    view.employee.accountId = null;
                }
                view.commitCurrentEmployeeToStore();
                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'employeeMapState', 'employeePreferenceMapState', 'employeeContractMapState', 'currentMonthEmployeeContractMapState']});
                view.employees.forEach(e => { if(e.id == view.employee.id){
                    e.active=false; e.ruleId = null; e.typeId = null;
                    if(deleteAccountId){
                        e.accountId = null;
                    }
                }});
                view.dataFiltered.forEach(e => { if(e.id == view.employee.id){
                    e.active=false; e.ruleId = null; e.typeId = null;
                    if(deleteAccountId){
                        e.accountId = null;
                    }
                }});

                view.updateEmployeeGridDataMetadata();
                view.refresh(null, true);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.employeeContext.deactivatedEmployee'));
            }).catch(function (error) {
                console.log(error)
                if (error.response && error.response.status == 400) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.notInActiveMonth'));
                } else {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.deactivateEmployeeError'));
                }

            })

        },
        activateEmployee(finishCallback, errorCallback){
            let view = this;
            let url = '/api/sec/employee/activate';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/activate');
            url = this.$helpers.appendParam("id", this.employee.id, url, '/api/sec/employee/activate');


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.employee.active=true;
                view.commitCurrentEmployeeToStore();
                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'employeeMapState', 'employeeWorkbalanceMapState', 'employeePreferenceMapState', 'employeeContractMapState', 'currentMonthEmployeeContractMapState']});
                view.employees.forEach(e => { if(e.id == view.employee.id) e.active=true; });
                view.dataFiltered.forEach(e => { if(e.id == view.employee.id) e.active=true; });

                view.updateEmployeeGridDataMetadata();
                view.$helpers.success(view.$t('pages.employeeContext.employeeActivated'), '');
                if(finishCallback != null){
                    finishCallback();
                }
            }).catch(function (error) {
                console.log(error)

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeContext.activateEmployeeError'));
                if(errorCallback != null){
                    errorCallback();
                }
            })

        },
        toggleUseRosterChecks(finishCallback, errorCallback){
            let view = this;
            let url = '/api/sec/employee/togglecheckroster';
            let params = {
                storeId: this.$store.state.storeId,
                id: this.employee.id
            }



            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.employee.useRosterChecks=!view.employee.useRosterChecks;
                let val = view.employee.useRosterChecks;
                view.employee = Object.assign({}, view.employee);
                view.commitCurrentEmployeeToStore();
                view.employees.forEach(e => { if(e.id == view.employee.id) e.useRosterChecks=val; });
                view.dataFiltered.forEach(e => { if(e.id == view.employee.id) e.useRosterChecks=val; });

                view.updateEmployeeGridDataMetadata();
                view.$helpers.success(this.$t('global.notifications.success'), view.$t('global.ui.editedX', [view.$tc('global.ui.setting')]));
                if(finishCallback != null){
                    finishCallback();
                }
            }).catch(function (error) {
                console.log(error)

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.ui.setting')]));
                if(errorCallback != null){
                    errorCallback();
                }
            })

        },

        infoPopup(title, message) {
            this.infoTitle = title;
            this.infoMessage = message;
            this.showModal('modal-info');
        },
        countryLabel(id){
            this.uiDataMap.countries.forEach(c => { if(c.id == id) return c.label_de; });
            return '';
        },
        labelForId(list, id){
            list.forEach(c => { if(c.id == id) return c.label_de; });
            return '';
        },
        currentEntryDateEqualsFirstEntryDate(employee){
            let first = this.employeeContractEntryDate(employee,true);
            let current = this.employeeContractEntryDate(employee,false);
            return first == current;
        },
        employeeContractEntryDate(employee, first){
            var firstFrom = '-';
            if(employee.workEntryDate != null && first){
                firstFrom = this.$helpers.getMomentFromStringTZ(employee.workEntryDate).format('DD.MM.YYYY');
            } else {
                var contract = this.employeeContractForEmployee(employee);
                var pastContracts = this.employeeContractsForEmployeeWithType(employee, 0);
                var futureContracts = this.employeeContractsForEmployeeWithType(employee, 2);


                if(contract != null){
                    firstFrom = this.$helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY');
                }
                var d;
                pastContracts.forEach((pc) => {
                    var curFrom = this.$helpers.getMomentFromStringTZ(pc.from);
                    if(d == null || curFrom < d) d = curFrom;
                });
                if(d != null) firstFrom = d.format('DD.MM.YYYY');
                if(first){
                    return firstFrom;
                }else{
                    var from = '';

                    let c = contract;
                    if(c == null && futureContracts.length > 0){
                        var nextFrom;
                        futureContracts.forEach((fc) => {
                            var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                            if(nextFrom == null){
                                nextFrom = curFrom;
                                c = fc;
                            }else{
                                if(curFrom < nextFrom){
                                    nextFrom = curFrom;
                                    c = fc;
                                }
                            }
                        });
                    }
                    if(c != null){
                        from = this.$helpers.getMomentFromStringTZ(c.from);
                        let preceeding = this.getPreceedingContract(c, pastContracts);
                        while(preceeding != null){
                            from = this.$helpers.getMomentFromStringTZ(preceeding.from);
                            c = preceeding;
                            preceeding = this.getPreceedingContract(c, pastContracts);
                        }

                        return from.format('DD.MM.YYYY');
                    }
                }
            }

            return firstFrom;
        },
        employeeContractExitDate(employee, asMoment = false){
            let lastTo = '-';
            let contract = this.employeeContractForEmployee(employee);
            let pastContracts = this.employeeContractsForEmployeeWithType(employee, 0);
            let futureContracts = this.employeeContractsForEmployeeWithType(employee, 2);

            let d;
            if(contract != null){
                if(contract.to != null){
                    d = this.$helpers.getMomentFromStringTZ(contract.to);

                }

            } else {
                pastContracts.forEach((pc) => {
                    if(pc.to != null){
                        let curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                        if(d == null || curTo > d){
                            d = curTo;
                        }
                    }
                });
            }
            let fcFrom = null;
            futureContracts.forEach((fc) => {
                let curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                if(fc.to != null){
                    let curTo = this.$helpers.getMomentFromStringTZ(fc.to);

                    if((d == null || curTo > d) && (fcFrom == null || curFrom > fcFrom)){
                        d = curTo;
                        fcFrom = curFrom;
                    }
                } else if(fcFrom == null || curFrom > fcFrom) {
                    d = null;
                    fcFrom = curFrom;
                }
            });

            if(asMoment){
                if(d != null){
                    return d;
                } else {
                    return null;
                }
            } else {
                if(d != null){
                    d = d.add(-1, 'days');
                    lastTo = d.format('DD.MM.YYYY');
                }
                return lastTo;
            }



            


            
        },
        getPreceedingContract(contract, otherContracts){
            let from = this.$helpers.getMomentFromStringTZ(contract.from);
            let prec;
            otherContracts.forEach((pc) => {
                let to = this.$helpers.getMomentFromStringTZ(pc.to);
                let diff = this.$helpers.TimeDiff(from, to);
                if(diff == 0){
                    prec = pc;
                }
            });
            return prec;
        },
        getEmployeeCsvHeaders(){
            return [
                this.$t('pages.employeeCoreData.personnelNumber'),
                this.$t('pages.employeeCoreData.firstName'),
                this.$t('pages.employeeCoreData.lastName'),
                'Beginn',
                this.$t('pages.employeeData.dateOfBirth'),
                'SVNummer',
                'Steuernummer',
                'Krankenkasse',
                'Krankenkasse Adresse',
                this.$t('pages.employeeCoreData.nationality'),
                this.$t('pages.employeeCoreData.citizenType'),
                'Anschrift',
                this.$t('pages.employeeCoreData.postalCode'),
                'Ort',
                this.$t('pages.employeeCoreData.country'),
                this.$t('pages.employeeCoreData.homephone'),
                this.$t('pages.employeeCoreData.email'),
                this.$t('pages.employeeCoreData.iban'),
                this.$t('pages.employeeCoreData.bic'),
                this.$t('pages.employeeCoreData.gender'),
                this.$t('pages.employeeCoreData.workExperience'),
                this.$t('pages.employeeContract.jobName'),
                this.$t('pages.employeeContract.category'),
                this.$t('pages.employeeContract.weekTimeRegular'),
                'Lohn'
            ];
        },
        employeeFieldForCsvHeader(header, employee, contract){
            switch(header){
                case this.$t('pages.employeeCoreData.personnelNumber'): return employee.personnelId;
                case this.$t('pages.employeeCoreData.firstName'): return employee.firstName;
                case this.$t('pages.employeeCoreData.lastName'): return employee.lastName;
                case 'Beginn': return this.employeeContractEntryDate(employee, false);
                case this.$t('pages.employeeData.dateOfBirth'): return (contract != null? this.$helpers.extractDateString(employee.dob, 'DD.MM.YYYY', false) : '');
                case 'SVNummer': return employee.socialsecurity;
                case 'Steuernummer': return employee.taxId;
                case 'Krankenkasse': return employee.healthInsurance;
                case 'Krankenkasse Adresse': return employee.healthInsuranceAddress;
                case this.$t('pages.employeeCoreData.workExperience'): return employee.workExperience;
                case this.$t('pages.employeeCoreData.nationality'): return employee.nationality != null && this.countryMap[employee.nationality] ? (this.countryMap[employee.nationality]) : '';
                case this.$t('pages.employeeCoreData.citizenType'): return employee.citizenType != null && this.citizenTypeMap[employee.citizenType] ? (this.citizenTypeMap[employee.citizenType]) : '';
                case 'Anschrift': return employee.address;
                case this.$t('pages.employeeCoreData.postalCode'): return employee.postalCode;
                case 'Ort': return employee.city;
                case this.$t('pages.employeeCoreData.country'): return employee.country != null && this.countryMap[employee.country] ? (this.countryMap[employee.country]) : '';
                case this.$t('pages.employeeCoreData.homephone'): return employee.mobilephone != null? employee.mobilephone : employee.homephone;
                case this.$t('pages.employeeCoreData.email'): return employee.email;
                case this.$t('pages.employeeCoreData.iban'): return employee.iban;
                case this.$t('pages.employeeCoreData.bic'): return employee.bic;
                case this.$t('pages.employeeCoreData.gender'): return employee['gender'] == 'F'? 'weiblich' : employee['gender'] == 'M'? 'männlich' : 'divers';
                case this.$t('pages.employeeContract.jobName'): return contract != null? contract.jobName : '';
                case this.$t('pages.employeeContract.category'): return (contract != null && contract.employeeCategory != null) ? contract.employeeCategory : '';
                case this.$t('pages.employeeContract.weekTimeRegular'): return (contract != null? (contract.weekTimeRegular / 60).toFixed(2) : '');
                case 'Lohn': return (contract != null? this.$helpers.formatPayment(contract.payment) : '');
            }
        },
        printEmployeeCSV(employee){
            let fileName = (employee.personnelId != null ? (employee.personnelId+ '_') : "")+employee.firstName + '_' + employee.lastName+".csv";


            let csvPre = "data:text/csv;charset=utf-8,";
            var contract = this.employeeContractForEmployee(employee);
            var futureContracts = this.employeeContractsForEmployeeWithType(employee, 2);

            if(contract == null && futureContracts.length > 0){
                var nextFrom;
                futureContracts.forEach((fc) => {
                    var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                    if(nextFrom == null){
                        nextFrom = curFrom;
                        contract = fc;
                    }else{
                        if(curFrom < nextFrom){
                            nextFrom = curFrom;
                            contract = fc;
                        }
                    }
                });
            }
            let headers = this.getEmployeeCsvHeaders();

            let fields = [];

            headers.forEach((header) => {
                fields.push(this.employeeFieldForCsvHeader(header, employee, contract));
            });

            if(this.$refs.compcoredata.externalService && this.$refs.compcoredata.externalId && this.$refs.compcoredata.externalId != ''){
                headers.push(this.$refs.compcoredata.externalService.name +" ID");
            }
            if(this.$refs.compcoredata.externalService && this.$refs.compcoredata.externalId && this.$refs.compcoredata.externalId != ''){
                fields.push(this.$refs.compcoredata.externalId);
            }
            let csv = headers.join(";");
            csv += "\n";
            csv += fields.join(";");

            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", fileName);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        printEmployee(employee){
            let filetitle = employee.lastName + ' ' + employee.firstName;
            let filename = employee.lastName + '_' + employee.firstName + '_Datenblatt.pdf';
            var imgData = null;
            if(employee.employeePicture != null){
                var elem = document.getElementById("employee-picture-img");

                var canvas = document.createElement('canvas');
                canvas.width = elem.naturalWidth; // or 'width' if you want a special/scaled size
                canvas.height = elem.naturalHeight; // or 'height' if you want a special/scaled size

                canvas.getContext('2d').drawImage(elem, 0, 0);

                // Get raw image data
                imgData = canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, '');
                if(imgData == 'data:,'){
                    imgData = null;
                }
            }

            var repDoc = this.$helpers.employeeDataReportDoc(employee.lastName + ' ' + employee.firstName, imgData, this.storeSettings.name);//, employee.email);
            var doc = repDoc.doc;
            var page = 1;
            var prevPage = page;
            var contentOffsetY = repDoc.contentOffsetY;
            var curY = contentOffsetY;
            var prevDataY = curY;
            var offset = {offsetY: curY, page: page};

            doc.rect(13.9, curY-0.2, 182.2, 297 - curY - 15);
            doc, curY = this.$helpers.reportHeaderColorBlock(doc, this.$t('pages.employeeContext.general'), curY);

            // fetch contract info
            var contract = this.employeeContractForEmployee(employee);
            var pastContracts = this.employeeContractsForEmployeeWithType(employee, 0);
            var futureContracts = this.employeeContractsForEmployeeWithType(employee, 2);

            var firstFrom = '';
            var d;
            pastContracts.forEach((pc) => {
                var curFrom = this.$helpers.getMomentFromStringTZ(pc.from);
                if(d == null || curFrom < d) d = curFrom;
            });
            if(d != null) firstFrom = d.format('DD.MM.YYYY');
            var from = '';
            var to = '';
            var payment = '';
            var weekWorkDaysRegular = 0;
            var weekTimeRegular = 0;
            var employmentType = '';
            var employeeCategory = '';
            var jobName = '';
            var probation = '';
            var probationTo = '';
            let deadlineTo = '';
            let wageGroup = '';
            var paymentType = '';
            let pregnant = false;

            if(contract != null){
                from = this.$helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY');
                if(firstFrom == '') firstFrom = from;
                if(contract.to != null){
                    to = this.$helpers.extractDateStringTZ(contract.to, 'DD.MM.YYYY', true);
                }
                payment = this.$helpers.formatPayment(contract.payment + contract.extraPayment);
                pregnant = contract.pregnant != null ? contract.pregnant  : false;
                weekTimeRegular = contract.weekTimeRegular / 60;
                weekWorkDaysRegular = contract.weekWorkDaysRegular;
                if(contract.employmentType != null){
                    this.uiDataMap.employmentTypes.forEach((et) => {
                        if(et.id == contract.employmentType) employmentType = et['label_de'];
                    });
                }
                if(contract.employeeCategory != null){
                    this.uiDataMap.employeeCategories.forEach((et) => {
                        if(et.id == contract.employeeCategory) employeeCategory = et['label_de'];
                    });
                }
                jobName = contract.jobName;
                if(contract.probation || contract.probationTo != null){
                    probation = this.$t('global.ui.yes');
                    probationTo = this.$helpers.extractDateStringTZ(contract.probationTo, 'DD.MM.YYYY', true);
                }else{
                    probation = this.$t('global.ui.no');
                }
                if(contract.deadlineTo){
                    deadlineTo = this.$helpers.extractDateStringTZ(contract.deadlineTo, 'DD.MM.YYYY', true);
                }
                this.uiDataMap.paymentTypes.forEach((t) => {
                    if(t.id == contract.paymentType) paymentType = t['label_de'];
                });
                if(contract.mlWageGroup != null && this.mlWageGroupMap[contract.mlWageGroup] != null){
                    wageGroup = this.mlWageGroupMap[contract.mlWageGroup].name
                }
            }
            // TODO check this keylist translations
            let data = [
                { key: this.$t('pages.employeeCoreData.lastName'), value: employee.lastName},
                { key: this.$t('pages.employeeCoreData.firstName'), value: employee.firstName},
                { key: "PLZ/Stadt", value: (employee.postalCode ? employee.postalCode : '') + ' ' + (employee.city ? employee.city : '')},
                { key: "Staatsangehörigkeit", value: employee.nationality != null && this.countryMap[employee.nationality] ? (this.countryMap[employee.nationality]) : ''},
                { key: "SVNR", value: employee.socialsecurity},
                { key: "Arbeitsverhältnis", value: employeeCategory},
                { key: "Ersteintrittsdatum", value: employee.workEntryDate != null? this.$helpers.extractDateStringTZ(employee.workEntryDate, "DD.MM.YYYY") : firstFrom},
                { key: this.$t('pages.employeeCoreData.personnelNumber'), value: employee.personnelId},
                { key: "", value: ""},
                { key: this.$t('pages.employeeCoreData.email'), value: employee.email},
                { key: "Telefon", value: employee.homephone},
                { key: "Mobil", value: employee.mobilephone},
                { key: "", value: ""},
                { key: "Konto Inhaber", value: employee.bankAccountHolder},
                { key: this.$t('pages.employeeCoreData.iban'), value: employee.iban},
                { key: this.$t('pages.employeeCoreData.bic'), value: employee.bic},

                { key: this.$t('pages.employeeCoreData.otherDetails'), value: employee.miscInfo}
            ];
            if(this.$refs.compcoredata.externalService && this.$refs.compcoredata.externalId && this.$refs.compcoredata.externalId != ''){
                data.push({key: "Externe ID", value: this.$refs.compcoredata.externalId +" ("+this.$refs.compcoredata.externalService.name+")"});
            }


            if(employee.guardianName || employee.guardianAddress || employee.guardianPhone){
                data.push({ key: "", value: ""});
                data.push({ key: this.$t('pages.employeeCoreData.emergencyContact'), value: employee.guardianName});
                data.push({ key: this.$t('pages.employeeCoreData.emergencyContactAddressShort'), value: employee.guardianAddress});
                data.push({ key: this.$t('pages.employeeCoreData.emergencyContactPhoneShort'), value: employee.guardianPhone});
            }

            prevDataY = curY;
            doc, offset = this.$helpers.dataBlock(doc, data, 0, curY, page);
            curY = offset.offsetY;
            page = offset.page;

            data = [
                { key: "Straße", value: employee.address},
                { key: this.$t('pages.employeeData.dateOfBirth'), value: employee.dob != null? this.$helpers.extractDateStringTZ(employee.dob, "DD.MM.YYYY") : ''},
                { key: "Geschlecht", value: employee.gender == 'F'? 'weiblich' : employee.gender == 'M'? 'männlich' : employee.gender == 'D'? 'divers' : ''},
                { key: "", value: ""},

                { key: "Aktueller Vertrag gültig ab", value: from},
                { key: this.$t('pages.employeeData.exitDate'), value: to},
                { key: this.$t('pages.employeeContract.jobName'), value: jobName},
                { key: "Sollstunden/Wo.", value: weekTimeRegular > 0? (weekTimeRegular + '') : ''},
                { key: "", value: ""},
                { key: this.$t('pages.employeeCoreData.taxId'), value: employee.taxId},
                { key: this.$t('pages.employeeCoreData.healthInsurance'), value: employee.healthInsurance},
                { key: "Krankenkasse Adresse", value: employee.healthInsuranceAddress},

            ];



            doc, offset = this.$helpers.dataBlock(doc, data, 95, prevDataY, page);
            prevDataY = offset.offsetY;
            page = offset.page;
            curY = prevDataY > curY? prevDataY : curY;
            doc, curY = this.$helpers.reportHeaderColorBlock(doc, 'Aktives Dienstverhältnis', curY);

            data = [
                {key: 'Bezeichnung', value: jobName},
                {key: 'Beginn', value: from},
                {key: 'Ende', value: to},
                {key: this.$t('pages.employeeContract.deadlineTo'), value: deadlineTo},
                {key: '', value: ''},
                {key: this.$t('pages.employeeContract.category'), value: employeeCategory},
                {key: this.$t('pages.employeeContract.employmentType'), value: employmentType},
                {key: '', value: ''},
                {key: 'Sollstunden/Wo.', value: weekTimeRegular > 0? (weekTimeRegular + '') : ''},
                {key: 'Arbeitstage/Wo.', value: weekWorkDaysRegular > 0? (weekWorkDaysRegular + '') : ''},

            ];

            prevDataY = curY;
            doc, offset = this.$helpers.dataBlock(doc, data, 0, curY, page);
            curY = offset.offsetY;
            page = offset.page;

            data = [
                {key: '', value: ''},
                {key: this.$t('pages.employeeContract.probation'), value: probation},
                {key: this.$t('pages.employeeContract.probationTo'), value: probationTo},
                {key: '', value: ''},
                {key: this.$t('pages.employeeContract.mlWageGroup'), value: wageGroup},
                {key: this.$t('pages.employeeContract.paymentType'), value: paymentType},
                {key: this.$t('pages.employeeContract.payment'), value: payment},
                {key: '', value: ''},
                {key: this.$t('pages.employeeContract.pregnancy'), value: pregnant ? this.$t('global.ui.yes') : this.$t('global.ui.no')},
            ];

            doc, offset = this.$helpers.dataBlock(doc, data, 95, prevDataY, page);
            prevDataY = offset.offsetY;
            page = offset.page;
            curY = prevDataY > curY? prevDataY : curY;

            if(futureContracts.length > 0){
                doc, curY = this.$helpers.reportHeaderColorBlock(doc, 'Zukünftige Dienstverhältnisse', curY);
                for(let i = 0; i < futureContracts.length; i++) {
                    contract = futureContracts[i];
                    from = '';
                    to = '';
                    payment = '';
                    weekWorkDaysRegular = 0;
                    weekTimeRegular = 0;
                    employmentType = '';
                    employeeCategory = '';
                    jobName = '';
                    probation = '';
                    probationTo = '';
                    deadlineTo = '';
                    paymentType = '';
                    wageGroup = '';
                    pregnant = false;

                    if(contract != null){
                        from = this.$helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY');
                        if(firstFrom == '') firstFrom = from;
                        if(contract.to != null){
                            to = this.$helpers.extractDateStringTZ(contract.to, 'DD.MM.YYYY', true);
                        }
                        payment = this.$helpers.formatPayment((contract.payment + contract.extraPayment));
                        pregnant = contract.pregnant != null ? contract.pregnant  : false;
                        weekTimeRegular = contract.weekTimeRegular / 60;
                        weekWorkDaysRegular = contract.weekWorkDaysRegular;
                        if(contract.employmentType != null){
                            this.uiDataMap.employmentTypes.forEach((et) => {
                                if(et.id == contract.employmentType) employmentType = et['label_de'];
                            });
                        }
                        if(contract.employeeCategory != null){
                            this.uiDataMap.employeeCategories.forEach((et) => {
                                if(et.id == contract.employeeCategory) employeeCategory = et['label_de'];
                            });
                        }
                        jobName = contract.jobName;
                        if(contract.probation || contract.probationTo != null){
                            probation = this.$t('global.ui.yes');
                            probationTo = this.$helpers.extractDateStringTZ(contract.probationTo, 'DD.MM.YYYY', true);
                        }else{
                            probation = this.$t('global.ui.no');
                        }
                        if(contract.deadlineTo){

                            deadlineTo = this.$helpers.extractDateStringTZ(contract.deadlineTo, 'DD.MM.YYYY', true);
                        }
                        this.uiDataMap.paymentTypes.forEach((t) => {
                            if(t.id == contract.paymentType) paymentType = t['label_de'];
                        });
                        if(contract.mlWageGroup != null && this.mlWageGroupMap[contract.mlWageGroup] != null){
                            wageGroup = this.mlWageGroupMap[contract.mlWageGroup].name
                        }
                    }
                    data = [
                        {key: 'Bezeichnung', value: jobName},
                        {key: 'Beginn', value: from},
                        {key: 'Ende', value: to},
                        {key: this.$t('pages.employeeContract.deadlineTo'), value: deadlineTo},
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.category'), value: employeeCategory},
                        {key: this.$t('pages.employeeContract.employmentType'), value: employmentType},
                        {key: '', value: ''},
                        {key: 'Sollstunden/Wo.', value: weekTimeRegular > 0? (weekTimeRegular + '') : ''},
                        {key: 'Arbeitstage/Wo.', value: weekWorkDaysRegular > 0? (weekWorkDaysRegular + '') : ''},

                    ];

                    prevDataY = curY;
                    doc, offset = this.$helpers.dataBlock(doc, data, 0, curY, page);
                    curY = offset.offsetY;
                    page = offset.page;

                    data = [
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.probation'), value: probation},
                        {key: this.$t('pages.employeeContract.probationTo'), value: probationTo},
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.mlWageGroup'), value: wageGroup},
                        {key: this.$t('pages.employeeContract.paymentType'), value: paymentType},
                        {key: this.$t('pages.employeeContract.payment'), value: payment},
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.pregnancy'), value: pregnant ? this.$t('global.ui.yes') : this.$t('global.ui.no')},
                    ];

                    doc, offset = this.$helpers.dataBlock(doc, data, 95, prevDataY, prevPage);
                    prevDataY = offset.offsetY;
                    prevPage = offset.page;

                    if(prevPage > page){
                        page = prevPage;
                        curY = prevDataY;
                    }else if(prevPage == page){
                        curY = prevDataY > curY? prevDataY : curY;
                    }else{
                        prevPage = page;
                    }
                    page = prevPage > page? prevPage : page;


                    if(i != futureContracts.length - 1) doc, curY = this.$helpers.reportColorBlockDivider(doc, curY);
                }
            }

            if(pastContracts.length > 0){
                doc, curY = this.$helpers.reportHeaderColorBlock(doc, 'Vergangene Dienstverhältnisse', curY);
                for(let i = 0; i < pastContracts.length; i++) {
                    contract = pastContracts[i];
                    from = '';
                    to = '';
                    payment = '';
                    weekWorkDaysRegular = 0;
                    weekTimeRegular = 0;
                    employmentType = '';
                    employeeCategory = '';
                    jobName = '';
                    probation = '';
                    probationTo = '';
                    deadlineTo = '';
                    paymentType = '';
                    wageGroup = '';
                    pregnant = false;

                    if(contract != null){
                        from = this.$helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY');
                        if(firstFrom == '') firstFrom = from;
                        if(contract.to != null){
                            to = this.$helpers.extractDateStringTZ(contract.to, 'DD.MM.YYYY', true);
                        }
                        payment = this.$helpers.formatPayment((contract.payment + contract.extraPayment));
                        pregnant = contract.pregnant != null ? contract.pregnant  : false;
                        weekTimeRegular = contract.weekTimeRegular / 60;
                        weekWorkDaysRegular = contract.weekWorkDaysRegular;
                        if(contract.employmentType != null){
                            this.uiDataMap.employmentTypes.forEach((et) => {
                                if(et.id == contract.employmentType) employmentType = et['label_de'];
                            });
                        }
                        if(contract.employeeCategory != null){
                            this.uiDataMap.employeeCategories.forEach((et) => {
                                if(et.id == contract.employeeCategory) employeeCategory = et['label_de'];
                            });
                        }
                        jobName = contract.jobName;
                        if(contract.probation || contract.probationTo != null){
                            probation = this.$t('global.ui.yes');
                            probationTo = this.$helpers.extractDateStringTZ(contract.probationTo, 'DD.MM.YYYY', true);
                        }else{
                            probation = this.$t('global.ui.no');
                        }
                        if(contract.deadlineTo){

                            deadlineTo = this.$helpers.extractDateStringTZ(contract.deadlineTo, 'DD.MM.YYYY', true);
                        }
                        this.uiDataMap.paymentTypes.forEach((t) => {
                            if(t.id == contract.paymentType) paymentType = t['label_de'];
                        });
                        if(contract.mlWageGroup != null && this.mlWageGroupMap[contract.mlWageGroup] != null){
                            wageGroup = this.mlWageGroupMap[contract.mlWageGroup].name
                        }
                    }
                    data = [
                        {key: 'Bezeichnung', value: jobName},
                        {key: 'Beginn', value: from},
                        {key: 'Ende', value: to},
                        {key: this.$t('pages.employeeContract.deadlineTo'), value: deadlineTo},
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.category'), value: employeeCategory},
                        {key: this.$t('pages.employeeContract.employmentType'), value: employmentType},
                        {key: '', value: ''},
                        {key: 'Sollstunden/Wo.', value: weekTimeRegular > 0? (weekTimeRegular + '') : ''},
                        {key: 'Arbeitstage/Wo.', value: weekWorkDaysRegular > 0? (weekWorkDaysRegular + '') : ''}
                    ];

                    prevDataY = curY;
                    prevPage = page;
                    doc, offset = this.$helpers.dataBlock(doc, data, 0, curY, page);
                    curY = offset.offsetY;
                    page = offset.page;

                    data = [
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.probation'), value: probation},
                        {key: this.$t('pages.employeeContract.probationTo'), value: probationTo},
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.mlWageGroup'), value: wageGroup},
                        {key: this.$t('pages.employeeContract.paymentType'), value: paymentType},
                        {key: this.$t('pages.employeeContract.payment'), value: payment},
                        {key: '', value: ''},
                        {key: this.$t('pages.employeeContract.pregnancy'), value: pregnant ? this.$t('global.ui.yes') : this.$t('global.ui.no')},
                    ];

                    if(page > prevPage){
                        doc.setPage(prevPage);
                    }
                    doc, offset = this.$helpers.dataBlock(doc, data, 95, prevDataY, prevPage);
                    prevDataY = offset.offsetY;
                    prevPage = offset.page;
                    //curY = prevDataY > curY? prevDataY : curY;

                    if(prevPage > page){
                        page = prevPage;
                        curY = prevDataY;
                    }else if(prevPage == page){
                        curY = prevDataY > curY? prevDataY : curY;
                    }else{
                        prevPage = page;
                    }
                    page = prevPage > page? prevPage : page;
                    doc.setPage(page);

                    if(i != pastContracts.length - 1) doc, curY = this.$helpers.reportColorBlockDivider(doc, curY);
                }
            }

            this.$helpers.insertPageNumbers(doc);
            this.$helpers.previewPdf(doc, filename);
        },
        createCoredataChangePdf(changedData){
            let view = this;

            let filetitle = changedData.lastName + ' ' + changedData.firstName;
            let filename = changedData.lastName + '_' + changedData.firstName + '_Änderung_'+ this.$helpers.getCurrentMoment().format('DD.MM.YYYY HH:mm') +'.pdf';
            let dob = changedData.empldob;
            if(dob.includes(":00Z") || dob.includes("+00:00")) dob = this.$helpers.extractDateString(dob, "DD.MM.YYYY");
            let socialsecurity = changedData.emplsocialsecurity;
            let svdob = "";
            if(socialsecurity.length > 0) svdob = 'SVNR: ' + socialsecurity;
            if(dob.length > 0){
                if(svdob.length > 0) svdob += " | ";
                svdob += 'Geb.: ' + dob;
            }
            var imgData = null;
            var repDoc = this.$helpers.reportDoc(filetitle, svdob, this.$t('pages.employeeContract.changeSheet'), null, 'p', imgData)
            var doc = repDoc.doc;
            var page = 1;
            var prevPage = page;
            var contentOffsetY = repDoc.contentOffsetY;
            var curY = contentOffsetY;
            var prevDataY = curY;
            var offset = {offsetY: curY, page: page};

            doc.rect(13.9, curY-0.2, 182.2, 297 - curY - 15);
            doc, curY = this.$helpers.reportHeaderColorBlock(doc, 'Geänderte Stammdaten', curY);

            let data = [];
            Object.keys(changedData).forEach((key) => {
                if(!['firstName', 'lastName', 'empldob', 'emplsocialsecurity'].includes(key)){
                    let val = changedData[key]['val'];
                    if(val == null || val == undefined) val = "";
                    if(typeof val === "boolean") val = val? this.$t('global.ui.yes').toUpperCase() : this.$t('global.ui.no').toUpperCase();
                    if(val.includes(":00Z") || val.includes("+00:00")) val = this.$helpers.extractDateString(val, "DD.MM.YYYY");
                    data.push({
                        key: view.$helpers.employeeFieldLabel(key),
                        value: val,
                    });
                }
            });

            prevDataY = curY;
            doc, offset = this.$helpers.dataBlock(doc, data, 0, curY, page);
            curY = offset.offsetY;
            page = offset.page;

            data = [];
            Object.keys(changedData).forEach((key) => {
                if(!['firstName', 'lastName', 'empldob', 'emplsocialsecurity'].includes(key)){
                    let oldVal = changedData[key]['oldVal'];
                    if(oldVal == null || oldVal == undefined) oldVal = "";
                    if(typeof oldVal === "boolean") oldVal = oldVal? this.$t('global.ui.yes').toUpperCase() : this.$t('global.ui.no').toUpperCase();
                    if(oldVal.includes(":00Z") || oldVal.includes("+00:00")) oldVal = this.$helpers.extractDateString(oldVal, "DD.MM.YYYY");
                    data.push({
                        key: view.$helpers.employeeFieldLabel(key) + ' (alt)',
                        value: oldVal,
                    });
                }
            });

            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '_______________________________________', value: '', keyOnly: true});
            data.push({key: this.$t('pages.employeeContract.employeeSignatureBubble'), value: '', keyOnly: true});

            doc, offset = this.$helpers.dataBlock(doc, data, 95, prevDataY, page);
            prevDataY = offset.offsetY;
            page = offset.page;
            curY = prevDataY > curY? prevDataY : curY;

            this.$helpers.insertPageNumbers(doc);
            //doc.save(filename);
            view.$helpers.previewPdf(doc, filename, this.$t('pages.employeeContext.changeReport'));
        },
        previewPdfHook(payload){

            this.$helpers.previewPdf(payload.doc, payload.filename, payload.type);
        },




        EmployeeIsActiveInTimeRange(employee, lower, upper){
            for(let i in this.employeeContractMap){
                let contract = this.employeeContractMap[i];
                let cType = this.contractType(contract);
                if(contract.employeeId == employee.id){

                    let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from).clone();
                    if(contractFrom < lower) contractFrom = lower.clone();
                    let contractTo = contract.to == null ? upper : this.$helpers.getMomentFromStringTZ(contract.to).clone();
                    if(contractTo > upper) contractTo = upper.clone();
                    let ratio = contractTo.diff(contractFrom) / upper.diff(lower);

                    // previous checks ensured that from >= lower and to <= upper

                    // --> only proceed if from <= upper and to >= lower otherwise contract is out of our range of interest
                    if(contractFrom <= upper && contractTo >= lower){
                        return true;
                    }
                }
            }
            return false;
        },

        GetCompensationForMonthFromContracts(employee,lower,upper){
            let compensation = 0;
            let contracts = this.employeeEmployeeContractMap[employee.id] ? this.employeeEmployeeContractMap[employee.id]: [];
            contracts.forEach(contract => {
                
                let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from).clone();
                if(contractFrom < lower) contractFrom = lower.clone();
                let contractTo = contract.to == null ? upper : this.$helpers.getMomentFromStringTZ(contract.to).clone();
                 if(contractTo > upper) contractTo = upper.clone();
                let ratio = contractTo.diff(contractFrom) / upper.diff(lower);

                // previous checks ensured that from >= lower and to <= upper

                // --> only proceed if from <= upper and to >= lower otherwise contract is out of our range of interest
                let avgRatio = (this.allowedContractMap[contract.collectiveContractId] ? this.allowedContractMap[contract.collectiveContractId].workTimeFactor : this.storeSettings.workTimeFactor)/Math.pow(10,7);


                if(contractFrom <= upper && contractTo >= lower){
                    if(contract.paymentType == 1){//Gehalt
                        compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * ratio);
                    }
                    if(contract.paymentType == 2){//Lohn
                        if(contract.wageType == 4){ //MonatsLohn
                            compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * ratio);
                        }else if(contract.wageType == 3){ //WochenLohn
                            compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * avgRatio * ratio);
                        }else if(contract.wageType == 2){ //TagesLohn

                            compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * upper.diff(lower, 'days') * ratio);
                        }else if(contract.wageType == 1){ //StundenLohn

                            compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * (contract.weekTimeRegular / 60) * avgRatio * ratio);
                        }
                    }
                }
            })

            return compensation;
        },
        GetHourlyWageFromContract(contract){
            let hourlyWage = 0;
            let sum = contract.payment + contract.extraPayment;
            if(contract.paymentType == 1){//Gehalt

                hourlyWage = sum /((contract.weekTimeRegular *4.325)/60.0) / 100.0 ;
            } else if(contract.paymentType == 2){//Lohn
                if(contract.wageType == 1){ //StundenLohn
                    hourlyWage = sum / 100.0;
                }
                else if(contract.wageType == 2){ //TagesLohn
                    hourlyWage = sum /(contract.weekTimeRegular/60.0) / 100.0 ;
                }
                else if(contract.wageType == 3){ //WochenLohn
                    hourlyWage = sum /(contract.weekTimeRegular/60.0) / 100.0 ;
                }
                else if(contract.wageType == 4){ //MonatsLohn

                    hourlyWage = sum /((contract.weekTimeRegular *4.325)/60.0) / 100.0 ;
                }
            }
            return hourlyWage;
        },

        GetAssistanceCompensationForMonthFromContracts(employee,lower,upper){
            let compensation = 0;
            let contracts = this.employeeEmployeeContractMap[employee.id] ? this.employeeEmployeeContractMap[employee.id]: [];
            contracts.forEach(contract => {

                let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from).clone();
                if(contractFrom < lower) contractFrom = lower.clone();
                let contractTo = contract.to == null ? upper : this.$helpers.getMomentFromStringTZ(contract.to).clone();
                 if(contractTo > upper) contractTo = upper.clone();
                let ratio = contractTo.diff(contractFrom) / upper.diff(lower);

                // previous checks ensured that from >= lower and to <= upper

                 // --> only proceed if from <= upper and to >= lower otherwise contract is out of our range of interest
                if(contractFrom <= upper && contractTo >= lower && contract.assistancePayment != null){
                    compensation = compensation + ((contract.assistancePayment / 100) * ratio);
                }
            })

            return compensation;
        },


        printEmployeesPDF(date, activeOnly = true, payment = true, pregnantOnly = false, includeGenderStats = false, includePlantype = false, includeEmploymentGroup = false, includePhone = false, includeAddress = false,sortOrder = 1){
            let view = this;
            let headers = [this.$t('pages.employeeData.name'), 'PNr', this.$t('pages.employeeCoreData.gender'), this.$t('pages.employeeCoreData.dob'), this.$t('pages.employeeCoreData.nationality'), this.$t('pages.employeeContext.ssn'), this.$t('pages.employeeCoreData.email'), this.$t('pages.employeeData.initialEntranceDate'), this.$t('pages.employeeContext.entry'), 'Austritt', this.$t('pages.employeeContract.jobName'), this.$tc('global.general.type', 1), this.$t('pages.employeeContext.targetWe'), this.$t('pages.employeeContext.targetMo')];

            let personalDataHeaders = [this.$t('pages.employeeData.name'), 'PNr', this.$t('pages.employeeCoreData.gender'), this.$t('pages.employeeCoreData.dob'), this.$t('pages.employeeCoreData.nationality'), this.$t('pages.employeeContext.ssn'), this.$t('pages.employeeCoreData.email')];
            let contractDataHeaders = [this.$t('pages.employeeData.name'), 'PNr', this.$t('pages.employeeData.initialEntranceDate'), this.$t('pages.employeeContext.entry'), 'Austritt', this.$t('pages.employeeContract.jobName'), this.$tc('global.general.type'), this.$t('pages.employeeContext.targetWe'), this.$t('pages.employeeContext.targetMo')];

            if(includePhone){
                personalDataHeaders.push(this.$t('pages.employeeCoreData.homephone'));
            }
            if(includeAddress){
                personalDataHeaders.push(this.$t('pages.employeeData.address'));
            }

            if(payment){
                contractDataHeaders.push(this.$t('pages.employeeContext.payment'));
                contractDataHeaders.push(this.$t('pages.employeeContract.funding'));
            }
            if(includePlantype){
                contractDataHeaders.push(this.$t('pages.employeeContract.planningEmployeeType'))
            }
            if(includeEmploymentGroup){
                contractDataHeaders.push(this.$t('pages.employeeContext.employmentGroupN'))
            }

            let filename = this.$t('pages.employeeContext.personnelBase') + ' ' + date.format('MMMM YYYY') + '.pdf';
            let personalDataBody = [];
            let contractDataBody = [];
            let employeeCategoryMap = {};
            let contractTypeMap = {};
            this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
            this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);
            var repDoc = this.$helpers.tableReportDoc(
                headers,
                this.$t('pages.employeeContext.personnelOverviewAndPayment') + ' ' + date.format('MMMM YYYY')+(pregnantOnly ? " (" + this.$t('pages.employeeContext.pregnant') + ")" : ""),
                this.storeSettings.name,
                this.storeSettings.description,
                this.userFullname,
                9);
            var doc = repDoc.doc;
            var contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(11);

            let startOfMonth = date.clone().startOf('month');
            let endOfMonth = date.clone().endOf('month').add(7,'days').startOf('month');

            let sumCompensation = 0;
            let sumAssistancePayment = 0;
            let sumWeekRegular = 0;
            let sumWeekRegularCrew = 0;
            let sumWeekRegularMgmt = 0;
            let sumMonthRegular = 0;
            let sumMonthRegularCrew = 0;
            let sumMonthRegularMgmt = 0;
            let activeEmployees = 0;
            let sumCompensationCrew = 0;
            let sumCompensationMgmt = 0;
            let sumAssistancePaymentCrew = 0;
            let sumAssistancePaymentMgmt = 0;

            let sumHourlyWageCrew = 0;
            let sumHourlyWageMgmt = 0;
            let employeeCountCrew = 0;
            let employeeCountMgmg = 0;

            let genderStats = {
                sumWeekRegularMale: 0,
                sumWeekRegularFemale: 0,
                sumWeekRegularOther: 0,

                sumMonthRegularMale: 0,
                sumMonthRegularFemale: 0,
                sumMonthRegularOther: 0,

                sumCompensationMale: 0,
                sumCompensationFemale: 0,
                sumCompensationOther: 0,

                sumAssistancePaymentMale: 0,
                sumAssistancePaymentFemale: 0,
                sumAssistancePaymentOther: 0,

                maleCount: 0,
                femaleCount: 0,
                otherCount: 0,

            }

            let catCounts = {
                1: 0,
                2: 0
            };
            let typeCounts = {
                1: 0,
                2: 0,
                3: 0
            };

            let sortedEmployees = this.employeeArray.sort((a, b) => {
                let aName = a.lastName + a.firstName;
                let bName = b.lastName + b.firstName;
                if(sortOrder == 1){

                    return aName.localeCompare(bName);

                } else if (sortOrder == 2){
                    let aNum = a.personnelId != null ? parseInt(a.personnelId) : Number.MAX_SAFE_INTEGER;
                    let bNum = b.personnelId != null ? parseInt(b.personnelId) : Number.MAX_SAFE_INTEGER;

                    aNum = isNaN(aNum) ? Number.MAX_SAFE_INTEGER : aNum;
                    bNum = isNaN(bNum) ? Number.MAX_SAFE_INTEGER : bNum;

                    let res = aNum - bNum;
                    if(res == 0){
                        return aName.localeCompare(bName);
                    } else {
                        return res;
                    }


                } else if (sortOrder == 3){
                    let aDob = a.dob != null ? view.$helpers.getMomentFromStringTZ(a.dob) : view.$helpers.getMomentFromStringTZ('1900-01-01T00:00:00.000000Z');
                    let bDob = b.dob != null ? view.$helpers.getMomentFromStringTZ(b.dob) : view.$helpers.getMomentFromStringTZ('1900-01-01T00:00:00.000000Z');

                    let res = bDob.diff(aDob, 'minutes');
                    if(res == 0){
                        return aName.localeCompare(bName);
                    } else {
                        return res;
                    }
                } else if (sortOrder == 4){
                    let aNat = a.nationality == 0 ? 'Zza' : (a.nationality != null && this.countryMap[a.nationality] ? (this.countryMap[a.nationality]) : 'Zzzz');
                    let bNat = b.nationality == 0 ? 'Zza' : (b.nationality != null && this.countryMap[b.nationality] ? (this.countryMap[b.nationality]) : 'Zzzz');

                    let res = aNat.localeCompare(bNat);
                    if(res == 0){
                        return aName.localeCompare(bName);
                    } else {
                        return res;
                    }
                }
            });

            sortedEmployees.forEach((e) => {
                let contract = this.employeeContractForEmployee(e, date);
                if((!activeOnly || e.active) && (!pregnantOnly || (contract && contract.pregnant))){

                    var futureContracts = this.employeeContractsForEmployeeWithType(e, 2, date);
                    var pastContracts = this.employeeContractsForEmployeeWithType(e, 0, date);
                    let contracts = this.employeeEmployeeContractMap[e.id] ? this.employeeEmployeeContractMap[e.id]: [];
                    var from = '';
                    var to = '';

                    var category = '';
                    var type = ''
                    let job = '';
                    var weekTimeRegular = 0;
                    let monthTimeRegular = 0;
                    let compensation = view.GetCompensationForMonthFromContracts(e,startOfMonth,endOfMonth);
                    //console.log(e.lastName+" "+compensation);
                    sumCompensation += compensation;
                    let assistanceCompensation = view.GetAssistanceCompensationForMonthFromContracts(e,startOfMonth,endOfMonth);
                    sumAssistancePayment += assistanceCompensation;

                    if(e.gender == 'M') {
                        genderStats.sumCompensationMale += compensation;
                        genderStats.sumAssistancePaymentMale += assistanceCompensation;
                        genderStats.maleCount += 1;
                    } else if(e.gender == 'F'){
                        genderStats.sumCompensationFemale += compensation;
                        genderStats.sumAssistancePaymentFemale += assistanceCompensation;
                        genderStats.femaleCount += 1;
                    } else {
                        genderStats.sumCompensationOther += compensation;
                        genderStats.sumAssistancePaymentOther += assistanceCompensation;
                        genderStats.otherCount += 1;
                    }



                    if(view.EmployeeIsActiveInTimeRange(e, startOfMonth, endOfMonth)) activeEmployees++;


                    if(contract == null && futureContracts.length > 0){
                        var nextFrom;
                        futureContracts.forEach((fc) => {
                            var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                            if(nextFrom == null){
                                nextFrom = curFrom;
                                contract = fc;
                            }else{
                                if(curFrom < nextFrom){
                                    nextFrom = curFrom;
                                    contract = fc;
                                }
                            }
                        });
                    }

                    if(contract == null && pastContracts.length > 0){
                        var lastTo;
                        pastContracts.forEach((pc) => {
                            var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                            if(lastTo == null){
                                lastTo = curTo;
                                contract = pc;
                            }else{
                                if(curTo > lastTo){
                                    lastTo = curTo;
                                    contract = pc;
                                }
                            }
                        });
                    }

                    if(contract != null){
                        from = this.$helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY');
                        if(contract.to != null){
                            var toMoment = this.$helpers.getMomentFromStringTZ(contract.to);
                            toMoment = toMoment.subtract(1, "days");
                            to = toMoment.format('DD.MM.YYYY');
                        }


                        weekTimeRegular = contract.weekTimeRegular / 60
                        let holidays = Object.values(this.holidayMap).filter(h=> h.active && h.federalHoliday).map(h => view.$helpers.getMomentFromStringTZ(h.from));
                        let includingContractHolidayMoments = Object.values(this.holidayMap).filter(h => h.active && (h.federalHoliday || h.contractHoliday)).map(h => view.$helpers.getMomentFromStringTZ(h.from));
                        monthTimeRegular = this.$helpers.GetWorktimeForRangeWithinMonthFromContracts(startOfMonth, startOfMonth, endOfMonth, contracts, this.allowedContractMap, this.storeSettings, this.storeSettings.workTimeMode, this.storeSettings.exitFactoring, null, holidays, includingContractHolidayMoments)/60;
                        sumWeekRegular += weekTimeRegular;
                        sumMonthRegular += monthTimeRegular;
                        if(e.spotId){
                            let spot = this.spotMap[e.spotId];
                            let hourlyWage = view.GetHourlyWageFromContract(contract);
                            if(spot.employeeLevel == 1){
                                sumCompensationCrew += compensation;
                                sumAssistancePaymentCrew += assistanceCompensation;
                                sumWeekRegularCrew += weekTimeRegular;
                                sumMonthRegularCrew += monthTimeRegular;
                                if(hourlyWage > 0.0){
                                    sumHourlyWageCrew += hourlyWage;
                                    employeeCountCrew += 1;
                                }

                            } else if(spot.employeeLevel == 2){
                                sumCompensationMgmt += compensation;
                                sumAssistancePaymentMgmt += assistanceCompensation;
                                sumWeekRegularMgmt += weekTimeRegular;
                                sumMonthRegularMgmt += monthTimeRegular;
                                if(hourlyWage > 0.0){
                                    sumHourlyWageMgmt += hourlyWage;
                                    employeeCountMgmg += 1;
                                }

                            }

                        }
                        if(e.gender == 'M') {
                            genderStats.sumWeekRegularMale += weekTimeRegular;
                            genderStats.sumMonthRegularMale += monthTimeRegular;
                        } else if(e.gender == 'F'){
                            genderStats.sumWeekRegularFemale += weekTimeRegular;
                            genderStats.sumMonthRegularFemale += monthTimeRegular;
                        } else {
                            genderStats.sumWeekRegularOther += weekTimeRegular;
                            genderStats.sumMonthRegularOther += monthTimeRegular;
                        }

                        category = employeeCategoryMap[contract.employeeCategory];
                        type = contractTypeMap[contract.contractType];
                        job = contract.jobName != null ? contract.jobName : '';
                        job = job.replace(' ','\n');
                        catCounts[contract.employeeCategory]++;
                        typeCounts[contract.contractType]++;

                    }
                    let emailSplit = e.email;
                    if(emailSplit != null){
                        emailSplit = e.email.split('@');
                        if(emailSplit.length > 1){
                            emailSplit = emailSplit[0]+'\n@'+emailSplit[1];
                        }
                    }
                    



                    let personalDataLine = [
                            e.lastName + '\n' + e.firstName,
                            e.personnelId,
                            e.gender == 'F'? this.$t('pages.employeeCoreData.female') : e.gender == 'M'? this.$t('pages.employeeCoreData.male') : this.$t('pages.employeeCoreData.nonBinary'),
                            e.dob != null? this.$helpers.extractDateString(e.dob, 'DD.MM.YYYY') : '',
                            e.nationality != null && this.countryMap[e.nationality] ? (this.countryMap[e.nationality]) : '',
                            e.socialsecurity,
                            emailSplit
                    ]

                    if(includePhone){
                        personalDataLine.push(e.mobile != null && !this.$helpers.isEmpty(e.mobile) ? e.mobile : e.homephone != null && !this.$helpers.isEmpty(e.homephone) ? e.homephone : '');
                    }
                    if(includeAddress){
                        let fullAddress = (e.address != null && !this.$helpers.isEmpty(e.address) ? (e.address+"\n") : '')+
                                          (e.postalCode != null && !this.$helpers.isEmpty(e.postalCode) ? e.postalCode : '')+" "+
                                          (e.city != null && !this.$helpers.isEmpty(e.city) ? e.city : '');
                        personalDataLine.push(fullAddress);
                    }

                    personalDataBody.push(personalDataLine);

                    let contractDataLine = [
                            e.lastName + '\n' + e.firstName,
                            e.personnelId,
                            this.employeeContractEntryDate(e, true),
                            this.employeeContractEntryDate(e, false),
                            to,
                            job,
                            type,
                            weekTimeRegular != 0? weekTimeRegular.toFixed(2) : '',
                            monthTimeRegular != 0? monthTimeRegular.toFixed(2) : ''
                    ]

                    if(payment){
                        contractDataLine.push( compensation.toFixed(2) + ' €');
                        contractDataLine.push( assistanceCompensation.toFixed(2) + ' €')
                    }
                    if(includePlantype){
                        let et = this.employeeTypeForEmployee(e);
                        contractDataLine.push(et != null ? (et.weekTimeRegular/60.0).toFixed(2)+"h / "+et.weekWorkDaysRegular+"T" : "-")
                    }
                    if(includeEmploymentGroup){
                        contractDataLine.push(contract != null ? contract.employmentGroup : '')
                    }

                    contractDataBody.push(contractDataLine);
                }
            });


            doc.autoTable({
                startY: contentOffsetY,
                head: [personalDataHeaders],
                body: personalDataBody,
                headStyles: {
                    fillColor: [109,141,33],
                    fontSize: 6.5,
                },
                bodyStyles: {
                    fontSize: 6.5
                },
                columnStyles: {
                    0: {

                        cellWidth: 20
                    },
                    1: {

                        cellWidth: 20
                    },
                    6: {

                        cellWidth: 25
                    },

                }
            })

            let finalY = doc.lastAutoTable.finalY || 10
            let pageSize = doc.internal.pageSize
            let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

            let offset = finalY + (pageHeight - (finalY % pageHeight))
            doc.autoTable({
                startY: offset + 20,
                head: [contractDataHeaders],
                body: contractDataBody,
                headStyles: {
                    fillColor: [109,141,33],
                    fontSize: 6.5,
                },
                bodyStyles: {
                    fontSize: 6.5
                },
                columnStyles: {
                    0: {

                        cellWidth: 20
                    },
                    1: {

                        cellWidth: 20
                    },
                    6: {
                        cellWidth: 16
                    }
                }
            })

            if(personalDataBody.length > 0){

                finalY = doc.lastAutoTable.finalY || 10
                pageSize = doc.internal.pageSize
                pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

                offset = finalY + (pageHeight - (finalY % pageHeight))


                let headers = [this.$t('roster.comp.sums') + ' '+ date.format('MMMM YYYY'), '', '', '', '', '', '', '', '', '', this.$t('pages.employeeContext.targetWe'), this.$t('pages.employeeContext.targetMo'), this.$t('pages.employeeContext.fullTimeEquivalents')];

                if(payment){
                    headers.push(this.$t('pages.employeeContext.payment'));
                    headers.push(this.$t('pages.employeeContract.funding'));
                }

                let body = [];
                let divisor = 173.0;
                if(this.storeSettings.country == 2){
                    divisor = 169.0;
                }
                let bodyLine = [this.$t('roster.comp.sums') + ' ' + this.$t('shift.template.management'),'','','','','','','','','', sumWeekRegularMgmt.toFixed(2), sumMonthRegularMgmt.toFixed(2), Math.round(sumMonthRegularMgmt/divisor)];
                if(payment){
                    bodyLine.push(sumCompensationMgmt.toFixed(2) + ' €');
                    bodyLine.push(sumAssistancePaymentMgmt.toFixed(2) + ' €')
                }
                body.push(bodyLine);

                bodyLine = [this.$t('roster.comp.sums') + ' Crew','','','','','','','','','', sumWeekRegularCrew.toFixed(2), sumMonthRegularCrew.toFixed(2), Math.round(sumMonthRegularCrew/divisor)];
                if(payment){
                    bodyLine.push(sumCompensationCrew.toFixed(2) + ' €');
                    bodyLine.push(sumAssistancePaymentCrew.toFixed(2) + ' €')
                }
                body.push(bodyLine);


                if(includeGenderStats){

                    bodyLine = [this.$t('roster.comp.sums') + ' ' + this.$t('pages.employeeCoreData.female'),'','','','','','','','','', genderStats.sumWeekRegularFemale.toFixed(2), genderStats.sumMonthRegularFemale.toFixed(2), Math.round(genderStats.sumMonthRegularFemale/divisor)];
                    if(payment){
                        bodyLine.push(genderStats.sumCompensationFemale.toFixed(2) + ' €');
                        bodyLine.push(genderStats.sumAssistancePaymentFemale.toFixed(2) + ' €')
                    }
                    body.push(bodyLine);
                    bodyLine = [this.$t('roster.comp.sums') + ' ' + this.$t('pages.employeeCoreData.male'),'','','','','','','','','', genderStats.sumWeekRegularMale.toFixed(2), genderStats.sumMonthRegularMale.toFixed(2), Math.round(genderStats.sumMonthRegularMale/divisor)];
                    if(payment){
                        bodyLine.push(genderStats.sumCompensationMale.toFixed(2) + ' €');
                        bodyLine.push(genderStats.sumAssistancePaymentMale.toFixed(2) + ' €')
                    }
                    body.push(bodyLine);
                    bodyLine = [this.$t('roster.comp.sums') + ' ' + this.$t('pages.employeeCoreData.nonBinary'),'','','','','','','','','',genderStats.sumWeekRegularOther.toFixed(2), genderStats.sumMonthRegularOther.toFixed(2), Math.round(genderStats.sumMonthRegularOther/divisor)];
                    if(payment){
                        bodyLine.push(genderStats.sumCompensationOther.toFixed(2) + ' €');
                        bodyLine.push(genderStats.sumAssistancePaymentOther.toFixed(2) + ' €')
                    }
                    body.push(bodyLine);
                }

                bodyLine = [this.$t('pref.main.sumTotal'),'','','','','','','','','',sumWeekRegular.toFixed(2), sumMonthRegular.toFixed(2), Math.round(sumMonthRegular/divisor)];
                if(payment){
                    bodyLine.push(sumCompensation.toFixed(2) + ' €');
                    bodyLine.push(sumAssistancePayment.toFixed(2) + ' €')
                }
                body.push(bodyLine);
                if(payment){
                    if(employeeCountMgmg > 0 || employeeCountCrew > 0){
                        bodyLine = ['','','', '', '', '', '','', '','', '', '', '', ''];
                        body.push(bodyLine);
                    }

                    if(employeeCountMgmg > 0){
                        bodyLine = [this.$t('pages.employeeContext.averageHourlyWage') + ' ' + this.$t('shift.template.management'),'','', '', '', '', '','', '','', '', '', '',(sumHourlyWageMgmt/employeeCountMgmg).toFixed(2)];
                        body.push(bodyLine);
                    }
                    if(employeeCountCrew > 0){
                        bodyLine = [this.$t('pages.employeeContext.averageHourlyWage') + ' ' + 'Crew','','', '', '', '', '','', '','', '', '', '',(sumHourlyWageCrew/employeeCountCrew).toFixed(2)];
                        body.push(bodyLine);
                    }


                }

                bodyLine = ['','','', '', '', '', '','', '','', '', ''];
                if(payment){
                    bodyLine.push('');
                    bodyLine.push('');
                }
                body.push(bodyLine);

                bodyLine = [this.$t('pages.employeeContext.activeEmployees') + ' ' + date.format('MMMM YYYY'),'','',activeEmployees,'','','','','','','','',''];
                if(payment){
                    bodyLine.push('');
                    bodyLine.push('');
                }
                body.push(bodyLine);
                if(includeGenderStats){
                    bodyLine = [this.$t('pages.employeeContext.femaleEmployees') + ' ','','',genderStats.femaleCount,'','','','','','','','',''];
                    if(payment){
                        bodyLine.push('');
                        bodyLine.push('');
                    }
                    body.push(bodyLine);
                    bodyLine = [this.$t('pages.employeeContext.maleEmployees') + ' ','','',genderStats.maleCount,'','','','','','','','',''];
                    if(payment){
                        bodyLine.push('');
                        bodyLine.push('');
                    }
                    body.push(bodyLine);

                    bodyLine = [this.$t('pages.employeeContext.diverseEmployees') + ' ','','',genderStats.otherCount,'','','','','','','','',''];
                    if(payment){
                        bodyLine.push('');
                        bodyLine.push('');
                    }
                    body.push(bodyLine);
                }

                bodyLine = ['','','', '', '', '', '','', '','','', ''];
                if(payment){
                    bodyLine.push('');
                    bodyLine.push('');
                }
                body.push(bodyLine);

                bodyLine = [this.$t('pages.employeeContext.byContractType'),'','', '', '', '', '','', '','', '', ''];
                if(payment){
                    bodyLine.push('');
                    bodyLine.push('');
                }
                body.push(bodyLine);

                Object.keys(typeCounts).forEach((id) => {
                    bodyLine = [this.$t('shift.template.amount') + ' ' + contractTypeMap[id] + ' ','','', typeCounts[id], '', '', '','', '','', '',  '', ''];
                    if(payment){
                        bodyLine.push('');
                        bodyLine.push('');
                    }
                    body.push(bodyLine);

                });

                doc.autoTable({
                    startY:  offset + 20,
                    head: [headers],
                    body: body,
                    headStyles: {
                    fillColor: [109,141,33],
                    fontSize: 7,
                    },
                    bodyStyles: {
                    fontSize: 7
                    },
                    columnStyles: {
                    },
                    horizontalPageBreak: headers.length > 15,
                    horizontalPageBreakRepeat: 0,
                });
            }



            this.$helpers.previewPdf(doc, filename);
        },
        printEmployeesCSV(date, activeOnly = true, printPayment = true, pregnantOnly = false, includePlantype = false, externalServiceId = null, includeEmploymentGroup = false, sortOrder = 1){
            let startOfMonth = date.clone().startOf('month');
            let endOfMonth = date.clone().endOf('month').add(7,'days').startOf('month');


            let employeeCategoryMap = {};
            let contractTypeMap = {};
            this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
            this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);

            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            // e.address, e.postalCode, e.city, e.iban, e.bic,
            let csv = "";
            if(externalServiceId != null){
                csv+="Externe ID; "
            }
            csv +=this.$t('pages.employeeContext.csvHeader1');
            if(printPayment){
                csv+=this.$t('pages.employeeContext.csvPaymentHeader');
            }
            if(includePlantype){
                csv+=";" + this.$t('pages.employeeContract.planningEmployeeType');
            }
            if(includeEmploymentGroup){
                csv+=";" + this.$t('pages.employeeContract.employmentGroup')
            }
            csv +="\r\n";

            let sortedEmployees = this.employeeArray.sort((a, b) => {
                let aName = a.lastName + a.firstName;
                let bName = b.lastName + b.firstName;
                if(sortOrder == 1){

                    return aName.localeCompare(bName);

                } else if (sortOrder == 2){
                    let aNum = a.personnelId != null ? parseInt(a.personnelId) : Number.MAX_SAFE_INTEGER;
                    let bNum = b.personnelId != null ? parseInt(b.personnelId) : Number.MAX_SAFE_INTEGER;

                    aNum = isNaN(aNum) ? Number.MAX_SAFE_INTEGER : aNum;
                    bNum = isNaN(bNum) ? Number.MAX_SAFE_INTEGER : bNum;

                    let res = aNum - bNum;
                    if(res == 0){
                        return aName.localeCompare(bName);
                    } else {
                        return res;
                    }


                } else if (sortOrder == 3){
                    let aDob = a.dob != null ? view.$helpers.getMomentFromStringTZ(a.dob) : view.$helpers.getMomentFromStringTZ('1900-01-01T00:00:00.000000Z');
                    let bDob = b.dob != null ? view.$helpers.getMomentFromStringTZ(b.dob) : view.$helpers.getMomentFromStringTZ('1900-01-01T00:00:00.000000Z');

                    let res = bDob.diff(aDob, 'minutes');
                    if(res == 0){
                        return aName.localeCompare(bName);
                    } else {
                        return res;
                    }
                } else if (sortOrder == 4){
                    let aNat = a.nationality == 0 ? 'Zza' : (a.nationality != null && this.countryMap[a.nationality] ? (this.countryMap[a.nationality]) : 'Zzzz');
                    let bNat = b.nationality == 0 ? 'Zza' : (b.nationality != null && this.countryMap[b.nationality] ? (this.countryMap[b.nationality]) : 'Zzzz');

                    let res = aNat.localeCompare(bNat);
                    if(res == 0){
                        return aName.localeCompare(bName);
                    } else {
                        return res;
                    }
                }
            });

            sortedEmployees.forEach((e) => {
                let contract = this.employeeContractForEmployee(e, date);
                if((!activeOnly || e.active) && (!pregnantOnly || (contract && contract.pregnant))){

                    var futureContracts = this.employeeContractsForEmployeeWithType(e, 2, date);
                    var pastContracts = this.employeeContractsForEmployeeWithType(e, 0, date);
                    let contracts = this.employeeEmployeeContractMap[e.id] ? this.employeeEmployeeContractMap[e.id]: [];
                    let citType = this.employeeFieldForCsvHeader(this.$t('pages.employeeCoreData.citizenType'), e, null);
                    let nationality = this.employeeFieldForCsvHeader(this.$t('pages.employeeCoreData.nationality'), e, null);
                    let country = this.employeeFieldForCsvHeader(this.$t('pages.employeeCoreData.country'), e, null);
                    var from = '';
                    var to = '';
                    let probationTo = '';
                    let deadlineTo = '';

                    var category = '';
                    var type = '';
                    let job = '';
                    var weekTimeRegular = 0;
                    let monthTimeRegular = 0;
                    let compensation = view.GetCompensationForMonthFromContracts(e,startOfMonth,endOfMonth);
                    let assistanceCompensation = view.GetAssistanceCompensationForMonthFromContracts(e,startOfMonth,endOfMonth);
                    let nightWorkTimePayment = 0;
                    let nightWorkCountPayment = 0;
                    let overTimePayment = 0;
                    let overTimeCountPayment = 0;

                    if(contract == null && futureContracts.length > 0){
                        var nextFrom;
                        futureContracts.forEach((fc) => {
                            var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                            if(nextFrom == null){
                                nextFrom = curFrom;
                                contract = fc;
                            }else{
                                if(curFrom < nextFrom){
                                    nextFrom = curFrom;
                                    contract = fc;
                                }
                            }
                        });
                    }
                    if(contract == null && pastContracts.length > 0){
                        var lastTo;
                        pastContracts.forEach((pc) => {
                            var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                            if(lastTo == null){
                                lastTo = curTo;
                                contract = pc;
                            }else{
                                if(curTo > lastTo){
                                    lastTo = curTo;
                                    contract = pc;
                                }
                            }
                        });
                    }

                    if(contract != null){
                        from = this.$helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY');
                        if(contract.to != null){
                            let toMoment = this.$helpers.getMomentFromStringTZ(contract.to);
                            toMoment = toMoment.subtract(1, "days");
                            to = toMoment.format('DD.MM.YYYY');
                        }
                        if(contract.probationTo != null){
                            let toMoment = this.$helpers.getMomentFromStringTZ(contract.probationTo);
                            toMoment = toMoment.subtract(1, "days");
                            probationTo = toMoment.format('DD.MM.YYYY');
                        }
                        if(contract.deadlineTo != null){
                            let toMoment = this.$helpers.getMomentFromStringTZ(contract.deadlineTo);
                            toMoment = toMoment.subtract(1, "days");
                            deadlineTo = toMoment.format('DD.MM.YYYY');
                        }

                        weekTimeRegular = contract.weekTimeRegular / 60;
                        let holidays = Object.values(this.holidayMap).filter(h=> h.active && h.federalHoliday).map(h => view.$helpers.getMomentFromStringTZ(h.from));
                        let includingContractHolidayMoments = Object.values(this.holidayMap).filter(h => h.active && (h.federalHoliday || h.contractHoliday)).map(h => view.$helpers.getMomentFromStringTZ(h.from));
                        
                        monthTimeRegular = this.$helpers.GetWorktimeForRangeWithinMonthFromContracts(startOfMonth, startOfMonth, endOfMonth, contracts, this.allowedContractMap, this.storeSettings, this.storeSettings.workTimeMode, this.storeSettings.exitFactoring, null, holidays, includingContractHolidayMoments)/60;

                        category = employeeCategoryMap[contract.employeeCategory];
                        type = contractTypeMap[contract.contractType];
                        job = contract.jobName != null ? contract.jobName : '';

                        nightWorkTimePayment = contract.calculateNightWork ? contract.nightWorkBonusHour : 0;
                        nightWorkCountPayment = contract.calculateNightWork ? contract.nightWorkBonusShift : 0;
                        overTimePayment = contract.overtimeBonusHour;
                        overTimeCountPayment = contract.overtimeBonusShift;
                    }
                    let eSpot = e.spotId != null? this.spotMap[e.spotId].label : '';
                    let firstAid = e.firstaidcourse != null? e.firstaidcourse : false;
                    let faExpiry = e.faExpiry != null? this.$helpers.extractDateStringTZ(e.faExpiry) : '';
                    let dlicense = e.driverslicense != null? e.driverslicense : false;
                    let dlExpiry = e.dlExpiry != null? this.$helpers.extractDateStringTZ(e.dlExpiry) : '';
                        // csv += "Nachname,Vorname,Geburtsdatum,SVNR,E-Mail,Mobil,Festnetz,Eintritt,Austritt,Wochenstunden,Entgelt\n\r";
                    let miscInfo = e.miscInfo != null? e.miscInfo : '';
                    miscInfo = miscInfo.replace(/(\r\n|\n|\r)/gm,",");
                    miscInfo = miscInfo.replace(";", ",");
                    miscInfo = miscInfo.replace(/\s+/g," ");
                    let bodyLine = [];
                    if(externalServiceId != null){
                        let eId = Object.values(this.employeeExternalDataMap).filter(ed => ed.externalServiceId == externalServiceId && ed.employeeId == e.id).map(ed => ed.externalId);
                        bodyLine.push(eId ? eId : '');
                    }
                    bodyLine = bodyLine.concat([e.personnelId != null ? e.personnelId : '', e.lastName, e.firstName, e.dob != null? this.$helpers.extractDateString(e.dob, 'DD.MM.YYYY') : '', e.socialsecurity, e.address, e.postalCode, e.city, country, citType, nationality, e.iban, e.bic, e.email, e.mobilephone, e.homephone, this.employeeContractEntryDate(e, true), this.employeeContractEntryDate(e, false), e.workExperience != null ? e.workExperience : 0, probationTo, deadlineTo, to, job, category, type, weekTimeRegular != 0? weekTimeRegular.toFixed(2).replace('.',',') : '',monthTimeRegular != 0? monthTimeRegular.toFixed(2).replace('.',',') : '', e.taxId, e.healthInsurance, e.healthInsuranceAddress, miscInfo, eSpot.replace(";", ","), firstAid? this.$t('global.ui.yes'): this.$t('global.ui.no'), faExpiry, dlicense? this.$t('global.ui.yes'): this.$t('global.ui.no'), dlExpiry]);
                    if(printPayment){
                        bodyLine.push(compensation.toFixed(2).replace('.',',') + ' €');
                        bodyLine.push(assistanceCompensation.toFixed(2).replace('.',',') + ' €');
                        bodyLine.push((nightWorkTimePayment/100).toFixed(2).replace('.',',') + ' €');
                        bodyLine.push((nightWorkCountPayment/100).toFixed(2).replace('.',',') + ' €');
                        bodyLine.push((overTimePayment/100).toFixed(2).replace('.',',') + ' €');
                        bodyLine.push((overTimeCountPayment/100).toFixed(2).replace('.',',') + ' €');
                    }

                    if(includePlantype){
                        let et = this.employeeTypeForEmployee(e);
                        bodyLine.push(et != null ? (et.weekTimeRegular/60.0).toFixed(2)+"h / "+et.weekWorkDaysRegular+"T" : "-")
                    }
                    if(includeEmploymentGroup){
                        bodyLine.push(contract != null ? contract.employmentGroup : '');
                    }

                    csv += bodyLine.join(";");
                    csv += "\r\n";

                }
            });
            let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "Personal_"+this.storeSettings.name+".csv");
            document.body.appendChild(link); // Required for FF

            link.click();
            //window.open(encodedUri);
        },
        printEmployees(){
            let view = this;
            let externalServiceItems = Object.values(this.externalServicesMap).filter(i => i.useExternalEmployeeIds).map(i => {return {label: i.name, value: i.id}});

            let sortItems = [{label: this.$t('pages.employeeData.lastname'), value: 1}, {label: this.$t('pages.employeeCoreData.personnelNumber'), value: 2}, {label: this.$t('pages.employeeData.dateOfBirth'), value: 3}, {label: "Nationalität", value: 4}];

            let reportDate = this.$helpers.getMomentTZ().startOf('day');
            let dataEntries = [
                {label: "Datum", key: 'date', hidden: false, type: 'date', value: reportDate},
                {label: this.$t('pages.employeeContext.exportAsCsv'), key: 'exportCsv', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.onlyExportActiveEmployees'), key: 'activeOnly', hidden: false, type: 'bool', value: true},
                {label: this.$t('pages.employeeContext.onlyExportPregnantEmployees'), key: 'pregnantOnly', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.includeGenderStatistics'), key: 'includeGenderStats', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('exportCsv'), type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.includePlanningBase'), key: 'includePlantype', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.includeEmploymentGroup'), key: 'includeEmploymentGroup', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.exportWithWages'), key: 'payment', hidden: false, type: 'bool', value: true},
                {label: this.$t('pages.employeeContext.exportWithPhoneNumber'), key: 'includePhone', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('exportCsv'), type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.exportWithAddress'), key: 'includeAddress', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('exportCsv'), type: 'bool', value: false},

                {label: this.$t('pages.employeeContext.exportWithExternalIds'), key: 'includeExternalId', hidden: view.$helpers.CheckDatafillKeysForHidden('exportCsv'), type: 'bool', value: false},
                {label: view.$t('pages.employeeContext.service'), key: 'externalServiceId', disabled: false, hidden: view.$helpers.CheckDatafillKeysForHidden('includeExternalId') || view.$helpers.CheckDatafillKeysForHidden('exportCsv'), type: 'dropdownsearch', value: null, flexGroup: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: externalServiceItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            selectFirst: true,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                          }
                },
                {label: this.$t('global.general.sorting'), key: 'sortOrder', disabled: false, hidden: false, type: 'dropdownsearch', value: 1, flexGroup: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: sortItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            selectFirst: true,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                          }
                },
            ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (item) {
                            
                            if(item.exportCsv){
                                view.printEmployeesCSV(item.date, item.activeOnly, item.payment, item.pregnantOnly, item.includePlantype, item.includeExternalId ? item.externalServiceId : null, item.includeEmploymentGroup, item.sortOrder);
                            }else{
                                view.printEmployeesPDF(item.date, item.activeOnly, item.payment, item.pregnantOnly, item.includeGenderStats, item.includePlantype, item.includeEmploymentGroup, item.includePhone, item.includeAddress, item.sortOrder);
                            }
                        },
                    },
                    header: this.$t('pages.employeeContext.exportEmployees'),
                    centered: true,
                    width: '600px',
                    expanded: true,
                });

        },
        printUnderagedPDF(activeOnly = true){
          let view = this;
          let headers = [this.$t('pages.employeeContext.lastFirstName'), this.$t('pages.employeeContext.placeOfResidence'), this.$t('pages.employeeCoreData.dob'),
              this.$t('pages.employeeContext.entry'), this.$t('pages.employeeContext.employmentType'), this.$t('pages.employeeCoreData.emergencyContact'),
              this.$t('pages.employeeCoreData.emergencyContactPhoneShort'), this.$t('pages.employeeCoreData.emergencyContactAddressShort')];
          let filename = this.$t('pages.employeeContext.underageOverview') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY') + '.pdf';
          var body = [];
          let employeeCategoryMap = {};
          let contractTypeMap = {};
          this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
          this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);
          var repDoc = this.$helpers.tableReportDoc(
              headers,
              this.$t('pages.employeeContext.underageOverview') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),
              this.storeSettings.name,
              this.storeSettings.description,
              this.userFullname,
              7);
          var doc = repDoc.doc;
          var contentOffsetY = repDoc.contentOffsetY;
          doc.setFontSize(12);

          let startOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().startOf('month');
          let endOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().endOf('month').add(7,'days').startOf('month');

          let activeEmployees = 0;
          let typeCounts = {
            1: 0,
            2: 0,
            3: 0
          };

          let underagedEmployess = this.employeeArray.filter(e => {
            var dobMoment = this.$helpers.getMomentFromStringTZ(e.dob);
            var dob18yearsMoment = dobMoment.add(18, 'years').add(1, 'month');
            return endOfMonth < dob18yearsMoment;
          });

          underagedEmployess.forEach((e) => {
            let contract = this.employeeContractForEmployee(e);
            if(!activeOnly || e.active){
              var futureContracts = this.employeeContractsForEmployeeWithType(e, 2);
              var pastContracts = this.employeeContractsForEmployeeWithType(e, 0);

              var type = ''

              if(view.EmployeeIsActiveInTimeRange(e, startOfMonth, endOfMonth)) activeEmployees++;

              if(contract == null && futureContracts.length > 0){
                var nextFrom;
                futureContracts.forEach((fc) => {
                  var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                  if(nextFrom == null){
                    nextFrom = curFrom;
                    contract = fc;
                  }else{
                    if(curFrom < nextFrom){
                      nextFrom = curFrom;
                      contract = fc;
                    }
                  }
                });
              }

              if(contract == null && pastContracts.length > 0){
                var lastTo;
                pastContracts.forEach((pc) => {
                  var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                  if(lastTo == null){
                    lastTo = curTo;
                    contract = pc;
                  }else{
                    if(curTo > lastTo){
                      lastTo = curTo;
                      contract = pc;
                    }
                  }
                });
              }

              if(contract != null){
                type = contractTypeMap[contract.contractType];
                typeCounts[contract.contractType]++;

              }
              let bodyLine = [
                e.lastName + ' ' + e.firstName,
                e.city,
                e.dob != null? this.$helpers.extractDateString(e.dob, 'DD.MM.YYYY') : '',
                this.employeeContractEntryDate(e, false),
                type,
                e.guardianName != null ? e.guardianName : '',
                e.guardianPhone != null ? e.guardianPhone : '',
                e.guardianAddress != null ? e.guardianAddress : '',
              ]
              body.push(bodyLine);
            }
          });
          let bodyLine = ['','','', '', '', '', '','', '','', '',  '', ''];
          body.push(bodyLine);

          bodyLine = ['','','', '', '', '', '','', '','', '', '', ''];
          body.push(bodyLine);

          bodyLine = [this.$t('pages.employeeContext.activeUnderage') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),'','',activeEmployees,'','','','','','','','','',''];
          body.push(bodyLine);

          bodyLine = ['','','', '', '', '', '','', '','','', '', ''];
          body.push(bodyLine);

          bodyLine = [this.$t('pages.employeeContext.byContractType'),'','', '', '', '', '','', '','', '', '', ''];
          body.push(bodyLine);

          Object.keys(typeCounts).forEach((id) => {
            bodyLine = [this.$t('shift.template.amount') + ' ' + contractTypeMap[id] + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),'','', typeCounts[id], '', '', '','', '','', '',  '', '', ''];
            body.push(bodyLine);

          });



          doc.autoTable({
            startY: contentOffsetY,
            head: [headers],
            body: body,
            headStyles: {
              fillColor: [109,141,33],
              fontSize: 7,
            },
            bodyStyles: {
              fontSize: 7
            },
            columnStyles: {
              9: {
                halign: 'right'
              },
              10: {
                halign: 'right',
                cellWidth: 15
              }
            }
          })

          this.$helpers.previewPdf(doc, filename);
        },
        printUnderagedCSV(activeOnly = true){
          let endOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().endOf('month').add(7,'days').startOf('month');

          let employeeCategoryMap = {};
          let contractTypeMap = {};
          this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
          this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);

          let csvPre = "data:text/csv;charset=utf-8,";
          let csv = this.$t('pages.employeeContext.csvHeader2');

          csv +="\r\n";
          let underagedEmployess = this.employeeArray.filter(e => {
            var dobMoment = this.$helpers.getMomentFromStringTZ(e.dob);
            var dob18yearsMoment = dobMoment.add(18, 'years').add(1, 'month');
            return endOfMonth < dob18yearsMoment;
          });
          underagedEmployess.forEach((e) => {
            let contract = this.employeeContractForEmployee(e);
            if(!activeOnly || e.active){

              var futureContracts = this.employeeContractsForEmployeeWithType(e, 2);
              var pastContracts = this.employeeContractsForEmployeeWithType(e, 0);
              var type = '';

              if(contract == null && futureContracts.length > 0){
                var nextFrom;
                futureContracts.forEach((fc) => {
                  var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                  if(nextFrom == null){
                    nextFrom = curFrom;
                    contract = fc;
                  }else{
                    if(curFrom < nextFrom){
                      nextFrom = curFrom;
                      contract = fc;
                    }
                  }
                });
              }
              if(contract == null && pastContracts.length > 0){
                var lastTo;
                pastContracts.forEach((pc) => {
                  var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                  if(lastTo == null){
                    lastTo = curTo;
                    contract = pc;
                  }else{
                    if(curTo > lastTo){
                      lastTo = curTo;
                      contract = pc;
                    }
                  }
                });
              }

              if(contract != null){
                type = contractTypeMap[contract.contractType];
              }

              let bodyLine = [
                e.lastName,
                e.firstName,
                e.city,
                e.dob != null? this.$helpers.extractDateString(e.dob, 'DD.MM.YYYY') : '',
                this.employeeContractEntryDate(e, false),
                type,
                e.guardianName != null ? e.guardianName : '',
                e.guardianPhone != null ? e.guardianPhone : '',
                e.guardianAddress != null ? e.guardianAddress : '',
              ]
              csv += bodyLine.join(";");
              csv += "\r\n";

            }
          });
          let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", this.$t('pages.employeeContext.underage') + ".csv");
          document.body.appendChild(link); // Required for FF

          link.click();
          //window.open(encodedUri);
        },
        printUnderaged(){
            let view = this;

            let dataEntries = [
                {label: this.$t('pages.employeeContext.exportAsCsv'), key: 'exportCsv', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.onlyExportActiveEmployees'), key: 'activeOnly', hidden: false, type: 'bool', value: true},
            ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (item) {
                            if(item.exportCsv){
                                view.printUnderagedCSV(item.activeOnly);
                            }else{
                                view.printUnderagedPDF(item.activeOnly);
                            }
                        },
                    },
                    header: this.$t('pages.employeeContext.exportUnderage'),
                    centered: true,
                    width: '600px',
                    expanded: true,
                });

        },
        printDisabledPDF(activeOnly = true){
          let view = this;
          let headers = ['PersNr.',this.$t('pages.employeeContext.lastFirstName'), this.$t('pages.employeeCoreData.dob'), this.$t('pages.employeeContext.ssn'), this.$t('pages.employeeContext.entry'), this.$t('pages.employeeContext.employmentType'), this.$t('pages.employeeContext.emergencyContact'), this.$t('pages.employeeContext.emergencyContactPhoneShort'), this.$t('pages.employeeContext.emergencyContactAddressShort'), this.$t('pages.employeeContext.under19')];
          let filename = this.$t('pages.employeeContext.overviewEligibleEmployees') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY') + '.pdf';
          var body = [];
          let employeeCategoryMap = {};
          let contractTypeMap = {};
          this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
          this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);
          var repDoc = this.$helpers.tableReportDoc(
              headers,
              this.$t('pages.employeeContext.overviewEligibleEmployees') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),
              this.storeSettings.name,
              this.storeSettings.description,
              this.userFullname,
              7);
          var doc = repDoc.doc;
          var contentOffsetY = repDoc.contentOffsetY;
          doc.setFontSize(12);

          let startOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().startOf('month');
          let endOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().endOf('month').add(7,'days').startOf('month');

          let activeEmployees = 0;
          let countableEmployees = 0;
          let typeCounts = {
            1: 0,
            2: 0,
            3: 0
          };

          let disabledEmployees = this.employeeArray.filter(e => {
            return e.disability;
          });

          disabledEmployees.forEach((e) => {
            var dobMoment = this.$helpers.getMomentFromStringTZ(e.dob);
            var dob19yearsMoment = dobMoment.add(19, 'years').add(1, 'month');
            var isUnder19 = endOfMonth < dob19yearsMoment;
            let contract = this.employeeContractForEmployee(e);
            if(!activeOnly || e.active){
              var futureContracts = this.employeeContractsForEmployeeWithType(e, 2);
              var pastContracts = this.employeeContractsForEmployeeWithType(e, 0);

              var type = ''

              if(view.EmployeeIsActiveInTimeRange(e, startOfMonth, endOfMonth)) {
                activeEmployees++;
                countableEmployees++;
                if(isUnder19){
                    countableEmployees++;
                }
              }

              if(contract == null && futureContracts.length > 0){
                var nextFrom;
                futureContracts.forEach((fc) => {
                  var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                  if(nextFrom == null){
                    nextFrom = curFrom;
                    contract = fc;
                  }else{
                    if(curFrom < nextFrom){
                      nextFrom = curFrom;
                      contract = fc;
                    }
                  }
                });
              }

              if(contract == null && pastContracts.length > 0){
                var lastTo;
                pastContracts.forEach((pc) => {
                  var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                  if(lastTo == null){
                    lastTo = curTo;
                    contract = pc;
                  }else{
                    if(curTo > lastTo){
                      lastTo = curTo;
                      contract = pc;
                    }
                  }
                });
              }

              if(contract != null){
                type = contractTypeMap[contract.contractType];
                typeCounts[contract.contractType]++;

              }
              let bodyLine = [
                e.personnelId,
                e.lastName + ' ' + e.firstName,
                e.dob != null? this.$helpers.extractDateString(e.dob, 'DD.MM.YYYY') : '',
                e.socialsecurity,
                this.employeeContractEntryDate(e, false),
                type,
                e.guardianName != null ? e.guardianName : '',
                e.guardianPhone != null ? e.guardianPhone : '',
                e.guardianAddress != null ? e.guardianAddress : '',
                isUnder19? this.$t('global.ui.yes').toUpperCase() : ''
              ]
              body.push(bodyLine);
            }
          });
          let bodyLine = ['', '','','', '', '', '', '','', '','', '',  '', '',''];
          body.push(bodyLine);

          bodyLine = ['', '','','', '', '', '', '','', '','', '', '', '',''];
          body.push(bodyLine);

          bodyLine = ['',this.$t('pages.employeeContext.activeEligibleEmployees') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),'','',activeEmployees,'', '','','','','','','','','',''];
          body.push(bodyLine);
          bodyLine = ['', this.$t('pages.employeeContext.creditableUnder19takenIntoAccount') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),'','',countableEmployees,'','','','','','','','','','',''];
          body.push(bodyLine);

          bodyLine = ['', '','','', '', '', '', '','', '','','', '', '',''];
          body.push(bodyLine);

          bodyLine = ['', this.$t('pages.employeeContext.byContractType'),'','', '', '', '', '','', '','', '', '','',''];
          body.push(bodyLine);

          Object.keys(typeCounts).forEach((id) => {
            bodyLine = ['', this.$t('shift.template.amount') + ' ' + contractTypeMap[id] + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),'','', typeCounts[id], '', '', '','', '','', '',  '', '', '',''];
            body.push(bodyLine);

          });



          doc.autoTable({
            startY: contentOffsetY,
            head: [headers],
            body: body,
            headStyles: {
              fillColor: [109,141,33],
              fontSize: 7,
            },
            bodyStyles: {
              fontSize: 7
            },
            columnStyles: {
              9: {
                halign: 'right'
              },
              10: {
                halign: 'right',
                cellWidth: 15
              }
            }
          })

          view.$helpers.previewPdf(doc, filename);
        },
        printDisabledCSV(activeOnly = true){
          let endOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().endOf('month').add(7,'days').startOf('month');

          let employeeCategoryMap = {};
          let contractTypeMap = {};
          this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
          this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);

          let csvPre = "data:text/csv;charset=utf-8,";
          let csv = this.$t('pages.employeeContext.csvHeader3');

          csv +="\r\n";
          let disabledEmployees = this.employeeArray.filter(e => {
            return e.disability;
          });
          disabledEmployees.forEach((e) => {
            var dobMoment = this.$helpers.getMomentFromStringTZ(e.dob);
            var dob19yearsMoment = dobMoment.add(19, 'years').add(1, 'month');
            var isUnder19 = endOfMonth < dob19yearsMoment;
            let contract = this.employeeContractForEmployee(e);
            if(!activeOnly || e.active){

              var futureContracts = this.employeeContractsForEmployeeWithType(e, 2);
              var pastContracts = this.employeeContractsForEmployeeWithType(e, 0);
              var type = '';

              if(contract == null && futureContracts.length > 0){
                var nextFrom;
                futureContracts.forEach((fc) => {
                  var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                  if(nextFrom == null){
                    nextFrom = curFrom;
                    contract = fc;
                  }else{
                    if(curFrom < nextFrom){
                      nextFrom = curFrom;
                      contract = fc;
                    }
                  }
                });
              }
              if(contract == null && pastContracts.length > 0){
                var lastTo;
                pastContracts.forEach((pc) => {
                  var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                  if(lastTo == null){
                    lastTo = curTo;
                    contract = pc;
                  }else{
                    if(curTo > lastTo){
                      lastTo = curTo;
                      contract = pc;
                    }
                  }
                });
              }

              if(contract != null){
                type = contractTypeMap[contract.contractType];
              }

              let bodyLine = [
                e.personnelId,
                e.lastName,
                e.firstName,
                e.dob != null? this.$helpers.extractDateString(e.dob, 'DD.MM.YYYY') : '',
                e.socialsecurity,
                this.employeeContractEntryDate(e, false),
                type,
                e.guardianName != null ? e.guardianName : '',
                e.guardianPhone != null ? e.guardianPhone : '',
                e.guardianAddress != null ? e.guardianAddress : '',
                isUnder19? this.$t('global.ui.yes').toUpperCase() : ''
              ]
              csv += bodyLine.join(";");
              csv += "\r\n";

            }
          });
          let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", this.$t('pages.employeeContext.eligibleEmp') + ".csv");
          document.body.appendChild(link); // Required for FF

          link.click();
          //window.open(encodedUri);
        },
        printDisabled(){
            let view = this;

            let dataEntries = [
                {label: this.$t('pages.employeeContext.exportAsCsv'), key: 'exportCsv', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.onlyExportActiveEmployees'), key: 'activeOnly', hidden: false, type: 'bool', value: true},
            ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (item) {
                            if(item.exportCsv){
                                view.printDisabledCSV(item.activeOnly);
                            }else{
                                view.printDisabledPDF(item.activeOnly);
                            }
                        },
                    },
                    header: this.$t('pages.employeeContext.exportEligibleEmployees'),
                    centered: true,
                    width: '600px',
                    expanded: true,
                });

        },
        printFirstAidPDF(activeOnly = true){
          let view = this;
          let headers = [this.$t('pages.employeeContext.lastFirstName'), this.$t('pages.employeeCoreData.firstaidcourse'), this.$t('global.general.expiringDate'), this.$t('pages.employeeContext.entry'), this.$t('pages.employeeContext.employmentType')];
          let filename = this.$t('pages.employeeContext.firstAidOverview') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY') + '.pdf';
          var body = [];
          let employeeCategoryMap = {};
          let contractTypeMap = {};
          this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
          this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);
          var repDoc = this.$helpers.tableReportDoc(
              headers,
              this.$t('pages.employeeContext.firstAidOverview') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),
              this.storeSettings.name,
              this.storeSettings.description,
              this.userFullname,
              7);
          var doc = repDoc.doc;
          var contentOffsetY = repDoc.contentOffsetY;
          doc.setFontSize(12);

          let startOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().startOf('month');
          let endOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().endOf('month').add(7,'days').startOf('month');

          let activeEmployees = 0;
          let typeCounts = {
            1: 0,
            2: 0,
            3: 0
          };

          let firstAidEmployess = this.employeeArray.filter(e => {


            return e.firstaidcourse;
          });

          firstAidEmployess.forEach((e) => {
            let contract = this.employeeContractForEmployee(e);
            if(!activeOnly || e.active){
              var futureContracts = this.employeeContractsForEmployeeWithType(e, 2);
              var pastContracts = this.employeeContractsForEmployeeWithType(e, 0);

              var type = ''

              if(view.EmployeeIsActiveInTimeRange(e, startOfMonth, endOfMonth)) activeEmployees++;

              if(contract == null && futureContracts.length > 0){
                var nextFrom;
                futureContracts.forEach((fc) => {
                  var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                  if(nextFrom == null){
                    nextFrom = curFrom;
                    contract = fc;
                  }else{
                    if(curFrom < nextFrom){
                      nextFrom = curFrom;
                      contract = fc;
                    }
                  }
                });
              }

              if(contract == null && pastContracts.length > 0){
                var lastTo;
                pastContracts.forEach((pc) => {
                  var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                  if(lastTo == null){
                    lastTo = curTo;
                    contract = pc;
                  }else{
                    if(curTo > lastTo){
                      lastTo = curTo;
                      contract = pc;
                    }
                  }
                });
              }

              if(contract != null){
                type = contractTypeMap[contract.contractType];
                typeCounts[contract.contractType]++;

              }
              let bodyLine = [
                e.lastName + ' ' + e.firstName,
                e.firstaidcourse ? this.$t('global.ui.yes') : this.$t('global.ui.no'),
                e.faExpiry != null? this.$helpers.extractDateString(e.faExpiry, 'DD.MM.YYYY') : '',
                this.employeeContractEntryDate(e, false),
                type,
              ]
              body.push(bodyLine);
            }
          });
          let bodyLine = ['','','', '', '', '', '','', '',''];
          body.push(bodyLine);

          bodyLine = ['','','', '', '', '', '','', '',''];
          body.push(bodyLine);

          bodyLine = [this.$t('pages.employeeContext.activeFirstAids') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),'','',activeEmployees,'','','','','','',''];
          body.push(bodyLine);

          bodyLine = ['','','', '', '', '', '','', '',''];
          body.push(bodyLine);

          bodyLine = [this.$t('pages.employeeContext.byContractType'),'','', '', '', '', '','', '',''];
          body.push(bodyLine);

          Object.keys(typeCounts).forEach((id) => {
            bodyLine = [this.$t('shift.template.amount') + ' ' + contractTypeMap[id] + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),'','', typeCounts[id], '', '', '','', '','', ''];
            body.push(bodyLine);

          });



          doc.autoTable({
            startY: contentOffsetY,
            head: [headers],
            body: body,
            headStyles: {
              fillColor: [109,141,33],
              fontSize: 7,
            },
            bodyStyles: {
              fontSize: 7
            },
            columnStyles: {
              9: {
                halign: 'right'
              },
              10: {
                halign: 'right',
                cellWidth: 15
              }
            }
          })

          this.$helpers.previewPdf(doc, filename);
        },
        printFirstAidCSV(activeOnly = true){
          let endOfMonth = this.$helpers.getCurrentMonthMomentTZ().clone().endOf('month').add(7,'days').startOf('month');

          let employeeCategoryMap = {};
          let contractTypeMap = {};
          this.uiData.employeeCategories.forEach(item => employeeCategoryMap[item.id] = item.label_de);
          this.uiData.contractTypes.forEach(item => contractTypeMap[item.id] = item.label_de);

          let csvPre = "data:text/csv;charset=utf-8,";
          let csv = this.$t('pages.employeeContext.csvHeaderFirstAid');

          csv +="\r\n";
          let firstAidEmployess = this.employeeArray.filter(e => {


            return e.firstaidcourse;
          });
          firstAidEmployess.forEach((e) => {
            let contract = this.employeeContractForEmployee(e);
            if(!activeOnly || e.active){

              var futureContracts = this.employeeContractsForEmployeeWithType(e, 2);
              var pastContracts = this.employeeContractsForEmployeeWithType(e, 0);
              var type = '';

              if(contract == null && futureContracts.length > 0){
                var nextFrom;
                futureContracts.forEach((fc) => {
                  var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
                  if(nextFrom == null){
                    nextFrom = curFrom;
                    contract = fc;
                  }else{
                    if(curFrom < nextFrom){
                      nextFrom = curFrom;
                      contract = fc;
                    }
                  }
                });
              }
              if(contract == null && pastContracts.length > 0){
                var lastTo;
                pastContracts.forEach((pc) => {
                  var curTo = this.$helpers.getMomentFromStringTZ(pc.to);
                  if(lastTo == null){
                    lastTo = curTo;
                    contract = pc;
                  }else{
                    if(curTo > lastTo){
                      lastTo = curTo;
                      contract = pc;
                    }
                  }
                });
              }

              if(contract != null){
                type = contractTypeMap[contract.contractType];
              }

              let bodyLine = [
                e.lastName + ' ' + e.firstName,
                e.firstaidcourse ? this.$t('global.ui.yes') : this.$t('global.ui.no'),
                e.faExpiry != null? this.$helpers.extractDateString(e.faExpiry, 'DD.MM.YYYY') : '',
                this.employeeContractEntryDate(e, false),
                type,
              ]
              csv += bodyLine.join(";");
              csv += "\r\n";

            }
          });
          let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", this.$t('pages.employeeCoreData.firstaidcourse') + ".csv");
          document.body.appendChild(link); // Required for FF

          link.click();
          //window.open(encodedUri);
        },
        printFirstAid(){
            let view = this;

            let dataEntries = [
                {label: this.$t('pages.employeeContext.exportAsCsv'), key: 'exportCsv', hidden: false, type: 'bool', value: false},
                {label: this.$t('pages.employeeContext.onlyExportActiveEmployees'), key: 'activeOnly', hidden: false, type: 'bool', value: true},
            ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (item) {
                            if(item.exportCsv){
                                view.printFirstAidCSV(item.activeOnly);
                            }else{
                                view.printFirstAidPDF(item.activeOnly);
                            }
                        },
                    },
                    header: this.$t('pages.employeeContext.exportWithFirstAid'),
                    centered: true,
                    width: '600px',
                    expanded: true,
                });

        },
        printDocumentsOverview(){
            let view = this;

            let dataEntries = [

                {label: this.$t('pages.employeeContext.includeExpiredDocuments'), key: 'includeExpired', hidden: false, type: 'bool', value: true},
                {label: this.$t('pages.employeeContext.includeSoonExpiringDocuments'), key: 'includeExpiring', hidden: false, type: 'bool', value: true},
                {label: this.$t('pages.employeeContext.includeConfirmedDocuments'), key: 'includeConfirmed', hidden: false, type: 'bool', value: true},
                {label: this.$t('pages.employeeContext.includeUnconfirmedDocuments'), key: 'includeUnconfirmed', hidden: false, type: 'bool', value: true},
                {label: this.$t('pages.employeeContext.exportAsCsv'), key: 'csv', hidden: false, type: 'bool', value: false},
            ];

            this.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (item) {
                       view.printDocumentsOverviewPDF(item.includeConfirmed, item.includeExpired, item.includeExpiring, item.includeUnconfirmed, item.csv);


                    },
                },
                header: this.$t('pages.employeeContext.documentOverview'),
                centered: true,
                width: '600px',
                expanded: true,
            });
        },
        printDocumentsOverviewPDF(includeConfirmedDocuments = true, includeExpiredDocuments = true, includeExpiringDocuments = true, includeUnconfirmedDocuments = true, csv = false){
            let view = this;
            let confirmed = [];
            let expiringSoon = [];
            let expired = [];
            let unconfirmed = [];
            let config = this.notificationBellConfigState;
            let now = this.$helpers.getMoment();
            let soonInterval = 56;
            if(config.documentExpiryLimit){
                soonInterval = Math.max(1, config.documentExpiryLimit);
            }
            let soonDate = now.clone().add(soonInterval, "days");
            Object.values(this.employeeMap).filter(e => e.active).forEach(e => {

                Object.values(this.employeeFilesMap).filter(f => f.employeeId == e.id).forEach((file) => {
                    if(file.validUntil != null){
                        let validDate = this.$helpers.getMomentFromStringUTC(file.validUntil);
                        if(validDate < now){
                            expired.push(file);
                        } else if(validDate < soonDate){
                            expiringSoon.push(file);

                        }
                    }
                    if(!file.confirmed){
                        unconfirmed.push(file)
                    } else {
                        confirmed.push(file)
                    }
                });
            })


            expired = expired.sort((a, b) => {
                let aDate = view.$helpers.getMomentFromStringTZ(a.validUntil);
                let bDate = view.$helpers.getMomentFromStringTZ(b.validUntil);
                return aDate.unix() - bDate.unix();
            })

            expiringSoon = expiringSoon.sort((a, b) => {
                let aDate = view.$helpers.getMomentFromStringTZ(a.validUntil);
                let bDate = view.$helpers.getMomentFromStringTZ(b.validUntil);
                return aDate.unix() - bDate.unix();
            })

            unconfirmed = unconfirmed.sort((a, b) => {
                let aDate = view.$helpers.getMomentFromStringTZ(a.creationDate);
                let bDate = view.$helpers.getMomentFromStringTZ(b.creationDate);
                return aDate.unix() - bDate.unix();
            })

            let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$tc('global.general.employee', 1), this.$tc('global.general.document', 1), this.$tc('global.general.type', 1), this.$t('global.general.creationDate'), this.$t('global.general.expiringDate'), this.$t('global.general.status')];

            let body = [];


            if(includeExpiredDocuments){
                expired.forEach(f => {
                    body.push([view.employeeMap[f.employeeId].personnelId ?view.employeeMap[f.employeeId].personnelId :'-', view.employeeMap[f.employeeId].lastName+" "+view.employeeMap[f.employeeId].firstName, f.name, view.$helpers.documentTypeLabel(f.documentType), view.$helpers.extractDateStringTZ(f.creationDate, 'DD.MM.YYYY'), f.validUntil ? view.$helpers.extractDateStringTZ(f.validUntil, 'DD.MM.YYYY') : '-', this.$t('pages.employeeContext.expired')])
                })
            }
            if(includeExpiringDocuments){
                expiringSoon.forEach(f => {
                    body.push([view.employeeMap[f.employeeId].personnelId ?view.employeeMap[f.employeeId].personnelId :'-', view.employeeMap[f.employeeId].lastName+" "+view.employeeMap[f.employeeId].firstName, f.name, view.$helpers.documentTypeLabel(f.documentType), view.$helpers.extractDateStringTZ(f.creationDate, 'DD.MM.YYYY'), f.validUntil ? view.$helpers.extractDateStringTZ(f.validUntil, 'DD.MM.YYYY') : '-', this.$t('pages.employeeContext.expiresSoon')])
                })
            }
            if(includeConfirmedDocuments){
                confirmed.forEach(f => {
                    body.push([view.employeeMap[f.employeeId].personnelId ?view.employeeMap[f.employeeId].personnelId :'-', view.employeeMap[f.employeeId].lastName+" "+view.employeeMap[f.employeeId].firstName, f.name, view.$helpers.documentTypeLabel(f.documentType), view.$helpers.extractDateStringTZ(f.creationDate, 'DD.MM.YYYY'), f.validUntil ? view.$helpers.extractDateStringTZ(f.validUntil, 'DD.MM.YYYY') : '-', this.$t('global.ui.approved')])
                })
            }
            if(includeUnconfirmedDocuments){
                unconfirmed.forEach(f => {
                    body.push([view.employeeMap[f.employeeId].personnelId ?view.employeeMap[f.employeeId].personnelId :'-', view.employeeMap[f.employeeId].lastName+" "+view.employeeMap[f.employeeId].firstName, f.name, view.$helpers.documentTypeLabel(f.documentType), view.$helpers.extractDateStringTZ(f.creationDate, 'DD.MM.YYYY'), f.validUntil ? view.$helpers.extractDateStringTZ(f.validUntil, 'DD.MM.YYYY') : '-', this.$t('pages.employeeContext.unconfirmed')])
                })
            }

            if(csv){
                let filename = this.$t('pages.employeeContext.overviewEmployeeDocuments') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY') + '.csv';
                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                csv += headers.join(";");
                csv += "\n";
                body.forEach((line) => {
                    csv += line.join(";");
                    csv += "\n";
                })
                let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Required for FF

                link.click();
            } else {
                let filename = this.$t('pages.employeeContext.overviewEmployeeDocuments') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY') + '.pdf';
                let repDoc = this.$helpers.tableReportDoc(
                    headers,
                    this.$t('pages.employeeContext.overviewEmployeeDocuments') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),
                    this.storeSettings.name,
                    this.storeSettings.description,
                    this.userFullname,
                    7);
                let doc = repDoc.doc;
                let contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);

                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                    fillColor: [109,141,33],
                    fontSize: 7,
                    },
                    bodyStyles: {
                    fontSize: 7
                    },
                    columnStyles: {
                    9: {
                        halign: 'right'
                    },
                    10: {
                        halign: 'right',
                        cellWidth: 15
                    }
                    }
                })

                this.$helpers.previewPdf(doc, filename);
            }


        },
        docValidUntilHelper(employeeEmployeeFileMap, employeeId, documentType, alt1 = null, alt2 = null){
            let view = this;
            if(employeeEmployeeFileMap[employeeId]){
                let passportdocs = employeeEmployeeFileMap[employeeId].filter(f => f.documentType == documentType || (alt1 != null && f.documentType == alt1) || (alt2 != null && f.documentType == alt2));
                passportdocs.sort((a, b) => {
                        let aValidUntil = a.validUntil ? view.$helpers.getMomentFromStringTZ(a.validUntil) : null;
                        let bValidUntil = a.validUntil ? view.$helpers.getMomentFromStringTZ(b.validUntil) : null;
                        if(aValidUntil && bValidUntil){
                            return bValidUntil.unix() - aValidUntil.unix()
                        } else if(!aValidUntil){
                            return -1;
                        } else if(!bValidUntil){
                            return 1;
                        } else {
                            return 0;
                        }
                });
                if(passportdocs.length > 0){
                    let doc = passportdocs[0]
                    return doc.validUntil ? view.$helpers.getMomentFromStringTZ(doc.validUntil).format("DD.MM.YYYY") : this.$t('global.ui.available')
                } else {
                    return this.$t('global.ui.unavailable');
                }
            } else {
                return this.$t('global.ui.unavailable');
            }
        },
        printNonEUEmployeesPDF(){

            let headers = [this.$tc('global.general.employee'), this.$t('pages.employeeContext.nationality'), this.$t('pages.employeeContext.passport'), this.$t('pages.employeeContext.workPermit'), this.$t('pages.employeeContext.residencePermit'), this.$t('pages.employeeContext.schoolStudyPermit')];
            let filename = this.$t('pages.employeeContext.overviewThirdCountry') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY') + '.pdf';
            let body = [];

            let employeeEmployeeFileMap = {}
            Object.values(this.employeeFilesMap).forEach(f => {
                if(!employeeEmployeeFileMap[f.employeeId]){
                    employeeEmployeeFileMap[f.employeeId] = [];
                }
                employeeEmployeeFileMap[f.employeeId].push(f);
            })

            Object.values(this.employeeMap)
            .filter(e => e.active && e.citizenType != 1 && e.citizenType != 3 && e.citizenType != 6)
            .sort((a, b) => {
                let aName = a.lastName+" "+a.firstName;
                let bName = b.lastName+" "+b.firstName;
                return aName.localeCompare(bName);
            })
            .forEach(e => {
                let line = [e.lastName+" "+e.firstName, e.nationality != null && this.countryMap[e.nationality] ? (this.countryMap[e.nationality]) : '']

                line.push(this.docValidUntilHelper(employeeEmployeeFileMap,e.id, 'PASSPORT', "ASYLUMPASS"));
                line.push(this.docValidUntilHelper(employeeEmployeeFileMap,e.id, 'WORKPERMIT', 'RESIDENCEWORKPERMIT', "ASYLUMPASS"));
                line.push(this.docValidUntilHelper(employeeEmployeeFileMap,e.id, 'RESIDENCEPERMIT', 'RESIDENCEWORKPERMIT', "ASYLUMPASS"));
                line.push(this.docValidUntilHelper(employeeEmployeeFileMap,e.id, 'EDUCATIONCERTIFICATE'));

                body.push(line);

            })



            let repDoc = this.$helpers.tableReportDoc(
                headers,
                this.$t('pages.employeeContext.overviewThirdCountry') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),
                this.storeSettings.name,
                this.storeSettings.description,
                this.userFullname,
                7);
            let doc = repDoc.doc;
            let contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);

            doc.autoTable({
                startY: contentOffsetY,
                head: [headers],
                body: body,
                headStyles: {
                fillColor: [109,141,33],
                fontSize: 7,
                },
                bodyStyles: {
                fontSize: 7
                },
                columnStyles: {
                9: {
                    halign: 'right'
                },
                10: {
                    halign: 'right',
                    cellWidth: 15
                }
                }
            })

          this.$helpers.previewPdf(doc, filename);
        },
        printBirthdaysPDF(){
            let current_ts = this.$helpers.getMomentTZ();
            let headers = [this.$tc('global.general.employee'), this.$t('roster.view.birthday'), this.$t('global.ui.age'),];
            let filename = this.$t('pages.employeeContext.overviewBirthdays') + ' ' + current_ts.format('YYYY') + '.pdf';
            let body = [];

            

            Object.values(this.employeeMap)
            .filter(e => e.active && e.dob != null)
            .sort((a, b) => {
                let aDate = this.$helpers.getMomentFromStringTZ(a.dob);
                let bDate = this.$helpers.getMomentFromStringTZ(b.dob);
                let diff = aDate.month() - bDate.month();
                if(diff == 0){
                    diff = aDate.date() - bDate.date();
                    if(diff == 0){
                        diff = aDate.unix() - bDate.unix();
                        if(diff == 0){
                            let aName = a.lastName+" "+a.firstName;
                            let bName = b.lastName+" "+b.firstName;
                            return aName.localeCompare(bName);
                        } else {
                            return diff;
                        }
                    } else {
                        return diff;
                    }
                    
                } else {
                    return diff;
                }
                
            })
            .forEach(e => {
                let dob = this.$helpers.getMomentFromStringTZ(e.dob);
                let age = current_ts.clone().month(dob.month()).date(dob.date()).diff(dob, 'years');
                let line = [e.lastName+" "+e.firstName, dob.format("DD.MM.YYYY"), age]

                

                body.push(line);

            })



            let repDoc = this.$helpers.tableReportDoc(
                headers,
                this.$t('roster.view.birthdays') + ' ' + this.$helpers.getMomentTZ().format('YYYY'),
                this.storeSettings.name,
                this.storeSettings.description,
                this.userFullname,
                7);
            let doc = repDoc.doc;
            let contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);

            doc.autoTable({
                startY: contentOffsetY,
                head: [headers],
                body: body,
                headStyles: {
                fillColor: [109,141,33],
                fontSize: 7,
                },
                bodyStyles: {
                fontSize: 7
                },
                columnStyles: {
                
                }
            })

          this.$helpers.previewPdf(doc, filename);
        },

        printEmploymentDurationPDF(){
            let current_ts = this.$helpers.getMomentTZ();
            let headers = [this.$tc('global.general.employee'), this.$t('pages.employeeCoreData.firstEntry'), this.$t('pages.employeeCoreData.workExperience'), this.$t('pages.employeeCoreData.nonEmploymentTime'), this.$t('pages.employeeCoreData.employmentDuration')];
            let filename = this.$t('pages.employeeContext.employmentDurationOverview') + ' ' + current_ts.format('MMMM YYYY') + '.pdf';
            let body = [];

            

            Object.values(this.employeeMap)
            .filter(e => e.active)
            .sort((a, b) => {
                let aName = a.lastName+" "+a.firstName;
                let bName = b.lastName+" "+b.firstName;
                return aName.localeCompare(bName);
                
            })
            .forEach(e => {
                let currentDate = this.$helpers.getMomentTZ().startOf('month');
                let startDateS = '-';
                let workExperienceS = '-';
                let nonEmploymentTimeS = '-';
                let durationS = '-';
                if(e.workEntryDate){
                    let startDate = this.$helpers.getMomentFromStringTZ(e.workEntryDate).startOf('month');
                    startDateS = this.$helpers.getMomentFromStringTZ(e.workEntryDate).format('DD.MM.YYYY');
                    let exitDate = this.employeeContractExitDate(e, true);
                    if(exitDate){
                        exitDate = exitDate.startOf('month').add(1, 'month');
                        if(exitDate < currentDate){
                            currentDate = exitDate;
                        }
                    }
                    let additionalYears = e.workExperience ? e.workExperience/12.0 : 0;
                    let subtractedYears = e.nonEmploymentTime ? e.nonEmploymentTime/12.0 : 0;
                    let totalYears = Math.max(0, Math.max(currentDate.diff(startDate, 'months')/12.0, 0) + additionalYears - subtractedYears);

                    durationS = totalYears.toFixed(2) + ' ' + this.$t('pages.employeeCoreData.years');
                }
                if(e.workExperience){
                    workExperienceS = e.workExperience
                }
                if(e.nonEmploymentTime){
                    nonEmploymentTimeS = e.nonEmploymentTime
                }
                
                
                                    
                
                let line = [e.lastName+" "+e.firstName, startDateS, workExperienceS, nonEmploymentTimeS, durationS]

                

                body.push(line);

            })



            let repDoc = this.$helpers.tableReportDoc(
                headers,
                this.$t('pages.employeeContext.employmentDurationOverview') + ' ' + this.$helpers.getMomentTZ().format('MMMM YYYY'),
                this.storeSettings.name,
                this.storeSettings.description,
                this.userFullname,
                7);
            let doc = repDoc.doc;
            let contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);

            doc.autoTable({
                startY: contentOffsetY,
                head: [headers],
                body: body,
                headStyles: {
                fillColor: [109,141,33],
                fontSize: 7,
                },
                bodyStyles: {
                fontSize: 7
                },
                columnStyles: {
                
                }
            })

          this.$helpers.previewPdf(doc, filename);
        },

        documentUploadEnabled(enabled){
            this.hideDocumentsUpload = !enabled;
        },
        OpenDocumentsOptionsPopup($event){
            let view = this;

            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: this.displaymenuState,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        OpenDisplayMenuDetails($event){
            let view = this;
            this.$helpers.OpenPopup({
                type: 'employeedisplayoptions',
                componentState: {
                    showOkEmployee: view.showOkEmployee,
                    toggleShowOkEmployee: () => {
                        view.showOkEmployee = !view.showOkEmployee;
                    },
                    showEmployeeWithInfo: view.showEmployeeWithInfo,
                    toggleShowEmployeeWithInfo: () => {
                        view.showEmployeeWithInfo = !view.showEmployeeWithInfo;
                    },
                    showEmployeeWithWarningOrDanger: view.showEmployeeWithWarningOrDanger,
                    toggleShowEmployeeWithWarningOrDanger: () => {
                        view.showEmployeeWithWarningOrDanger = !view.showEmployeeWithWarningOrDanger;
                    },
                    showActiveEmployees: view.showActiveEmployees,
                    toggleShowActiveEmployees: () => {
                        view.showActiveEmployees = !view.showActiveEmployees;
                    },
                    showInactiveEmployees: view.showInactiveEmployees,
                    toggleShowInactiveEmployees: () => {
                        view.showInactiveEmployees = !view.showInactiveEmployees;
                    }
                },
                listStyle: true,
                noScroll: true,
                pointerDirection: 1,
                elRelative: $event.currentTarget,
                pointerOffset: -14,
            });
        },
        accountInfoRefreshed(account){
            this.useraccount = account;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

.dropdown-search.filters {
    height: 18px !important;
    display: block;
    margin-top: -4px;
    width: 100%;
}
.has-header > .has-header > .scrollbar-container{
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    overflow-x: hidden;
    top: var(--header-height);
    padding: 0px 14px;
}


.btn-success {
  color: #fff;
  background-color: var(--md);
  border-color: var(--md);
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: var(--md);
  border-color: var(--md);
  box-shadow: 0 0 0 0.2rem rgba(61, 79, 18, 0.5);
}

.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: var(--md);
  border-color: rgba(61, 79, 18, 0.5);
}


.btn-outline-success {
  color: var(--md);
  border-color: var(--md);
}
.btn-outline-success:hover {
  color: #fff;
  background-color:var(--md);
  border-color:var(--md);
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(61, 79, 18, 0.5);
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color:var(--md);
  border-color: rgba(61, 79, 18, 0.5);
}

</style>
